/*
 * CHEditor 6
 * Copyright 1997-2026 CHCODE. All rights reserved.
 */

class GB {
    static COLORS = ['#000000', '#333333', '#535353', '#666666', '#999999', '#a0a0a0', '#b5b5b5', '#cccccc', '#dedede', '#eeeeee', '#ffffff', 'rgba(0, 0, 0, 0)',
        '#ff0000', '#ff8000', '#ffff00', '#80ff00', '#00ff00', '#00ff99', '#00ffff', '#0080ff', '#0000ff', '#7f00ff', '#ff00ff', '#ff007f',
        '#ffcccc', '#ffe5cc', '#ffffcc', '#e5ffcc', '#ccffcc', '#ccffe5', '#ccffff', '#cce5ff', '#ccccff', '#e5ccff', '#ffccff', '#ffcce5',
        '#ff9999', '#ffcc99', '#ffff99', '#ccff99', '#99ff99', '#99ffcc', '#99ffff', '#99ccff', '#9999ff', '#cc99ff', '#ff99ff', '#ff99cc',
        '#ff6666', '#ffb266', '#ffff66', '#b2ff66', '#66ff66', '#66ffb2', '#66ffff', '#66b2ff', '#6666ff', '#b266ff', '#ff66ff', '#ff66b2',
        '#ff3333', '#ff9933', '#ffff33', '#99ff33', '#33ff33', '#33ff99', '#33ffff', '#3399ff', '#3333ff', '#9933ff', '#ff33ff', '#ff3399',
        '#cc0000', '#cc6600', '#cccc00', '#66cc00', '#00cc00', '#00cc66', '#00cccc', '#0066cc', '#0000cc', '#6600cc', '#cc00cc', '#cc0066',
        '#990000', '#994c00', '#999900', '#4c9900', '#009900', '#00994c', '#009999', '#004c99', '#000099', '#4c0099', '#990099', '#99004c',
        '#660000', '#663300', '#666600', '#336600', '#006600', '#006633', '#006666', '#003366', '#000066', '#330066', '#660066', '#660033'];

    static TAGS = {
        INLINE: new Set([ "A", "ABBR", "ACRONYM", "B", "BDO", "BIG", "BR", "BUTTON", "CITE", "CODE", "DFN", "EM", "I", "IMG", "INPUT", "KBD", "LABEL", "MAP", "OBJECT", "OUTPUT", "Q", "S", "SAMP", "SCRIPT", "SELECT", "SMALL", "SPAN", "STRONG", "SUB", "SUP", "SVG", "TEMPLATE", "TEXTAREA", "TIME", "TT", "U", "VAR" ]),
        LINE_HEIGHT: new Set([ "ADDRESS", "BLOCKQUOTE", "DIV", "DL", "FIGCAPTION", "H1", "H2", "H3", "H4", "H5", "H6", "LI", "P", "PRE", "SECTION", "TD", "TH", ]),
        INDENT: new Set([ "ADDRESS", "BLOCKQUOTE", "DIV", "FIGURE", "H1", "H2", "H3", "H4", "H5", "H6", "P", "PRE", "TABLE" ]),
        FORMATTING: new Set([ "A", "ACRONYM", "ADDR", "B", "BDO", "BIG", "CITE", "CODE", "DEL", "DFN", "EM", "FONT", "I", "INS", "KBD", "MARK", "Q", "S", "SAMP", "SMALL", "SPAN", "STRIKE", "STRONG", "SUB", "SUP", "TIME", "TT", "U", "VAR" ]),
        FORCE_REMOVE: new Set(["BLOCKQUOTE", "FIGURE", "HR", "TABLE"]),
        REMOVE_BREAK: new Set(["BLOCKQUOTE", "BODY", "DIV", "FIGURE", "LI", "P", "TD"]),
        TABLE: new Set(["TABLE", "THEAD", "TBODY", "TFOOT", "TH", "TR", "TD"]),
        QUICK_INSERT_PARAGRAPH: new Set(["BLOCKQUOTE", "CANVAS", "FIGURE", "HR", "TABLE"]),
        LIST: {
            STARTS: new Set(["DL", "OL", "UL"]),
            ITEMS: new Set(["DD", "DT", "LI"]),
            REPLACE_PARENTS: new Set(["P", "DIV"]),
            VALID_PARENTS: new Set(["ADDRESS", "ARTICLE", "ASIDE", "BLOCKQUOTE", "BLOCKQUOTE", "DD", "DETAILS", "DIALOG", "DIV", "FIELDSET", "FIGURE", "FOOTER", "FORM", "HEADER", "LI", "MAIN", "NAV", "SEARCH", "SECTION", "TD", "TH"]),
            get ENTIRE() { return [...this.STARTS, ...this.ITEMS]; }
        },
        VOID: new Set([ "AREA", "BASE", "BR", "COL", "EMBED", "HR", "IMG", "INPUT", "LINK", "META", "PARAM", "SOURCE", "TRACK", "WBR" ]),
        RAW: new Set(["SCRIPT", "STYLE", "PRE", "TEXTAREA"]),
        PASTE_ALLOWED_TAGS: ["A", "B", "BLOCKQUOTE", "BR", "CODE", "DIV", "EM", "FIGURE", "FIGCAPTION", "H1", "H2", "H3", "H4", "H5", "H6", "HR", "I", "IMG", "LI", "OL", "P", "PICTURE", "PRE", "S", "SPAN", "STRIKE", "STRONG", "SUB", "SUP", "TABLE", "TBODY", "TD", "TH", "THEAD", "TR", "U", "UL"],
        PASTE_ALLOWED_ATTR: ["ALT", "HEIGHT", "HREF", "SRC", "STYLE", "TITLE", "WIDTH"],
    };

    static UI = {
        POPUPS: {
            Emoji: {tmpl: "emoji.html", title: "이모지"},
            ImageUpload: {tmpl: "image.html", title: "이미지 / 동영상"},
            Link: {tmpl: "hyperlink.html", title: "하이퍼링크"},
            Symbol: {tmpl: "symbol.html", title: "기호"},
            Video: {tmpl: "video.html", title: "동영상 링크"},
            CodeEdit: {tmpl: "code.html", title: "소스 편집"},
            Ai: {tmpl: "gemini-ai.html", title: "AI에 물어보기"}
        },
        DROPDOWNS: {
            FONTS: ["맑은 고딕", "돋움", "굴림", "바탕", "궁서체", "Arial", "Comic Sans MS", "Courier New", "Times New Roman", "Sans-serif"],
            FONT_SIZES: [9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72].sort((a, b) => a - b),
            FORMAT_BLOCKS: {P: "기본", H1: "제목 1", H2: "제목 2", H3: "제목 3", H4: "제목 4", PRE: "코드", ADDRESS: "주소"},
            LINE_HEIGHTS: [
                { title: "1.0", value: 1 },
                { title: "1.15", value: 1.15 },
                { title: "1.5", value: 1.5 },
                { title: "2.0", value: 2 },
                { title: "2.5", value: 2.5 },
                { title: "3.0", value: 3 }
            ],
            TEXT_ALIGNMENTS: [
                { align: "left", title: "왼쪽 정렬", execCommand: "JustifyLeft" },
                { align: "center", title: "가운데 정렬", execCommand: "JustifyCenter" },
                { align: "right", title: "오른쪽 정렬", execCommand: "JustifyRight" },
                { align: "justify", title: "양쪽 정렬", execCommand: "JustifyFull" }
            ],
            LIST_STYLES: {
                ordered: [
                    { title: "숫자", type: "decimal" }, { title: "영문 소문자", type: "lower-alpha" },
                    { title: "영문 대문자", type: "upper-alpha" },
                    { title: "로마 소문자", type: "lower-roman"}, { title: "로마 대문자", type: "upper-roman" }
                ],
                unordered: [
                    { title: "동그라미", type: "disc" }, { title: "빈원", type: "circle" }, { title: "사각형", type: "square" }
                ]
            },
            QUOTE_BLOCKS: [
                { menu: "background-color: #f4f5f6;", apply: "background-color: #f4f5f6; border-radius: 0.25rem; overflow: hidden; padding: 0.5em 1em; margin: 1em 0" },
                { menu: "background-color: #e8f9ff;", apply: "background-color: #e8f9ff; border-radius: 0.25rem; overflow: hidden; padding: 0.5em 1em; margin: 1em 0" },
                { menu: "background-color: #fbefff;", apply: "background-color: #fbefff; border-radius: 0.25rem; overflow: hidden; padding: 0.5em 1em; margin: 1em 0" },
                { menu: "background-color: #fef9d9;", apply: "background-color: #fef9d9; border-radius: 0.25rem; overflow: hidden; padding: 0.5em 1em; margin: 1em 0" },
                { menu: "background-color: #dafbe1;", apply: "background-color: #dafbe1; border-radius: 0.25rem; overflow: hidden; padding: 0.5em 1em; margin: 1em 0" },
                { menu: "vertical-bar", apply: "border-left: 5px #dee3ed solid; overflow: hidden; padding: 0.5em 1em 0.5em calc(1em - 5px); margin: 1em 0" }
            ],
            COMMAND_MAP: {
                FontName: "dropdownFontType", FontSize: "dropdownFontSize", ForeColor: "dropdownColor",
                BackColor: "dropdownColor", FormatBlock: "dropdownFormatBlock", QuoteBlock: "dropdownQuoteBlock",
                LineHeight: "dropdownLineHeight", OrderedList: "dropdownOrderedList", UnOrderedList: "dropdownOrderedList",
                Table: "dropdownTable", TextAlign: "dropdownTextAlign"
            }
        }
    };

    static STYLES = {
        DEFAULT_TABLE: {
            rows: 10, cols: 10,
            table: "border: 1px double #b1b7c3; border-collapse: collapse; border-spacing: 0; width: 100%; table-layout: fixed; margin: 0;",
            cell: "border: 1px solid #b1b7c3; padding: 0.3em 0.3em; word-break: break-word; min-width: 2em; background-color: #fff;"
        },
        HR: "height: 0; overflow: visible; border: 0; margin: 1.5rem 0; border-top: 1px solid #dedfdf; box-sizing: content-box",
        FIGURE: {
            css: "margin: 0.7em auto; display: table; clear: both; position: relative; line-height: 0;",
            attrs: [{name: "contenteditable", value: false}],
            alignment: {left: "0.7em 0", center: "0.7em auto", right: "0.7em 0 0.7em auto"},
            alignment_float: {left: "float: left", right: "float: right"},
        },
        IMAGE: "min-width: 100%; max-width: 100%; height: auto; display: block",
        PICTURE: "display: block",
        CAPTION: {
            css: "background-color: #f5f6f7; padding: 0.4em 0.3em; font-size: 14px; line-height: 1.5; color: #5e636e; display: table-caption; caption-side: bottom; word-break: break-word;",
            attrs: [
                {name: "role", value: "textbox"},
                {name: "spellcheck", value: "false"}
            ],
        },
        TEXT_ALIGNMENTS: { JustifyLeft: "left", JustifyCenter: "center", JustifyRight: "right", JustifyFull: "justify" },
        BOGUS_CARET: "position:fixed; top: 0; left: -5000px; width: 100px;",
        PAGE_BREAK: "border: 0; border-top: 1px #999 dotted; page-break-after: always; margin: 20px 0; box-sizing: content-box;",
    };

    static KEY_NAMES = {
        ARROW: new Set(['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight']),
        DELETE: new Set(['Backspace', 'Delete']),
        ALLOW_KEY_UP: new Set(['Backspace', 'Delete', 'Enter'])
    };

    static OS_FONTS = {
        APPLE: ["Apple SD Gothic Neo"]
    };

    static HTML_ENTITY = {
        ESCAPE: { regex: /[&<>"']/g, map: { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' } },
        UNESCAPE: { regex: /&(amp|lt|gt|quot|#34|#39);/g, map: { '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#34;': '"', '&#39;': "'" } }
    };

    static MIME_TYPES = {
        VIDEO: ['webm', 'mp4', 'ogg', '3gpp', 'x-m4v', 'quicktime'].map(s => 'video/' + s),
        IMAGE: ['gif', 'png', 'jpeg', 'webp', 'svg+xml'].map(s => 'image/' + s)
    };

    static SPECIAL_CHARS = {
        ZERO_WIDTH_SPACE: "\u200b",
        ZERO_WIDTH_REGEX: /[\u200b-\u200d\ufeff]+/g,
        ZERO_WIDTH_TRIM_REGEX: /^[\u200b-\u200d\ufeff]+|[\u200b-\u200d\ufeff]+$/g
    };

    static PATHS = { icon: 'icons', css: 'css', popup: 'popup', lib: 'lib', uploadScript: null };
    static COMPARE_POS = { backward: -1, before: 0, after: 1 };
    static SVG_NAMESPACE = "http://www.w3.org/2000/svg";

    static dragWindow = null;
    static colorDropper = null;
    static readyEditor = 0;
    static browser = {};
    static removeZeroWidthSpaceAttr = "remove-zw-space";
    static removeRangeMarkerAttr = "remove";
    static defaultOffsetIncrement = 40;
    static scriptLoadCache = new Map();
    // static UndoManager = (function () {});

    static initialize(browserInfo) {
        GB.browser = browserInfo;
        GB.supportedMimeTypes = [...GB.MIME_TYPES.VIDEO, ...GB.MIME_TYPES.IMAGE];
    }
}

function isUndefined(obj) {
    return obj === void 0; // obj === undefined;
}

function detectBrowser() {
    // 1. User Agent 준비 및 헬퍼 함수 정의
    const ua = (!isUndefined(navigator) ? window.navigator.userAgent : null) || '';
    if (!ua) return {};

    const getFirstMatch = (regex) => {
        const match = ua.match(regex);
        return (match && match.length > 1 && match[1]) || '';
    };

    // 2. 공통 정규식 검사 결과 캐싱 (가독성 향상)
    const iosDevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase();
    const likeAndroid = /like android/i.test(ua);
    const isAndroid = !likeAndroid && /android/i.test(ua);
    const isTablet = /tablet/i.test(ua);
    const isMobile = !isTablet && /[^-]mobi/i.test(ua);
    const versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i);

    let result = {};

    // 3. 브라우저 이름 및 버전 감지
    if (/opera|opr/i.test(ua)) {
        result = {
            name: 'Opera',
            opera: true,
            version: versionIdentifier || getFirstMatch(/(?:opera|opr)[\s/](\d+(\.\d+)?)/i)
        };
    } else if (/windows phone/i.test(ua)) {
        result = {
            name: 'Windows Phone',
            windowsPhone: true,
            msie: true,
            version: getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
        };
    } else if (/msie|trident/i.test(ua)) {
        result = {
            name: 'Internet Explorer',
            msie: true,
            version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
        };
    } else if (/edge/i.test(ua)) {
        result = {
            name: 'edge',
            edge: true,
            version: getFirstMatch(/edge\/(\d+(\.\d+)?)/i)
        };
    } else if (/chrome|crios|crmo/i.test(ua)) {
        result = {
            name: 'Chrome',
            chrome: true,
            version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
        };
    } else if (iosDevice) {
        result = {
            name: (iosDevice === 'iphone' ? 'iPhone' : (iosDevice === 'ipad' ? 'iPad' : 'iPod')),
            version: versionIdentifier || ''
        };
    } else if (/firefox|iceweasel/i.test(ua)) {
        result = {
            name: 'Firefox',
            firefox: true,
            version: getFirstMatch(/(?:firefox|iceweasel)[ /](\d+(\.\d+)?)/i)
        };
        if (/\((mobile|tablet);[^)]*rv:[\d.]+\)/i.test(ua)) result.firefoxos = true;
    } else if (isAndroid) {
        result = { name: 'Android', version: versionIdentifier };
    } else if (/safari/i.test(ua)) {
        result = { name: 'Safari', safari: true, version: versionIdentifier };
    }

    // 4. 엔진 감지 (Webkit/Gecko) 및 후처리
    if (/(apple)?webkit/i.test(ua)) {
        result.name = result.name || 'Webkit';
        result.webkit = true;
        if (!result.version && versionIdentifier) result.version = versionIdentifier;
    } else if (!result.opera && /gecko\//i.test(ua)) {
        result.gecko = true;
        result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i);
        result.name = result.name || 'Gecko';
    }

    // 5. 플랫폼 플래그 설정
    if (isAndroid) {
        result.android = true;
    } else if (iosDevice) {
        result[iosDevice] = true;
        result.ios = true;
    }

    // 6. OS 버전 추출
    let osVersion = '';
    if (iosDevice) {
        osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i).replace(/[_\s]/g, '.');
    } else if (isAndroid) {
        osVersion = getFirstMatch(/android[ /-](\d+(\.\d+)*)/i);
    } else if (result.windowsPhone) {
        osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    }
    if (osVersion) result.osversion = osVersion;

    // 7. 장치 유형 (태블릿/모바일) 판별
    const osMajorVersion = parseInt(osVersion.split('.')[0], 10) || 0;
    if (isTablet || iosDevice === 'ipad' || (isAndroid && (osMajorVersion === 3 || (osMajorVersion === 4 && !isMobile)))) {
        result.tablet = true;
    } else if (isMobile || iosDevice === 'iphone' || iosDevice === 'ipod' || isAndroid) {
        result.mobile = true;
    }

    // 9. OS 이름 결정 및 Windows 버전 매핑
    const osChecks = [
        { regex: /windows/i, name: 'Windows' },
        { regex: /mac/i, name: 'MacOS' },
        { regex: /x11/i, name: 'UNIX' },
        { regex: /linux/i, name: 'Linux' }
    ];
    const matchedOS = osChecks.find(check => check.regex.test(ua));
    result.osname = matchedOS ? matchedOS.name : 'Unknown OS';

    return result;
}

class URI {
    constructor(uri) {
        this.scheme = null;
        this.authority = null;
        this.path = '';
        this.query = null;
        this.fragment = null;

        if (uri) {
            this.parse(uri);
        }
    }

    parse(uri) {
        const m = uri.match(/^(([A-Za-z][0-9A-Za-z+.-]*)(:))?((\/\/)([^/?#]*))?([^?#]*)((\?)([^#]*))?((#)(.*))?/);
        this.scheme = m[3] ? m[2] : null;
        this.authority = m[5] ? m[6] : null;
        this.path = m[7];
        this.query = m[9] ? m[10] : null;
        this.fragment = m[12] ? m[13] : null;
        return this;
    }

    toString() {
        let result = '';
        if (this.scheme !== null) {
            result += this.scheme + ':';
        }
        if (this.authority !== null) {
            result += '//' + this.authority;
        }
        if (this.path !== null) {
            result += this.path;
        }
        if (this.query !== null) {
            result += '?' + this.query;
        }
        if (this.fragment !== null) {
            result += '#' + this.fragment;
        }
        return result;
    }

    static removeDotSegments(path) {
        let result = '';
        let rm;
        while (path) {
            if (path.substring(0, 3) === '../' || path.substring(0, 2) === './') {
                path = path.replace(/^\.+/, '').substring(1);
            } else if (path.substring(0, 3) === '/./' || path === '/.') {
                path = '/' + path.substring(3);
            } else if (path.substring(0, 4) === '/../' || path === '/..') {
                path = '/' + path.substring(4);
                result = result.replace(/\/?[^/]*$/, '');
            } else if (path === '.' || path === '..') {
                path = '';
            } else {
                rm = path.match(/^\/?[^/]*/)[0];
                path = path.substring(rm.length);
                result += rm;
            }
        }
        return result;
    }

    toAbsolute(location) {
        const baseUri = new URI(location);
        const target = new URI();

        if (baseUri.scheme === null) {
            return false;
        }

        // 스킴이 같으면 상속받지 않음 (RFC 3986)
        if (this.scheme !== null && this.scheme.toLowerCase() === baseUri.scheme.toLowerCase()) {
            this.scheme = null;
        }

        if (this.scheme !== null) {
            target.scheme = this.scheme;
            target.authority = this.authority;
            target.path = URI.removeDotSegments(this.path);
            target.query = this.query;
        } else {
            if (this.authority !== null) {
                target.authority = this.authority;
                target.path = URI.removeDotSegments(this.path);
                target.query = this.query;
            } else {
                if (this.path === '') {
                    target.path = baseUri.path;
                    target.query = this.query || baseUri.query;
                } else {
                    if (this.path.startsWith('/')) {
                        target.path = URI.removeDotSegments(this.path);
                    } else {
                        if (baseUri.authority !== null && baseUri.path === '') {
                            target.path = '/' + this.path;
                        } else {
                            target.path = baseUri.path.replace(/[^/]+$/, '') + this.path;
                        }
                        target.path = URI.removeDotSegments(target.path);
                    }
                    target.query = this.query;
                }
                target.authority = baseUri.authority;
            }
            target.scheme = baseUri.scheme;
        }
        target.fragment = this.fragment;
        return target;
    }
}

function setConfig() {
    return {
        allowedOnEvent: false,
        allowPasteImage: true,
        maxPasteImageCount: 5,
        maxVideoFileSize: 1024 * 1024 * 100, // 10M
        colorToHex: true,
        docTitle: '내 문서',
        editAreaMargin: '5px 10px',
        editorBgColor: '#ffffff',
        editorFontSize: '14px',
        editorFontFamily: '"맑은 고딕", "Malgun Gothic", "Helvetica", Arial, sans-serif',
        editorFontColor: '#14141f',
        editorHeight: '300px',
        editorPath: '',
        editorWidth: '100%',
        allowedTags: [],
        allowedAttributes: [],
        blockTags: ['script', 'style', 'iframe'],
        blockAttributes: [],
        fullHTMLSource: false,
        imgJpegQuality: 1,           // JPEG 사진의 퀄리티 값, 최대값 1
        imgMaxWidth: 1024,           // 사진 최대 가로 크기, 이 크기 보다 크면 리사이징 처리, 0으로 설정하면 제한 없음.
        imgResizeMinLimit: 120,      // 사진 리사이징의 사용자 직접 입력 값이 이 값 보다 작으면, 이 값으로 설정
        imgResizeSelected: 800,      // 사진 리사이징의 선택 입력 폼의 기본 선택 값
        imgResizeValue: [240, 320, 640, 800, 1024, -1], // -1 = 사용자 직접 입력
        imgSetAttrAlt: true,
        imgDefaultAlign: 'center',
        imgUploadNumber: 4,
        emojiUnicode: true,          // true = 이모지 유니코드 사용, false = 이모지 이미지 사용
        emojiNativeCode: true,       // true = 이모지 유니코드 문자 사용, false = 이모지 HTML HEX 코드 사용
        includeHostname: true,
        lineHeight: 1.5,
        linkTargetAttr: '_blank',    // 하이퍼링크(A 태그) target 기본 속성
        makeThumbnail: false,        // 사진의 썸네일 이미지 생성, 가로 크기는 thumbnailWidth 값, 세로는 자동 계산
        path: {},
        thumbnailWidth: 240,
        showTagSelector: true,
        showToolbarTooltip: true,
        toolbarSVGIcon: true,
        tabIndent: '  ',
        uploadScript: 'upload-bin/upload.php',
        geminiApiKey: 'AIzaSyAUy-crfjWGo3V5iBwx3IABXeUxvLtb0hI', // 구글 제미나이 API 키
        geminiModel: 'gemini-2.5-flash',

        // 버튼 사용 유무
        useSource: true,
        useBackColor: true,
        useBold: true,
        useClearTag: true,
        useCopy: true,
        useCut: true,
        useEmoji: true,
        useFontName: true,
        useFontSize: true,
        useFontSizeDown: false,
        useFontSizeUp: false,
        useForeColor: true,
        useFormatBlock: true,
        useFullScreen: true,
        useHR: true,
        useImage: true,
        useIndent: true,
        useItalic: true,
        useLineHeight: true,
        useLink: true,
        useAi: true,
        useModifyTable: true,
        useNewDocument: true,
        useOrderedList: true,
        useOutdent: true,
        usePageBreak: true,
        usePrint: true,
        useQuoteBlock: true,
        useRedo: true,
        useRemoveFormat: true,
        useSelectAll: true,
        useStrikethrough: true,
        useSubscript: true,
        useSuperscript: true,
        useSymbol: true,
        useTable: true,
        useTextAlign: true,
        useUnderline: true,
        useUndo: true,
        useUnLink: true,
        useUnOrderedList: true,
        useVideo: true,
    };
}

function cheditorPolyfill() {
    if (typeof Element.prototype.replaceChildren !== 'function') {
        const replaceChildren = function (...children) {
            const { childNodes } = this;
            while (childNodes.length) {
                childNodes[0].remove();
            }
            this.append(...children);
        };
        Document.prototype.replaceChildren = replaceChildren;
        DocumentFragment.prototype.replaceChildren = replaceChildren;
        Element.prototype.replaceChildren = replaceChildren;
    }
}

class CHEditor {
    constructor(config) {
        const toType = (obj) => {
            if (obj === this) {
                return 'global';
            }
            return Object.prototype.toString
                .call(obj)
                .replace(/^.*\s(\w+).*$/, '$1')
                .toLowerCase();
        };

        Object.assign(this, {
            appHost: null,
            appRoot: null,
            appTagName: null,
            api: null,
            browser: detectBrowser(),
            cheditor: { modifyState: false },
            config: setConfig(),
            dropdown: {},
            editarea: null,
            images: [],
            videos: [],
            initEventHandler: false,
            isUndefined: isUndefined,
            inputForm: 'textAreaId',
            keyPressStoredSelections: [],
            modalZIndex: 2001,
            bogusCaret: null,
            elementResizer: null,
            popover: null,
            popper: null,
            range: null,
            storedSelections: [],
            toolbar: {},
            selectionChangeEventTimer: null,
            selectionChangeEventDelay: 100,
            selectionTracking: true,
            toType: toType,
            pointerEvents: {},
            isTouchEvent: 'ontouchstart' in window,
            removeNode: null,
            URI,
        });

        if (this.browser.msie) {
            alert('마이크로소프트 인터넷 익스플로러 브라우저는 지원하지 않습니다.');
            return;
        }

        if (!this.config.editorPath) {
            const baseHref = location.href;
            const editorScript = this.getEditorScript();
            const scriptUri = new URI(editorScript.src);
            const absUri = scriptUri.toAbsolute(baseHref);

            absUri.query = null;
            absUri.fragment = null;

            this.config.editorPath = absUri.toString().replace(/[^/]+$/, '');

            if (!this.config.editorPath) {
                alert("CHEditor 경로가 바르지 않습니다.\n'config.editorPath'를 설정하여 주십시오.");
                return;
            }
        }

        GB.initialize(this.browser);

        this.config.browser = this.browser;
        this.applyEditorConfig(config);

        this.pointerEvents = this.isTouchEvent
            ? { start: 'touchstart', move: 'touchmove', end: 'touchend' }
            : { start: 'mousedown', move: 'mousemove', end: 'mouseup' };

        this.loadEditor().then(async () => {
            this.tmpl = TMPL;
            this.api = new CHEditorApi(this);
            this.cheditor.id = this.isUndefined(GB.readyEditor) ? 1 : GB.readyEditor++;
            this.popper = window['cheditorPopper'];
            await this.run('initEditor');
        });

        cheditorPolyfill();
    }

    async loadEditor() {
        const editorScript = this.getEditorScript();
        const dependencyLibs = this.getEditorDependencyLibs();

        try {
            await this.loadEditorDependencies(dependencyLibs, editorScript);
            return await this.loadScript(
                this.getEditorLibraryUrl(),
                editorScript
            );
        } catch (error) {
            console.error('에디터 실행 중 오류:', error);
            throw error;
        }
    }

    getEditorLibraryUrl() {
        const libraryFileName = this.browser.mobile ? 'lib.mobile.js' : 'lib.js';
        return `${this.config.editorPath}lib/${libraryFileName}`;
    }

    getEditorDependencyLibs() {
        const libraryBasePath = `${this.config.editorPath}lib`;
        return [
            `${libraryBasePath}/dom-offset.min.js`,
            `${libraryBasePath}/dom-purify.min.js`,
        ];
    }

    getEditorScript() {
        const editorScriptSelector = 'script[src*="cheditor.min.js"], script[src*="cheditor.js"]';
        const editorScript = document.querySelector(editorScriptSelector);

        if (!editorScript) {
            throw new Error('기준이 되는 cheditor.js 스크립트를 찾을 수 없습니다.');
        }

        return editorScript;
    }

    async loadEditorDependencies(urls, referenceScript) {
        for (const url of urls) {
            await this.loadScript(url, referenceScript);
        }
    }

    createElement(name) {
        return document.createElement(name);
    }

    loadScript(url, anchorElement) {
        if (GB.scriptLoadCache.has(url)) {
            return GB.scriptLoadCache.get(url);
        }

        const existingScript = document.querySelector(`script[src="${url}"]`);
        if (existingScript) {
            const resolvedPromise = Promise.resolve(existingScript);
            GB.scriptLoadCache.set(url, resolvedPromise);
            return resolvedPromise;
        }

        const loadPromise = new Promise((resolve, reject) => {
            const script = this.createElement('script');
            script.src = url;
            script.onload = () => resolve(script);
            script.onerror = () => {
                GB.scriptLoadCache.delete(url);
                reject(new Error(`스크립트 로드 실패: ${url}`));
            }
            anchorElement.after(script);
        });

        GB.scriptLoadCache.set(url, loadPromise);
        return loadPromise;
    }

    applyEditorConfig(config) {
        if (!config || typeof config !== 'object') return;

        for (const [key, value] of Object.entries(config)) {
            if (Object.hasOwn(this.config, key)) {
                this.config[key] = value;
            }
        }

        this.applyInputFormConfig(config);
    }

    applyInputFormConfig(config) {
        const inputFormConfigKey = 'inputForm';
        if (!Object.hasOwn(config, inputFormConfigKey)) return;
        this.inputForm = config[inputFormConfigKey];
    }

    prependContents(contents) {
        this.updateContents(contents, 'afterbegin', 'firstChild', 'setEndBefore', 'setStartBefore');
    }

    appendContents(contents) {
        this.updateContents(contents, 'beforeend', 'lastChild', 'setStartAfter', 'setEndAfter');
    }

    insertContents(contents) {
        const htmlContents = this.normalizeContents(contents);
        this.insertHtmlAtSelection(htmlContents);
        this.editareaFocus();
    }

    replaceContents(contents) {
        this.loadContents(contents);
    }

    loadContents(contents) {
        this.editareaFocus();
        this.emptyChildren();
        this.body.insertAdjacentHTML('afterbegin', this.validateAndParseContents(contents));
        this.initContentsEvent();
        this.placeCaretAt(this.body.firstChild, true);
    }

    updateContents(contents, insertPosition, referenceChildKey, rangeStartMethod, rangeEndMethod) {
        const body = this.body;
        const rng = this.createRange();
        const refNodeBeforeInsert = body[referenceChildKey];
        const sanitizedHtml = this.validateAndParseContents(contents);

        body.insertAdjacentHTML(insertPosition, sanitizedHtml);

        if (!refNodeBeforeInsert) {
            rng.selectNodeContents(body);
        } else {
            const referenceNodeAfterInsert = body[referenceChildKey];
            rng[rangeStartMethod](refNodeBeforeInsert);
            rng[rangeEndMethod](referenceNodeAfterInsert);
        }

        const sel = this.getSelection();
        sel.empty();
        sel.addRange(rng);

        this.clearHelperNodes();

        const blockAlign = referenceChildKey === "firstChild" ? "start" : "end";
        body.scrollIntoView({ block: blockAlign, behavior: "smooth" });

        this.editareaFocus();
    }

    initContentsEvent() {
        const figs = this.body.querySelectorAll('figure');

        if (figs.length < 1) return;

        figs.forEach((fig) => {
            const tbl = fig.querySelector('table');
            if (tbl) {
                if (!tbl.querySelector('colgroup')) {
                    const len = tbl.rows[0].cells.length;
                    tbl.prepend(this.createTableColumnGroup(len));
                }
                this.createTableEventHandler(tbl);
            }

            const figCap = fig.querySelector('figcaption');
            if (figCap) {
                this.createFigCaptionEventHandler(fig, figCap, this.getSelection());
            }
        });
    }

    normalizeContents(contents) {
        if (typeof contents !== 'string' || this.trimSpace(contents).length === 0) {
            return '';
        }
        contents = this.removeNls(this.trimSpace(contents)).replace(/\s*(<\/)/g, '$1');
        contents = contents.replace(
            /(font-family\s*:\s*)([^>]+)(?=">)/gi,
            (match, prefix, attrs) => {
                attrs += attrs.endsWith(';') ? '' : ';';
                attrs = this.escapeHTML(attrs);
                return `${prefix}${attrs}`;
            }
        );
        return this.domPurify(contents);
    }

    validateAndParseContents(contents) {
        const normalizedHTML = this.normalizeContents(contents);
        const shadow = this.createElement('temp-shadow');

        shadow.insertAdjacentHTML('afterbegin', normalizedHTML);

        if (!shadow.hasChildNodes()) {
            shadow.append(this.createEmptyParagraph());
        } else {
            const walker = this.doc.createTreeWalker(
                shadow,
                NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT,
                null
            );

            let node = walker.nextNode();
            let p = null;

            while (node) {
                const isTextOrInline = node.nodeType === Node.TEXT_NODE ||
                    this.isInlineElement(node.nodeName);

                if (isTextOrInline) {
                    if (!p) {
                        p = this.createElement('p');
                        node.before(p);
                    }
                    p.append(node);
                    walker.currentNode = p;
                } else {
                    p = null;
                }

                node = walker.nextSibling();
            }
        }

        const CONTENTEDITABLE = 'contenteditable';
        const CONTENTEDITABLE_TRUE = 'true';
        const CONTENTEDITABLE_FALSE = 'false';

        const makeFigcaptionEditable = figure => {
            if (!figure.querySelector('img')) {
                return false;
            }
            figure.setAttribute(CONTENTEDITABLE, CONTENTEDITABLE_FALSE);
            const figCaption = figure.querySelector('figcaption');
            if (figCaption) {
                figCaption.setAttribute(CONTENTEDITABLE, CONTENTEDITABLE_TRUE);
                return true;
            }
            return false;
        };

        const makeTableCellsEditable = (figure) => {
            const table = figure.querySelector('table');
            let isEditable = false;

            if (table) {
                const tableCells = table.querySelectorAll('td, th');
                tableCells.forEach(cell => {
                    cell.setAttribute(CONTENTEDITABLE, CONTENTEDITABLE_TRUE);
                    if (!cell.hasAttribute('style')) {
                        cell.setAttribute('style', GB.STYLES.DEFAULT_TABLE.cell);
                    }
                    isEditable = true;
                });

                if (isEditable) {
                    if (!table.hasAttribute('style')) {
                        table.setAttribute('style', GB.STYLES.DEFAULT_TABLE.table);
                    }
                }
            }

            return isEditable;
        };

        const figures = shadow.querySelectorAll('figure');

        figures.forEach((figure) => {
            if (!makeFigcaptionEditable(figure)) {
                makeTableCellsEditable(figure);
            }
        });

        return shadow.getHTML();
    }

    setFolderPath() {
        const TRAILING_SLASH = '/';
        const normalizePath = (path) => path.trim().replace(/\/$/, '');
        const isHttpUrl = (url) => /^https?:\/\//i.test(url);
        const path = this.config.editorPath;
        const basePath = path.endsWith(TRAILING_SLASH) ? path : `${path}${TRAILING_SLASH}`;

        for (let [key, path] of Object.entries(GB.PATHS)) {
            if (key === 'uploadScript') {
                this.config[key] = isHttpUrl(this.config.uploadScript)
                    ? this.config.uploadScript
                    : `${basePath}${this.config.uploadScript}`;
            } else {
                const normalizedPath = normalizePath(path);
                this.config.path[key] = `${basePath}${normalizedPath}`;
            }
        }
    }

    initializeInputForm() {
        const textarea = document.getElementById(this.inputForm);
        if (!textarea) throw `ID가 ${this.inputForm}인 textarea 요소를 찾을 수 없습니다.`;

        textarea.style.display = 'none';
        textarea.style.removeProperty('visibility');

        this.cheditor.inputForm = textarea;
    }

    setDesignMode(designMode = true, doc = this.doc) {
        doc.designMode = designMode ? 'on' : 'off';
    }

    createPopper(reference, popper, options = {}) {
        return this.popper.createPopper(reference, popper, options);
    }

    createDocument() {
        const { docTitle } = this.config;
        const newDocument = document.implementation.createHTMLDocument(docTitle);

        const styleElement = this.createElement('style');
        newDocument.head.append(styleElement);

        const newRootElement = newDocument.documentElement;
        const importedNode = document.importNode(newRootElement, true);

        this.doc.documentElement.replaceWith(importedNode);
        this.body = this.doc.body;
    }

    getWindowHandle(iframe) {
        return iframe.contentWindow;
    }

    createDocumentFragment() {
        return this.doc.createDocumentFragment();
    }

    createCustomElements() {
        const self = this;
        const RANGE_MARKER_ELEMENT_NAME = 'range-marker';
        const TEMP_SHADOW_ELEMENT_NAME = 'temp-shadow';
        const SHADOW_ROOT_MODE = 'open';
        const OBSERVED_CLASS_ATTRIBUTE = 'class';
        const BODY_NODE_NAME = 'BODY';
        const HIDDEN_DISPLAY = 'none';
        const ANCHOR_MARKER_LABEL = 'anchorNode';
        const FOCUS_MARKER_LABEL = 'focusNode';

        class RangeMarker extends HTMLElement {
            static get observedAttributes() {
                return [OBSERVED_CLASS_ATTRIBUTE];
            }
            constructor() {
                super();
                this.attachShadow({ mode: SHADOW_ROOT_MODE }).append('\ufeff');
            }
            connectedCallback() {
                if (this.parentNode.nodeName !== BODY_NODE_NAME) {
                    this.parentNode.normalize();
                }
            }
            adoptedCallback() {
                this.before(GB.SPECIAL_CHARS.ZERO_WIDTH_SPACE);
                this.after(GB.SPECIAL_CHARS.ZERO_WIDTH_SPACE);
            }
            attributeChangedCallback(attrName, oldValue, newValue) {
                if (newValue === GB.removeZeroWidthSpaceAttr) {
                    [this.previousSibling, this.nextSibling].forEach(node => {
                        if (node?.textContent) {
                            node.textContent = node.textContent.replaceAll(GB.SPECIAL_CHARS.ZERO_WIDTH_SPACE, '');
                        }
                    });
                    return;
                }
                if (newValue === GB.removeRangeMarkerAttr) {
                    this.remove();
                }
            }
            create(rng, collapseToStart) {
                const markerEl = self.createElement('span');
                markerEl.style.display = HIDDEN_DISPLAY;
                markerEl.append(collapseToStart ? ANCHOR_MARKER_LABEL : FOCUS_MARKER_LABEL);
                this.shadowRoot.append(markerEl);
                rng.collapse(collapseToStart);
                rng.insertNode(this);
            }
        }

        class TempShadow extends HTMLElement {
            constructor() {
                super();
                this.attachShadow({ mode: SHADOW_ROOT_MODE });
            }
            connectedCallback() {
            }
        }

        this.defineCustomElement(RANGE_MARKER_ELEMENT_NAME, RangeMarker);
        this.defineCustomElement(TEMP_SHADOW_ELEMENT_NAME, TempShadow);
    }

    initCustomElements() {
        this.createCustomElements();
    }

    async resetEditorDocument() {
        const editarea = this.cheditor.editarea;

        if (this.isUndefined(editarea)) {
            return false;
        }

        try {
            this.editarea = this.getWindowHandle(editarea);
            this.doc = editarea.contentDocument;
            this.doc.open();
            this.doc.close();

            await this.documentOpen();
            this.initCustomElements();

            return true;
        } catch (err) {
            console.error("에디터 문서 초기화 실패:", err);
            this.alert(`에디터 문서 초기화 오류: ${err.message}`);
            return false;
        }
    }

    initEditorFocus() {
        this.setEditorVisibility();
        this.editareaFocus();
        this.initBodyContent();
        this.finalizeEditorSetup();
    }

    initBodyContent() {
        if (this.body && this.body.hasChildNodes()) {
            this.placeCaretAt(this.body.childNodes[0], true);
            return;
        }
        this.initDefaultParagraphSeparator();
    }

    finalizeEditorSetup() {
        this.setEditorMode('rich');
    }

    async documentOpen() {
        const openHandler = () => {
            this.createDocument();
            this.setDocumentBodyStyle();
            this.setDesignMode(true);
            this.loadContents(this.cheditor.inputForm.value);
        };

        if (this.doc.readyState !== 'complete') {
            this.doc.open(); this.doc.write('<!DOCTYPE html>'); this.doc.close();
            await new Promise((resolve, reject) => {
                this.addEvent(this.doc, 'readystatechange', evt => {
                    if (evt.target.readyState === 'complete') {
                        this.removeEvent(this.doc, 'readystatechange', evt);
                        resolve('loaded');
                    } else {
                        reject('document initialization error');
                    }
                });
            }).then(result => {
                if (result === 'loaded') {
                    openHandler();
                }
            }).catch(err => {
                console.error(err);
            });
        } else {
            openHandler();
        }
    }

    resetDocumentBody() {
        this.body.replaceWith(this.createElement('body'));
        this.setDocumentBodyAttributes();
    }

    setDocumentBodyAttributes() {
        this.body.setAttribute('spellcheck', 'false');
    }

    setEditorVisibility(visible = true) {
        this.cheditor.container.style.visibility = visible ? 'visible' : 'hidden';
    }

    setEditorMode(mode) {
        this.cheditor.mode = mode;
    }

    generateBodyStyle() {
        return `font-size: ${this.config.editorFontSize};
            line-height: ${this.config.lineHeight};`;
    }

    addStyleRules(sheet, styles) {
        styles.forEach((rule, idx) => sheet.insertRule(rule, idx));
    }

    setDocumentBodyStyle() {
        const sheet = this.doc.styleSheets[0];
        const bodyStyle = this.generateBodyStyle().replace(/\s+/g, ' ');

        this.setDefaultCss({css: 'editarea.css', doc: this.doc});
        this.addStyleRules(sheet, [
            `body, table {${bodyStyle}}`,
            `br.is-bogus {visibility: hidden}`,
            `.is-bogus-caret {${GB.STYLES.BOGUS_CARET}}`
        ]);

        if (this.browser.osname.toLowerCase() === 'macos') {
            this.body.classList.add('macos');
            if (GB.readyEditor === 1) {
                GB.UI.DROPDOWNS.FONTS.unshift(...GB.OS_FONTS.APPLE);
            }
        }

        this.setDefaultParagraphSeparator();
        this.setDocumentBodyAttributes();
    }

    initDefaultParagraphSeparator() {
        const para = this.createEmptyParagraph();
        if (this.body.firstChild?.nodeName === 'BR') {
            this.body.firstChild.remove();
        }
        if (!this.body.hasChildNodes()) {
            this.body.appendChild(para);
            this.placeCaretAt(para, true);
        }
    }

    createHTMLDocument(title) {
        return this.doc.implementation.createHTMLDocument(title || this.config.docTitle);
    }

    async processPasteImageItem(file, bogusWindow) {
        const maxImageWidth = this.config.imgMaxWidth;
        const createAndDecodeImage = async (file) => {
            const URL = window.URL || window.webkitURL;
            const img = new Image();
            img.src = URL.createObjectURL(file);
            await img.decode();
            URL.revokeObjectURL(img.src);
            return img;
        };
        const calculateResizedDimensions = (width, height) => {
            if (width > maxImageWidth) {
                const newWidth = maxImageWidth;
                const newHeight = Math.round(height * (newWidth / width));
                return { width: newWidth, height: newHeight };
            }
            return { width, height };
        };

        const img = await createAndDecodeImage(file);
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);

        reader.onload = () => {
            const { width, height } = calculateResizedDimensions(img.width, img.height);
            const sendMessage = {
                type: 'file',
                value: {
                    bitmap: reader.result,
                    type: file.type,
                    name: file.name,
                    width,
                    height,
                }
            };
            this.postMessage(bogusWindow, sendMessage);
        };
    }

    handlePaste(evt) {
        this.stopEvent(evt);

        const dataTransfer = evt.clipboardData || window.clipboardData;
        if (!dataTransfer) return;

        const items = Array.from(dataTransfer.items || []);

        const htmlItems = items.filter(item => item.kind === 'string' && (item.type === 'text/html' || item.type === 'text/plain'));
        if (htmlItems.length > 0) {
            this.handleNonFilePaste(dataTransfer);
            return;
        }

        const fileItems = items.filter(item => item.kind === 'file');
        if (fileItems.length > 0) {
            this.handleFilePaste(dataTransfer);
        }
    }

    handleFilePaste(dataTransfer) {
        const SUPPORTED_IMAGE_TYPES = ['png', 'jpeg', 'gif', 'webp'];
        const MIME_TYPE_IMAGE = 'image';
        const existingBogusWindow = this.doc.getElementById('bogus-window');

        if (existingBogusWindow) existingBogusWindow.remove();

        let items = [];
        const images = [];
        const bogusWindow = this.addBogusWindow();

        const insertDataHandler = (evt) => {
            const data = evt.data.value;
            if (data) {
                images.push(data);
                if (!items.length) {
                    this.doInsertImage({ images });
                    this.cleanUpBogusWindow(bogusWindow, insertDataHandler);
                    return;
                }
                void this.processPasteImageItem(items.shift(), bogusWindow);
            } else {
                this.cleanUpBogusWindow(bogusWindow, insertDataHandler);
            }
        };

        this.addEvent(this.editarea, 'message', insertDataHandler);

        for (const item of dataTransfer.items) {
            const [type, subtype] = item.type.split('/');
            if (type === MIME_TYPE_IMAGE && SUPPORTED_IMAGE_TYPES.includes(subtype)) {
                if (items.length >= this.config.maxPasteImageCount) break;
                items.push(item.getAsFile());
            }
        }

        this.addEvent(bogusWindow, 'load', () => {
            if (items.length) {
                this.postMessage(bogusWindow, { type: 'init', value: this.config });
                void this.processPasteImageItem(items.shift(), bogusWindow);
            }
        });
    }

    handleNonFilePaste(dataTransfer) {
        const HTML_CONTENT_TYPE = 'text/html';
        const PLAIN_CONTENT_TYPE = 'text/plain';
        const contentType = dataTransfer.types.includes(HTML_CONTENT_TYPE)
            ? HTML_CONTENT_TYPE
            : PLAIN_CONTENT_TYPE;

        const data = dataTransfer.getData(contentType);
        if (data) {
            this.getPasteFragment(data, contentType);
        }
    }

    addBogusWindow() {
        const bogusWindow = this.createElement('iframe');
        bogusWindow.style.display = 'none';
        bogusWindow.id = 'bogus-window';
        bogusWindow.src = `${this.config.path.popup}/paste-image.html`;
        this.body.append(bogusWindow);
        return bogusWindow;
    }

    cleanUpBogusWindow(bogusWindow, handler) {
        bogusWindow.remove();
        this.removeEvent(this.editarea, 'message', handler);
    }

    sanitizePasteFragment(root, mso) {
        const LIST_TYPES_BY_LEVEL = {
                1: 'decimal',
                2: 'upper-alpha',
                3: 'lower-alpha',
                4: 'upper-roman',
                5: 'lower-roman',
                6: 'upper-alpha',
                7: 'upper-roman',
                8: 'lower-roman',
                9: 'disc',
                10: 'circle'
            },
            DEFAULT_LIST_STYLE = 'square',
            ORDERED_LIST_TAG = 'ol',
            LIST_ITEM_TAG = 'li',
            MSO_LIST_NODE_NAMES = new Set(['P', 'LI', 'DIV']),
            DIV_WRAPPER_PARENT_NAMES = new Set(['TEMP-SHADOW', 'P']),
            RESTORABLE_STYLE_NAMES = new Set([
                'font-weight',
                'font-style',
                'color',
                'background-color',
                'width'
            ]),
            SINGLE_TAGS = new Set(['BR', 'HR']),
            IGNORED_STYLE_VALUES = new Set(['initial', 'inherit']),
            walker = this.doc.createTreeWalker(
                root,
                NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT,
                {
                    acceptNode() {
                        return NodeFilter.FILTER_ACCEPT;
                    }
                }
            ),
            getListType = level => LIST_TYPES_BY_LEVEL[level] || DEFAULT_LIST_STYLE,
            getListIndex = level => level === 1 ? 0 : level - 1,
            isRemovableSpan = node => node?.nodeName === 'SPAN' && !node.hasAttributes();

        let curNode,
            prevLiItems = [],
            prevLiLevel = 0;

        if (mso) {
            RESTORABLE_STYLE_NAMES.add('font-family');
        }

        const extractMsoListLevel = node => {
            const styles = node.getAttribute('style')?.split(';');

            if (!styles) {
                return 0;
            }

            node.removeAttribute('style');

            for (const style of styles) {
                const [name, val = ''] = style.split(':');
                if (name === 'mso-list') {
                    const match = val.match(/level(\d+)/);
                    if (match) {
                        return Number(match[1]);
                    }
                }
            }

            return 0;
        };

        const appendMissingParentLists = (li, idx) => {
            let omittedLi = null;

            for (let i = 0; i < idx; i++) {
                omittedLi = this.createElement(ORDERED_LIST_TAG);

                const omittedItem = this.createElement(LIST_ITEM_TAG);
                omittedItem.style.listStyleType = 'none';

                omittedLi.append(omittedItem);
                omittedLi.style.listStyleType = getListType(i + 1);

                if (i === 0) {
                    li.before(omittedLi);
                } else {
                    prevLiItems[i - 1].append(omittedLi);
                }

                prevLiItems[i] = omittedItem;
            }

            if (omittedLi) {
                omittedLi.append(li);
            }
        };

        const moveNodeChildrenBeforeNode = node => {
            while (node.firstChild) {
                node.before(node.firstChild);
            }
        };

        const convertNodeToListItem = (node, liLevel) => {
            const li = this.createElement(LIST_ITEM_TAG);
            const idx = getListIndex(liLevel);

            if (prevLiLevel < liLevel) {
                const liEl = this.createElement(ORDERED_LIST_TAG);

                liEl.append(li);
                node.before(liEl);
                li.append(node);

                if (idx > 0 && prevLiItems[idx - 1]) {
                    prevLiItems[idx - 1].append(liEl);
                } else {
                    appendMissingParentLists(liEl, idx);
                }

                liEl.style.listStyleType = getListType(liLevel);
                prevLiItems[idx] = li;
            } else if (prevLiItems[idx]) {
                li.append(node);
                prevLiItems[idx].append(li);
                prevLiItems[idx] = li;
            } else {
                const liEl = this.createElement(ORDERED_LIST_TAG);

                liEl.style.listStyleType = getListType(liLevel);
                liEl.append(li);
                node.before(liEl);
                li.append(node);
                prevLiItems[idx] = liEl;
            }

            prevLiLevel = liLevel;
            moveNodeChildrenBeforeNode(node);
        };

        const sanitizeMsoListNode = node => {
            if (!MSO_LIST_NODE_NAMES.has(node.nodeName)) {
                return false;
            }

            const styleSnapshots = collectElementStyleSnapshots(node);
            const level = extractMsoListLevel(node);

            if (level > 0) {
                convertNodeToListItem(node, level);
            } else {
                prevLiItems = [];
                prevLiLevel = 0;
            }

            styleSnapshots.forEach((css, targetNode) => {
                sanitizeNodeAttributesAndStyles(targetNode, css);
            });

            removeAttributeLessSpansFromNodes(styleSnapshots.keys());
            node?.normalize();

            return true;
        };

        const unwrapInitialBlockquote = node => {
            if (node?.nodeName !== 'BLOCKQUOTE') {
                return node;
            }

            const firstChild = node.firstChild;
            node.before(firstChild);
            node.remove();
            walker.currentNode = firstChild;

            return firstChild;
        };

        const removeCommentNode = node => {
            walker.previousNode();
            node.remove();

            return walker.currentNode;
        };

        const flattenNestedSingleDiv = node => {
            while (node.childNodes.length === 1 && node.firstChild.nodeName === 'DIV') {
                const childDiv = node.firstChild;

                node.before(childDiv);
                node.remove();
                node = childDiv;
                walker.currentNode = node;
            }

            return node;
        };

        const replaceWrappedDivWithParagraph = node => {
            if (!DIV_WRAPPER_PARENT_NAMES.has(node.parentNode.nodeName)) {
                return node;
            }

            const rng = this.doc.createRange();
            const p = this.createElement('p');

            rng.selectNodeContents(node);
            p.append(rng.extractContents());
            node.before(p);
            node.remove();
            walker.currentNode = p;

            return p;
        };

        const sanitizeDivNode = node => {
            node = flattenNestedSingleDiv(node);
            return replaceWrappedDivWithParagraph(node);
        };

        const restoreStyle = (node, attr) => {
            if (node.nodeName === 'IMG') {
                if (attr.name === 'width' || attr.name === 'height') {
                    node.style[attr.name] = attr.value;
                } else {
                    node.style.removeProperty(attr.name);
                }
                return;
            }

            switch (attr.name) {
                case 'font-size': {
                    const fontSize = this.convertToPx(attr.value);
                    if (fontSize) {
                        node.style[attr.name] = fontSize;
                    }
                    break;
                }
                default:
                    if (RESTORABLE_STYLE_NAMES.has(attr.name) && !IGNORED_STYLE_VALUES.has(attr.value)) {
                        node.style[attr.name] = attr.value;
                    } else {
                        node.style.removeProperty(attr.name);
                    }
            }
        };

        const sanitizeNodeAttributesAndStyles = (node, css = this.cssProperties(node)) => {
            if (css) {
                css.forEach(attr => restoreStyle(node, attr));
            }
        };

        const collectElementStyleSnapshots = rootNode => {
            const snapshots = new Map();

            if (!rootNode) {
                return snapshots;
            }

            snapshots.set(rootNode, this.cssProperties(rootNode));

            rootNode.querySelectorAll?.('*').forEach(childNode => {
                snapshots.set(childNode, this.cssProperties(childNode));
            });

            return snapshots;
        };

        const getNextNodeAfterSubtree = node => {
            walker.currentNode = node;

            let nextNode = walker.nextSibling();

            while (!nextNode) {
                const parentNode = walker.parentNode();

                if (!parentNode || parentNode === root) {
                    return null;
                }

                nextNode = walker.nextSibling();
            }

            return nextNode;
        };

        const sanitizeNodeTreeAttributesAndStyles = rootNode => {
            const nextNode = getNextNodeAfterSubtree(rootNode);
            const styleSnapshots = collectElementStyleSnapshots(rootNode);

            styleSnapshots.forEach((css, node) => {
                sanitizeNodeAttributesAndStyles(node, css);
            });

            removeAttributeLessSpans(rootNode);
            rootNode?.normalize();

            return nextNode;
        };

        const unwrapSpanNode = node => node.replaceWith(...node.childNodes);
        const removeAttributeLessSpansFromNodes = nodes => {
            [...nodes]
                .filter(isRemovableSpan)
                .sort((a, b) => {
                    if (a.contains(b)) return 1;
                    if (b.contains(a)) return -1;
                    return 0;
                })
                .forEach(unwrapSpanNode);
        };

        const removeAttributeLessSpans = rootNode => {
            const nodes = [...rootNode.querySelectorAll?.('span') || []];

            if (rootNode.nodeName === 'SPAN') {
                nodes.push(rootNode);
            }

            removeAttributeLessSpansFromNodes(nodes);
        };

        curNode = unwrapInitialBlockquote(walker.nextNode());

        while (curNode) {
            if (curNode.nodeType === Node.COMMENT_NODE) {
                curNode = removeCommentNode(curNode);
            } else if (SINGLE_TAGS.has(curNode.nodeName) && curNode.hasAttributes()) {
                const nextNode = walker.nextNode();
                curNode.replaceWith(this.createElement(curNode.nodeName));
                curNode = nextNode;
            } else {
                const handledByMsoLi = mso && sanitizeMsoListNode(curNode);

                if (!handledByMsoLi && curNode.nodeName === 'DIV') {
                    curNode = sanitizeDivNode(curNode);
                }

                curNode = sanitizeNodeTreeAttributesAndStyles(curNode);
            }
        }
    }

    getPasteFragment(content, contentType) {
        if (contentType === 'text/plain') {
            const trimmed = content.trim();
            if (!trimmed) return;

            const lines = trimmed.split(/\r?\n|\r/);
            const clip = this.createElement('temp-shadow');

            lines.forEach(line => {
                const p = this.createEmptyParagraph();

                if (line.length > 0) {
                    p.textContent = line;
                }

                clip.append(p);
            });

            this.queryCommand('insertHTML', this.getInnerHTML(clip));
            return;
        }

        const START_FRAGMENT_TAG = '<!--StartFragment-->';
        const END_FRAGMENT_TAG = '<!--EndFragment-->';
        let startPos = content.indexOf(START_FRAGMENT_TAG);
        let endPos = content.indexOf(END_FRAGMENT_TAG);

        startPos = startPos === -1 ? 0 : startPos + START_FRAGMENT_TAG.length;
        endPos = endPos === -1 ? content.length : endPos;

        content = content.substring(startPos, endPos)
            .trim()
            .replace(/<!(--)?\[if\s(![^\]]+?)](--)?>([\s\S]*?)<!(--)?\[endif](--)?>/igm, '')
            .replace(/<\/?[a-z]+?:[^>]*>/g, '');

        if (content.length === 0) {
            return;
        }

        const cleanHtml = this.domPurify(content, {
            ALLOWED_TAGS: GB.TAGS.PASTE_ALLOWED_TAGS,
            ALLOWED_ATTR: GB.TAGS.PASTE_ALLOWED_ATTR,
            ALLOW_DATA_ATTR: false,
            ALLOW_UNKNOWN_PROTOCOLS: true,
            ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
            WHOLE_DOCUMENT: false
        });

        const mso = ['schemas-microsoft-com:office', 'mso-list:']
            .some(marker => cleanHtml.includes(marker));

        const clip = this.createElement('temp-shadow');
        clip.insertAdjacentHTML('afterbegin', cleanHtml);

        let hasFigcaptionNodes = false;

        if (clip.hasChildNodes()) {
            clip.querySelectorAll('figure').forEach(el => {
                const img = el.querySelector('img');
                if (img && img.src) {
                    const w = img.getAttribute('width') || 'auto';
                    const h = img.getAttribute('height') || 'auto';
                    const info = {
                        images: [{fileUrl: img.src, width: w, height: h, alt: ''}]
                    };
                    const shadow = this.processImage(info);
                    if (shadow) {
                        const fig = shadow.firstChild;
                        if (el.querySelector('figcaption')) {
                            const figCapEl = this.createFigCaptionElement();
                            figCapEl.append(el.querySelector('figcaption').textContent.trim());
                            fig.append(figCapEl);
                            hasFigcaptionNodes = true;
                        }
                        el.before(fig);
                    }
                    el.remove();
                }
            });

            this.sanitizePasteFragment(clip, mso);

            clip.querySelectorAll('*').forEach(el => {
                const tagName = `</${el.tagName}>`;
                if (el.outerHTML.slice(-tagName.length).toUpperCase() === tagName && !el.hasChildNodes()) {
                    el.remove();
                }
            });
            console.log(this.removeEmptyTags(this.getInnerHTML(clip)));

            this.queryCommand('insertHTML', this.removeEmptyTags(this.getInnerHTML(clip)));

            if (hasFigcaptionNodes) {
                const nodes = this.doc.querySelectorAll('figure figcaption');
                nodes.forEach(node => {
                    if (!node.hasAttribute('contenteditable')) {
                        node.setAttribute('contenteditable', 'true');
                        this.createFigCaptionEventHandler(node.closest('figure'), node, this.getSelection());
                    }
                });
            }
        }
    }

    editareaFocus() {
        if (!this.doc.hasFocus()) {
            this.editarea.focus();
        }
    }

    getPageY(evt) {
        return this.isTouchEvent ? evt.touches[0].pageY : evt.pageY;
    }

    getPageX(evt) {
        return this.isTouchEvent ? evt.touches[0].pageX : evt.pageX;
    }

    createResizingBackdrop() {
        const backdrop = this.createElement('div');
        backdrop.className = 'modal-backdrop';
        backdrop.style.cursor = 'ns-resize';
        return backdrop;
    }

    editareaResizeStart(evt) {
        const editWrapper = this.cheditor.editWrapper;
        const initialHeight = parseInt(editWrapper.style.height, 10) || 0;
        const initialMouseY = this.getPageY(evt);

        this.stopEvent(evt);
        const backdrop = this.createResizingBackdrop();
        this.appRoot.append(backdrop);

        const onMouseMove = (moveEvent) => {
            const deltaY = this.getPageY(moveEvent) - initialMouseY;
            const newHeight = initialHeight + deltaY;

            if (newHeight >= 1) {
                const height = `${newHeight}px`;
                editWrapper.style.height = height;
                this.config.editorHeight = height;
            } else {
                this.stopEvent(moveEvent);
            }
        };

        const onMouseUp = (upEvent) => {
            this.stopEvent(upEvent);
            this.removeEvent(document, this.pointerEvents.move, onMouseMove);
            this.removeEvent(document, this.pointerEvents.end, onMouseUp);
            backdrop.remove();
            this.editareaFocus();
        };

        this.addEvent(document, this.pointerEvents.move, onMouseMove);
        this.addEvent(document, this.pointerEvents.end, onMouseUp);
    }

    toolbarDropdownChecked(button, checked) {
        button.checked = checked;
        button.elem.classList.toggle('checked', checked);
    }

    toolbarTextAlignChecked(button, currentElement) {
        const svgIcon = button.elem.querySelector('use');
        let currentAlign = window.getComputedStyle(currentElement).textAlign;

        if (currentAlign === 'start') {
            currentAlign = 'left';
        }

        svgIcon.setAttribute('href', svgIcon.getAttribute('href')
            .replace(/left|right|center|justify/, currentAlign));
    }

    toolbarButtonChecked(button, active) {
        button.checked = active;
        button.elem.classList.toggle('active', active);
    }

    toolbarSetDisabled(button, disabled) {
        button.elem.classList.toggle('disabled', disabled);
        this.toolbar[button.name].disabled = disabled;
        return disabled;
    }

    colorConvert(color, which, opacity) {
        const colorDefs = [
            {
                re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
                process : function (bits) {
                    return [
                        parseInt(bits[1], 10),
                        parseInt(bits[2], 10),
                        parseInt(bits[3], 10),
                        1
                    ];
                }
            }, {
                re : /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*(\d+(?:\.\d+)?|\.\d+)\s*\)/,
                process : function (bits) {
                    return [
                        parseInt(bits[1], 10),
                        parseInt(bits[2], 10),
                        parseInt(bits[3], 10),
                        parseFloat(bits[4])
                    ];
                }
            }, {
                re: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
                process : function (bits) {
                    return [
                        parseInt(bits[1], 16),
                        parseInt(bits[2], 16),
                        parseInt(bits[3], 16),
                        1
                    ];
                }
            }, {
                re: /^([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])$/,
                process : function (bits) {
                    return [
                        parseInt((bits[1] * 2).toString(), 16),
                        parseInt((bits[2] * 2).toString(), 16),
                        parseInt((bits[3] * 2).toString(), 16),
                        1
                    ];
                }
            }
        ];
        let r = null, g = null, b = null, a = null,
            i, re, processor, bits, channels, min, result = null;

        if (!which) {
            which = 'rgba';
        }

        color = color.replace(/^\s*#|\s*$/g, '');
        if (color.length === 3) {
            color = color.replace(/(.)/g, '$1$1');
        }

        color = color.toLowerCase();
        which = which.toLowerCase();

        for (i = 0; i < colorDefs.length; i++) {
            re = colorDefs[i].re;
            processor = colorDefs[i].process;
            bits = re.exec(color);
            if (bits) {
                channels = processor(bits);
                r = channels[0];
                g = channels[1];
                b = channels[2];
                a = channels[3];
            }
        }

        r = r < 0 || isNaN(r) ? 0 : r > 255 ? 255 : r;
        g = g < 0 || isNaN(g) ? 0 : g > 255 ? 255 : g;
        b = b < 0 || isNaN(b) ? 0 : b > 255 ? 255 : b;
        a = a < 0 || isNaN(a) ? 0 : a > 1 ? 1 : a;

        function hex(x) {
            return ('0' + parseInt(x, 10).toString(16)).slice(-2);
        }

        switch (which) {
            case 'rgba':
                if (opacity) {
                    a = (255 - (min = Math.min(r, g, b))) / 255;
                    r = ((r - min) / a).toFixed(0);
                    g = ((g - min) / a).toFixed(0);
                    b = ((b - min) / a).toFixed(0);
                    a = a.toFixed(4);
                }
                result = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
                break;
            case 'rgb':
                result = 'rgb(' + r + ',' + g + ',' + b + ')';
                break;
            case 'hex':
                if (isNaN(parseInt(r, 10)) || isNaN(parseInt(g, 10)) || isNaN(parseInt(b, 10))) {
                    return color;
                }
                result = '#' + hex(r) + hex(g) + hex(b);
                break;
        }
        return result;
    }

    setToolbarDropdownValue(button, aCommandName, aValue) {
        const wrapper = button.elem;

        if (aCommandName === 'FontName') {
            const idx = aValue.indexOf(',');
            if (idx !== -1) {
                aValue = aValue.substring(0, idx);
            }
            aValue = aValue.replace(/['"]/g, '');
        } else if (aCommandName === 'FontSize') {
            aValue = aValue.replace(/[^\d.]+/g, '');
        }

        const textSpan = wrapper.querySelector('.menu-item .menu-item-text');
        if (textSpan) {
            textSpan.textContent = aValue;
        }
        button.data = aValue;
    }

    getQueryCommandValue(currElem, aCommandName) {
        const attrs = {
            FontSize: { name: 'font-size', default: this.config.editorFontSize },
            FontName: { name: 'font-family', default: this.config.editorFontFamily },
            LineHeight: { name: 'line-height', default: this.config.lineHeight},
            BackColor: { name: 'background-color', default: this.config.editorBgColor},
            ForeColor: { name: 'color', default: this.config.editorFontColor},
        };
        const attr = attrs[aCommandName];
        let styleValue;

        if ((aCommandName === 'ForeColor' || aCommandName === 'BackColor')) {
            styleValue = this.doc.queryCommandValue(aCommandName);
            if (styleValue.startsWith('rgba')) {
                styleValue = attr.default;
            }
        } else {
            styleValue = this.getComputedStyleValue(currElem, attr.name) || attr.default;
        }

        return styleValue;
    }

    isFormatBlockTagName(currElem) {
        let blockTags = Object.keys(GB.UI.DROPDOWNS.FORMAT_BLOCKS).toString();
        return currElem.closest(blockTags)?.tagName || '기본';
    }

    isUnlinkEnable(currElem) {
        return currElem.closest('a');
    }

    updateToolbarListButtonState(tbButton, rangeElem, listType) {
        const isListActive = rangeElem.closest('li')?.parentNode.nodeName === listType;
        this.toolbarButtonChecked(tbButton, isListActive);
    }

    updateToolbar(evt, targetElement = null) {
        let bNoOff = { 'Link': 1 },
            curEl,
            el,
            fontAttr,
            isControl = false,
            isIgnore,
            isTable = false,
            liItem,
            rngEl,
            // ancestorsLength = 0,
            // shouldDisable,
            state;
        const rng = this.getRange();
        const sel = this.getSelection();

        rngEl = this.getRangeElement(rng);
        curEl = targetElement || rngEl;
        isIgnore = !this.isElementNode(curEl) || curEl.classList.contains('table-col-resizer');

        if (isIgnore) {
            return;
        }

        const isBogusCaret = this.hasBogusCaret();
        const tagName = rngEl.tagName;
        const isCollapsed = rng.collapsed;

        if (!isCollapsed) {
            isControl = ['IMG', 'TABLE', 'BLOCKQUOTE', 'HR'].includes(tagName);
        } else {
            el = curEl;
            while (el && !this.isBody(el)) {
                // ancestors.push(elem);
                if (GB.TAGS.TABLE.has(el.tagName)) {
                    isTable = true;
                }
                el = el.parentElement;
            }
            // ancestorsLength = ancestors.length;
        }

        if (!isTable && GB.TAGS.TABLE.has(curEl.tagName)) {
            isTable = true;
        }

        Object.entries(this.toolbar).forEach(([tbName, tbButton]) => {
            if (typeof tbButton !== 'object' || !tbButton.action) {
                return;
            }
            if (isBogusCaret && isBogusCaret.hasCaret) {
                this.toolbarSetDisabled(tbButton, true);
                this.toolbarButtonChecked(tbButton, false);
                return;
            }

            let autoOff = false;

            if (isBogusCaret && isBogusCaret.figcaption) {
                autoOff = !['Color', 'Format', 'Alignment', 'InsertSymbol'].includes(tbButton.group);
                this.toolbarSetDisabled(tbButton, autoOff);
            } else {
                switch (tbName) {
                    case 'Indent':
                        liItem = rngEl.tagName !== 'LI' ? rngEl.closest('li') : rngEl;
                        autoOff = liItem && !liItem.previousElementSibling;
                        break;
                    case 'ModifyTable':
                        autoOff = !isTable;
                        break;
                }
            }

            if (isControl) {
                const isNotAlignmentGroup = tbButton.group !== 'Alignment';
                autoOff = isNotAlignmentGroup &&
                    !(curEl.tagName === 'IMG' && bNoOff[tbButton.action]);
            }

            this.toolbarSetDisabled(tbButton, autoOff);
            tbButton.data = null;

            const command = tbButton.argv;
            switch (command) {
                case 'TextAlign':
                    this.toolbarTextAlignChecked(tbButton, curEl);
                    break;
                case 'QuoteBlock':
                    el = rngEl.closest('blockquote');
                    this.toolbarDropdownChecked(tbButton, !!el);
                    tbButton.data = el;
                    break;
                case 'Copy': case 'Cut': case 'RemoveFormat':
                    this.toolbarSetDisabled(tbButton, isCollapsed);
                    break;
                case 'UnLink':
                    this.toolbarSetDisabled(tbButton, !this.isUnlinkEnable(rngEl));
                    break;
                case 'FormatBlock':
                    this.setToolbarDropdownValue(tbButton, command, this.isFormatBlockTagName(curEl));
                    break;
                case 'ForeColor': case 'BackColor':
                    fontAttr = this.getQueryCommandValue(curEl, command);
                    if (!fontAttr.startsWith('rgb') && !fontAttr.startsWith('#')) {
                        fontAttr = ((fontAttr & 0x0000ff) << 16 | fontAttr & 0x00ff00 | (fontAttr & 0xff0000) >>> 16).toString(16);
                        fontAttr = '#000000'.slice(0, 7 - fontAttr.length) + fontAttr;
                    }
                    tbButton.icon.lastElementChild.style.backgroundColor = fontAttr;
                    break;
                case 'FontName': case 'FontSize':
                    this.setToolbarDropdownValue(tbButton, command, this.getQueryCommandValue(curEl, command));
                    break;
                case 'LineHeight':
                    el = this.findClosestBlockElement(curEl);
                    tbButton.data = String(el?.style.lineHeight || this.config.lineHeight);
                    break;
                case 'InsertOrderedList':
                    this.updateToolbarListButtonState(tbButton, rngEl, 'OL');
                    break;
                case 'InsertUnOrderedList':
                    this.updateToolbarListButtonState(tbButton, rngEl, 'UL');
                    break;
                default:
                    if (!this.doc.queryCommandSupported(command)) {
                        return;
                    }
                    state = this.doc.queryCommandState(command);
                    if (state === null) {
                        return;
                    }
                    this.toolbarButtonChecked(tbButton, state);
            }
        });

        if (this.config.showTagSelector) {
            this.outputTagSelector(curEl);
        }
    }

    setSvgIconAttributes(svgIcon, iconSize = "0") {
        const svgAttributes = {
            "aria-hidden": "true",
            focusable: "false",
            width: iconSize,
            height: iconSize,
        };

        Object.entries(svgAttributes).forEach(([name, value]) => {
            svgIcon.setAttribute(name, value);
        });
    }

    createSvgIcon(svgContent, className = null) {
        const TOOLBAR_ICON_CLASS = className || "toolbar-svg-icon";

        const svg = document.createElementNS(GB.SVG_NAMESPACE, "svg");
        svg.classList.add(TOOLBAR_ICON_CLASS);

        const use = document.createElementNS(GB.SVG_NAMESPACE, "use");
        use.setAttribute("href", svgContent);

        svg.appendChild(use);
        this.setSvgIconAttributes(svg);

        return svg;
    }

    setupMenuItemIcon(elem, menuText) {
        const menuTextSpan = this.createElement("span");
        menuTextSpan.className = "menu-item-text";

        if (menuText) {
            menuTextSpan.textContent = menuText;
            elem.append(menuTextSpan);
        }

        const icon = this.createSvgIcon("#chevron-down", "chevron-down");
        elem.append(icon);

        return menuTextSpan;
    }

    createToolbarButton(prop) {
        const icon = this.createToolbarButtonIcon(prop);
        if (!icon) return;

        const elem = this.createElement("div");
        elem.setAttribute("aria-label", prop.name);
        elem.setAttribute("role", "button");
        elem.dataset.name = prop.name;
        elem.className = prop.class;
        elem.appendChild(icon);

        const button = this.createToolbarButtonState(prop, elem, icon);
        this.setupToolbarMenuItem(button, prop);
        this.toolbar[prop.name] = button;

        return button;
    }

    createToolbarButtonIcon(prop) {
        const DROPDOWN_ACTION = "showDropdown";
        const MENU_ITEM_CLASS = "menu-item";
        const ICON_CLASS = "icon";

        const svgIcon = prop.svg ? this.createSvgIcon(prop.svg) : null;

        if (prop.action === DROPDOWN_ACTION) {
            const dropdownContainer = this.createElement("div");
            dropdownContainer.className = MENU_ITEM_CLASS;
            if (svgIcon) {
                dropdownContainer.append(svgIcon);
            }
            return dropdownContainer;
        }

        if (svgIcon) {
            svgIcon.classList.add(ICON_CLASS);
            return svgIcon;
        }

        const fallbackIcon = this.createElement("div");
        fallbackIcon.className = ICON_CLASS;
        return fallbackIcon;
    }

    createToolbarButtonState(prop, elem, icon) {
        return {
            autoCheck: prop.check || false,
            className: prop.class,
            checked: false,
            icon,
            argv: prop.value,
            elem: elem,
            colorNode: {},
            disabled: false,
            action: prop.action,
            name: prop.name,
            node: prop.node || null,
            data: null
        };
    }

    handleToolbarButtonClick(button, elem) {
        switch (button.action) {
            case "doCmd":
                this.execEditorCommand(button.argv);
                break;
            case "applyTextFormat":
                this.applyTextFormat(button.argv);
                break;
            case "applyFontSize":
                this.fontSizeUpDown(button.argv);
                break;
            case "popupWindowOpen":
                this.popupWindowOpen(button);
                break;
            case "showDropdown":
                this.handleToolbarDropdownClick(button, elem);
                break;
            default:
                alert("해당 명령은 지원하지 않는 기능입니다.");
        }
    }

    setupToolbarMenuItem(button, buttonProps) {
        const MENU_ITEM_CLASS = "menu-item";
        const ICON_CLASS = "icon";

        if (button.icon.className !== MENU_ITEM_CLASS) {
            return;
        }

        const menuText = buttonProps.item_text || null;
        this.setupMenuItemIcon(button.icon, menuText);

        if (menuText) {
            button.data = menuText;
        }

        if (buttonProps.icon > -1 && !this.config.toolbarSVGIcon) {
            button.icon.classList.add(ICON_CLASS);
        }
    }

    createTooltipElement(tooltipText, showArrow) {
        const tooltip = this.createElement("div");
        tooltip.setAttribute("role", "tooltip");
        tooltip.classList.add("tooltip");

        const textNode = document.createTextNode(this.trimSpace(tooltipText) || '');
        const span = this.createElement("span");
        span.appendChild(textNode);
        tooltip.appendChild(span);

        if (showArrow) {
            const arrowElem = this.createElement("div");
            arrowElem.classList.add("tooltip-arrow");
            arrowElem.setAttribute("data-popper-arrow", "");
            tooltip.append(arrowElem);
        }

        return tooltip;
    }

    handleToolbarDropdownClick(button, buttonElement) {
        if (button.checked && button.name === "QuoteBlock" && button.data) {
            this.removeBlockquote(button.data);
            this.toolbarDropdownChecked(button, false);
            button.data = null;
            return;
        }

        this.showDropdown(button.argv, buttonElement);
        this.toolbarButtonChecked(button, true);
    }

    createButtonHint(refNode, button, text, arrow = true, placement='bottom') {
        const SHOW_EVENTS = ['mouseenter'];
        const HIDE_EVENTS = ['mouseleave'];
        const SHOW_DELAY = 500;
        const POPPER_OFFSET = [0, 8];

        let tooltip = null;
        let popper = null;
        let showTimeoutId = null;

        const createPopperOptions = {
            placement,
            modifiers: [{ name: 'offset', options: { offset: POPPER_OFFSET} }]
        };

        const hideTooltip = () => {
            if (popper) {
                popper.destroy();
                popper = null;
            }
            if (tooltip) {
                tooltip.remove();
                tooltip = null;
            }
            if (showTimeoutId) {
                window.clearTimeout(showTimeoutId);
                showTimeoutId = null;
            }
        };

        const showTooltip = () => {
            hideTooltip();

            tooltip = this.createTooltipElement(text, arrow);
            popper = this.createPopper(button, tooltip, createPopperOptions);
            refNode.append(tooltip);

            showTimeoutId = window.setTimeout(() => {
                if (!tooltip || !popper) {
                    return;
                }

                popper.update();
                tooltip.classList.add("show", "fade");
                showTimeoutId = null;
            }, SHOW_DELAY);
        }

        SHOW_EVENTS.forEach(evt => this.addEvent(button, evt, showTooltip));
        HIDE_EVENTS.forEach(evt => this.addEvent(button, evt, hideTooltip));
    }

    showToolbar(wrapper) {
        const baseElem = this.createElement('div');
        const showButtonHint = this.config.showToolbarTooltip && !this.browser.mobile;
        const createColumn = (colClass) => {
            const columnElem = baseElem.cloneNode(false);
            columnElem.className = colClass;
            wrapper.append(columnElem);
            return columnElem;
        };
        const showToolbarIcons = () => {
            wrapper.querySelectorAll('.dropdown')
                .forEach(btn => btn.classList.add('trans'));
        };

        const startColumn = createColumn('col-start');
        let endColumn = null;

        if (this.config.useFullScreen) {
            const btnFullscreen = baseElem.cloneNode(false);
            btnFullscreen.className = 'btn-fullscreen';
            btnFullscreen.dataset.action = 'fullscreen';

            this.addEvent(btnFullscreen, 'mousedown', evt => this.stopEvent(evt));
            this.addEvent(btnFullscreen, "click", (evt) => {
                evt.target.classList.toggle('actual');
                this.cheditor.resizeBar.classList.toggle('full-screen');
                this.fullScreenMode(evt);
            });

            endColumn = createColumn('col-end');
            endColumn.append(btnFullscreen);

            if (showButtonHint) {
                this.createButtonHint(wrapper, btnFullscreen, '전체 화면');
            }
        }

        if (this.config.useAi && !this.browser.mobile && !this.config.toolbarSVGIcon) {
            const btnAi = baseElem.cloneNode(false);
            btnAi.className = 'btn-ai';
            btnAi.dataset.action = 'ai';

            this.addEvent(btnAi, 'mousedown', evt => this.stopEvent(evt));
            this.addEvent(btnAi, "click", () => {
                this.popupWindowLoad(GB.UI.POPUPS.Ai);
            });

            if (!endColumn) {
                endColumn = createColumn('col-end');
            }

            endColumn.prepend(btnAi);

            if (showButtonHint) {
                this.createButtonHint(wrapper, btnAi, GB.UI.POPUPS.Ai.title);
            }
        }

        TMPL.toolbar.forEach((group) => {
            if (group.name === 'Split') {
                const split = baseElem.cloneNode(false);
                split.className = 'toolbar-split';
                startColumn.append(split);
                return;
            }
            if (group.name === 'vertical-divider') {
                const divider = baseElem.cloneNode(false);
                divider.className = 'toolbar-divider-line';
                startColumn.append(divider);
                return;
            }

            // const btn_group = [];
            const groupOuter = baseElem.cloneNode(false);
            groupOuter.className = 'toolbar-btn-outer';

            group.button.forEach((prop) => {
                if (prop.name === 'vertical-line') {
                    const verticalLine = baseElem.cloneNode(false);
                    verticalLine.className = prop.class;
                    groupOuter.append(verticalLine);
                    return;
                }

                if (!prop.node && this.config['use' + prop.name] !== true ||
                    !this.config.toolbarSVGIcon && typeof prop.icon === 'undefined') {
                    return;
                }

                if (prop.type === 'combobox' && this.config['use' + prop.node] !== true) {
                    return;
                }

                const tbButton = this.createToolbarButton(prop);
                if (!tbButton) {
                    return;
                }

                tbButton.group = group.name;

                if (tbButton.name === 'ForeColor' || tbButton.name === 'BackColor') {
                    const color = baseElem.cloneNode(false);
                    color.className = 'current-color d-none';
                    color.style.backgroundColor = prop.default;
                    tbButton.icon.append(color);
                }
                groupOuter.append(tbButton.elem);

                if (showButtonHint) {
                    this.createButtonHint(wrapper, tbButton.elem, prop.label);
                }
            });

            // if (btn_group.length > 0) {
            //     if (btn_group.length === 1) {
            //         btn_group.shift().classList.add('btn-single');
            //     } else {
            //         btn_group.shift().classList.add('btn-start');
            //         btn_group.pop().classList.add('btn-end');
            //         while (btn_group.length) {
            //             btn_group.shift().classList.add('btn-middle');
            //         }
            //     }
            // }
            if (groupOuter.childElementCount > 0) {
                startColumn.append(groupOuter);
            }
        });

        if (document.readyState === 'complete') {
            showToolbarIcons();
        } else {
            this.addEvent(document, 'readystatechange', evt => {
                if (evt.target.readyState === 'complete') {
                    showToolbarIcons();
                }
            });
        }
    }

    defineCustomElement(name, cls) {
        if (!customElements.get(name)) {
            customElements.define(name, cls);
        }
    }

    createAppElement() {
        const appContext = this;
        const editor = appContext.cheditor;
        const config = appContext.config;
        const browser = appContext.browser;
        const toolbar = appContext.toolbar;
        
        const SHADOW_ROOT_MODE = 'open';
        const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        const FULL_SIZE = '100%';

        const DOM_IDS = {
            appTemplate: 'app-template',
            root: 'root',
            uiCss: 'ui-css'
        };
        const CSS_CLASSES = {
            mobile: 'mobile',
            hidden: 'd-none',
            fade: 'fade',
            editareaFrame: '.editarea-frame',
            htmlSelector: '.html-selector',
            textareaResizer: '.editarea-resizer',
            modalTitle: '.modal-title',
            modalTitleText: '.modal-title .title',
            modalCloseButton: '.modal-title-bar .close',
            modalFrame: '.modal-contents'
        };
        const ELEMENT_IDS = {
            toolbar: 'note-toolbar',
            editArea: 'note-editarea',
            statusBar: 'note-statusbar',
            imageResizer: 'image-resizer',
            imagePopover: 'image-popover',
            modal: 'popover-modal',
            dialog: 'popover-dialog'
        };
        const SELECTORS = {
            insertParagraphLine: '#insert-paragraph-node',
            toolbarButton: '[role="button"]'
        };

        const tplFragment = document.createRange().createContextualFragment(TMPL.container);

        const getAppTagName = () => {
            const alphabet = Array.from({ length: 26 }, (_, i) => String.fromCharCode(97 + i));
            return editor.id > 0 ? `cheditor-app-${alphabet[editor.id]}` : 'cheditor-app';
        }

        appContext.appTagName = getAppTagName();

        class EditorBlock extends HTMLElement {
            constructor() {
                super();

                const tpl = tplFragment.getElementById(DOM_IDS.appTemplate);
                this.attachShadow({mode: SHADOW_ROOT_MODE})
                    .appendChild(tpl.content.cloneNode(true));
                this.setElementSetupHandlers();
            }

            setElementSetupHandlers() {
                this.elementSetupHandlers = {
                    [ELEMENT_IDS.toolbar]: el => this.setupToolbar(el),
                    [ELEMENT_IDS.editArea]: el => this.setupEditArea(el),
                    [ELEMENT_IDS.statusBar]: el => this.setupStatusBar(el),
                    [ELEMENT_IDS.imageResizer]: el => this.registerDetachedEditorElement(el, 'imageResizer'),
                    [ELEMENT_IDS.imagePopover]: el => this.registerDetachedEditorElement(el, 'imagePopover'),
                    [ELEMENT_IDS.modal]: el => this.setupModal(el),
                    [ELEMENT_IDS.dialog]: el => {
                        editor.dialog = el;
                    }
                };
            }

            connectedCallback() {
                appContext.appHost = this;
                appContext.appRoot = this.shadowRoot;
                this.attachEditorElements();
            }

            attachEditorElements() {
                this.attachStyles();
                this.createSvgIconSprite();
                this.attachElements();
            }

            attachStyles() {
                const link = this.shadowRoot.getElementById(DOM_IDS.uiCss);
                link.setAttribute('href', `${config.path.css}/ui.css`);
            }

            setImportantStyle(el, prop, val) {
                el.style.setProperty(prop, val, 'important');
            }

            createSvgIconSprite() {
                const svgContainer = document.createElementNS(SVG_NAMESPACE, 'svg');

                svgContainer.insertAdjacentHTML('afterbegin', TMPL.svgIcons);
                svgContainer.setAttribute('aria-hidden', 'true');
                svgContainer.style.display = 'none';

                this.shadowRoot.appendChild(svgContainer);
            }

            attachElements() {
                let el = this.shadowRoot.getElementById(DOM_IDS.root);

                while (el) {
                    if (el.id === DOM_IDS.root) {
                        this.setupMainElement(el);
                    } else {
                        this.setupEditorElement(el);
                    }

                    el = el.nextElementSibling;
                }
            }

            setupMainElement(el) {
                this.setupChildEditorElements(el);
                this.setupContainer(el);
            }

            setupChildEditorElements(el) {
                let child = el.firstElementChild;

                while (child) {
                    this.setupEditorElement(child);
                    child = child.nextElementSibling;
                }
            }

            setupContainer(el) {
                this.setImportantStyle(el, 'width', config.editorWidth);

                if (browser.mobile) {
                    el.classList.add(CSS_CLASSES.mobile);
                }

                editor.container = el;
            }

            setupEditorElement(el) {
                const setupEl = this.elementSetupHandlers[el.getAttribute('id')];

                if (setupEl) {
                    setupEl(el);
                }
            }

            setupToolbarEventHandlers(tb) {
                appContext.addEvent(tb, 'mousedown', evt => appContext.stopEvent(evt));
                appContext.addEvent(tb, 'click', evt => {
                    const btn = evt.target?.closest(SELECTORS.toolbarButton);
                    const btnInfo = this.getToolbarButtonConfig(btn);

                    if (!btnInfo) {
                        return;
                    }
                    appContext.handleToolbarButtonClick(btnInfo, btn);
                });
            }

            getToolbarButtonConfig(btn) {
                if (!btn?.dataset.name) {
                    return null;
                }

                return toolbar[btn.dataset.name] || null;
            }

            setupToolbar(el) {
                appContext.showToolbar(el);
                editor.toolbarWrapper = el;
                this.setupToolbarEventHandlers(el);
            }

            setupEditArea(el) {
                const frame = el.querySelector(CSS_CLASSES.editareaFrame);

                this.setImportantStyle(frame, 'height', FULL_SIZE);
                this.setImportantStyle(frame, 'width', FULL_SIZE);
                this.setImportantStyle(el, 'height', config.editorHeight);

                editor.editarea = frame;
                editor.editWrapper = el;
                editor.insertParagraphLine = el.querySelector(SELECTORS.insertParagraphLine);
            }

            setupStatusBar(el) {
                if (config.showTagSelector) {
                    editor.htmlTagSelector = el.querySelector(CSS_CLASSES.htmlSelector);
                    el.classList.remove(CSS_CLASSES.hidden);
                }

                editor.resizeBar = el.querySelector(CSS_CLASSES.textareaResizer);

                appContext.addEvent(
                    editor.resizeBar,
                    appContext.pointerEvents.start,
                    evt => appContext.editareaResizeStart(evt)
                );
            }

            registerDetachedEditorElement(el, prop) {
                el.removeAttribute('id');
                editor[prop] = el;
            }

            setupModal(el) {
                editor.modal = el;
                editor.modal.classList.add(CSS_CLASSES.fade);
                editor.modal.titleBar = el.querySelector(CSS_CLASSES.modalTitle);
                editor.modal.titleText = el.querySelector(CSS_CLASSES.modalTitleText);
                editor.modal.closeButton = el.querySelector(CSS_CLASSES.modalCloseButton);
                editor.modal.frameWrapper = el.querySelector(CSS_CLASSES.modalFrame);
            }
        }

        this.defineCustomElement(appContext.appTagName, EditorBlock);
    }

    findElementPosition(el) {
        let x, y;
        if (typeof el.offsetParent !== 'undefined') {
            for (x = 0, y = 0; el; el = el.offsetParent) {
                x += el.offsetLeft;
                y += el.offsetTop;
            }
            return {left: x, top: y};
        }
        return { left: el.x, top: el.y };
    }

    async run(caller) {
        if (this.isUndefined(caller) || caller !== 'initEditor') {
            return;
        }

        try {
            this.setFolderPath();
            this.initializeInputForm();
            this.createAppElement();
            this.cheditor.inputForm.after(this.createElement(this.appTagName));
        } catch (e) {
            alert(e.toString());
            return;
        }

        if (await this.resetEditorDocument()) {
            this.editorEventHandler();
            this.initEditorFocus();
        }
    }

    fullScreenMode(evt) {
        const btnFullScreen = evt.target;
        const isFullScreen = btnFullScreen.classList.contains('actual');
        const container = this.cheditor.container;
        const editWrapper = this.cheditor.editWrapper;
        const setEditorHeight = (height) => {
            editWrapper.style.setProperty('height', height, 'important');
        };

        if (isFullScreen) {
            const toolbarHeight = this.cheditor.toolbarWrapper.offsetHeight;
            this.config.editorHeight = editWrapper.offsetHeight;
            setEditorHeight(`calc(100% - ${toolbarHeight}px)`);
            container.classList.add('full-screen');

            const afterToolbarHeight = this.cheditor.toolbarWrapper.offsetHeight;
            if (toolbarHeight > afterToolbarHeight) {
                setEditorHeight(`calc(100% - ${afterToolbarHeight}px)`);
            }
        } else {
            setEditorHeight(`${this.config.editorHeight}px`);
            container.classList.remove('full-screen');
        }
    }

    showDropdown(command, button) {
        const methodName = GB.UI.DROPDOWNS.COMMAND_MAP[command];
        if (methodName && typeof this[methodName] === 'function') {
            const dropdownId = this[methodName](button);
            if (dropdownId) {
                this.showDropdownMenu(button, dropdownId);
            }
        }
    }

    createDropdownBuilder() {
        return {
            createContainer: () => this.createElement('div'),
            createItem: (value, clickHandler) => {
                const item = this.createElement('div');
                item.dataset.value = value;
                item.onclick = clickHandler;
                return item;
            },
            createLabel: (content, styles = {}) => {
                const label = this.createElement('span');
                if (typeof content === 'string') {
                    label.append(content);
                } else {
                    label.append(content);
                }
                Object.assign(label.style, styles);
                return label;
            },
            ensureDropdownExists: (dropdownName) => {
                return typeof this.dropdown[dropdownName] !== 'undefined';
            },
            registerDropdown: (dropdownName, width, content, button, className = null) => {
                this.createDropdown(dropdownName, width, content, button, className);
            }
        };
    }

    dropdownOrderedList(button) {
        const dropdownName = button.dataset.name;
        const builder = this.createDropdownBuilder();

        if (builder.ensureDropdownExists(dropdownName)) {
            return dropdownName;
        }

        const DROPDOWN_WIDTH = 120;
        const dropdownContainer = builder.createContainer();
        const isUnordered = dropdownName === 'UnOrderedListCombo';
        const command = isUnordered ? 'UnOrderedList' : 'OrderedList';
        const styles = isUnordered
            ? GB.UI.DROPDOWNS.LIST_STYLES.unordered
            : GB.UI.DROPDOWNS.LIST_STYLES.ordered;

        styles.forEach(style => {
            const dropdownItem = builder.createItem(style.type, () => this.doCmdPopup(command, style.type));
            const listPreview = this.createElement('ul');

            Object.assign(listPreview.style, {
                width: '90px',
                padding: '0 15px',
                margin: '0',
                listStyleType: style.type,
                cursor: 'default',
                textAlign: 'left'
            });

            const listItem = this.createElement('li');
            listItem.append(style.title);
            listPreview.append(listItem);

            const itemLabel = builder.createLabel(listPreview);
            dropdownItem.append(itemLabel);
            dropdownContainer.append(dropdownItem);
        });

        builder.registerDropdown(dropdownName, DROPDOWN_WIDTH, dropdownContainer, button);
        return dropdownName;
    }

    dropdownColor(button) {
        const dropdownName = button.dataset.name;
        const currentColorSelector = '.current-color';
        const DROPDOWN_WIDTH = 220;
        const dropdownClassName = 'color-palette';
        const tickIconStyle = `url("${this.config.path.icon}/color_picker_tick.png")`;
        const builder = this.createDropdownBuilder();

        const applyTickIconStyle = (elem) => {
            elem.style.backgroundImage = tickIconStyle;
            elem.style.backgroundRepeat = 'no-repeat';
            elem.style.backgroundPosition = 'center center';
        };

        const getOrCreateColorDropdown = () => {
            if (builder.ensureDropdownExists(dropdownName)) {
                return this.dropdown[dropdownName];
            }

            const dropdownContent = this.setColorTable(dropdownName);
            builder.registerDropdown(dropdownName, DROPDOWN_WIDTH, dropdownContent, button, dropdownClassName);
            return this.dropdown[dropdownName];
        };

        const updateColorPicker = (colorNode, selectedColor) => {
            colorNode.selectedValue.style.backgroundColor = selectedColor;
            colorNode.colorPicker.hidePicker();
            colorNode.colorPicker.fromString(selectedColor);
            colorNode.showPicker = false;
        };

        const currentColor = button.querySelector(currentColorSelector).style.backgroundColor;
        const selectedColor = this.colorConvert(currentColor, 'hex');
        const colorNode = this.toolbar[dropdownName].colorNode;
        const dropdownElem = getOrCreateColorDropdown();

        updateColorPicker(colorNode, selectedColor);

        const colorItems = dropdownElem.getElementsByTagName('span');
        const selectedColorLowerCase = selectedColor.toLowerCase();

        for (const colorItem of colorItems) {
            colorItem.style.backgroundImage = '';
            if (colorItem.id.toLowerCase() === selectedColorLowerCase) {
                applyTickIconStyle(colorItem);
            }
        }

        applyTickIconStyle(colorNode.selectedValue);
        return dropdownName;
    }

    dropdownTable(button) {
        const dropdownName = button.dataset.name;
        const builder = this.createDropdownBuilder();

        if (!builder.ensureDropdownExists(dropdownName)) {
            const dropdownContent = this.createTableDropdown();
            builder.registerDropdown(dropdownName, 0, dropdownContent, button, 'table-dropdown');
        }

        return dropdownName;
    }

    dropdownFontType(button) {
        const dropdownName = button.dataset.name;
        const builder = this.createDropdownBuilder();

        if (builder.ensureDropdownExists(dropdownName)) {
            return dropdownName;
        }

        const DROPDOWN_WIDTH = 155;
        const defaultFont = this.config.editorFontFamily.split(',');
        const setFontFamily = fontName => {
            const result = defaultFont.filter(name => name.replace(/["']/g, '').trim() !== fontName);
            result.unshift(fontName);
            return result.join(',');
        };
        const dropdownContent = builder.createContainer();

        GB.UI.DROPDOWNS.FONTS.forEach(fontName => {
            const itemElem = builder.createItem(fontName, () => this.doCmdPopup(dropdownName, fontName));
            const labelElem = builder.createLabel(fontName, {fontFamily: setFontFamily(fontName)});

            itemElem.append(labelElem);
            dropdownContent.append(itemElem);
        });

        builder.registerDropdown(dropdownName, DROPDOWN_WIDTH, dropdownContent, button);
        return dropdownName;
    }

    dropdownFormatBlock(button) {
        const dropdownName = button.dataset.name;
        const builder = this.createDropdownBuilder();

        if (builder.ensureDropdownExists(dropdownName)) {
            return dropdownName;
        }

        const DROPDOWN_WIDTH = 155;
        const FORMAT_BLOCK_FONT_SIZES = {
            H1: "2em", H2: "1.5em", H3: "1.17em", H4: "1em", H5: "0.83em", H6: "0.75em"
        };

        const dropdownContent = builder.createContainer();
        const applyFormatBlockItemStyle = (labelElement, tag) => {
            if (Object.hasOwn(FORMAT_BLOCK_FONT_SIZES, tag)) {
                labelElement.style.fontWeight = "bold";
                labelElement.style.fontSize = FORMAT_BLOCK_FONT_SIZES[tag];
                return labelElement;
            }
            if (tag === 'ADDRESS') {
                labelElement.style.fontStyle = "italic";
                return labelElement;
            }
            if (tag === 'PRE') {
                const preElement = this.createElement('pre');
                preElement.style.margin = "0";
                labelElement.append(preElement);
                return preElement;
            }
            return labelElement;
        };

        Object.entries(GB.UI.DROPDOWNS.FORMAT_BLOCKS).forEach(([tag, title]) => {
            const itemElem = builder.createItem(tag, () => this.doCmdPopup(dropdownName, `<${tag}>`));
            const labelElem = this.createElement('div');

            const trimmedTitle = title.trim();
            const styledLabelElem = applyFormatBlockItemStyle(labelElem, tag);
            styledLabelElem.append(trimmedTitle);
            itemElem.append(labelElem);
            styledLabelElem.setAttribute('name', trimmedTitle);

            dropdownContent.append(itemElem);
        });

        builder.registerDropdown(dropdownName, DROPDOWN_WIDTH, dropdownContent, button);
        return dropdownName;
    }

    dropdownFontSize(button) {
        const dropdownName = button.dataset.name;
        const builder = this.createDropdownBuilder();

        if (builder.ensureDropdownExists(dropdownName)) {
            return dropdownName;
        }

        const DROPDOWN_WIDTH = 55;
        const DROPDOWN_HEIGHT = '260px';
        const outputHtml = builder.createContainer();

        GB.UI.DROPDOWNS.FONT_SIZES.forEach(size => {
            const sizeStr = size.toString();
            const div = builder.createItem(sizeStr, () => this.doCmdPopup(dropdownName, sizeStr));
            const label = builder.createLabel(sizeStr);
            div.append(label);
            outputHtml.append(div);
        });

        outputHtml.style.height = DROPDOWN_HEIGHT;
        outputHtml.style.overflowX = 'hidden';

        builder.registerDropdown(dropdownName, DROPDOWN_WIDTH, outputHtml, button);
        return dropdownName;
    }

    dropdownLineHeight(button) {
        const dropdownName = button.dataset.name;
        const builder = this.createDropdownBuilder();

        if (builder.ensureDropdownExists(dropdownName)) {
            return dropdownName;
        }

        const DROPDOWN_WIDTH = 100;
        const createLineHeightOptionElement = (item) => {
            const optionElement = builder.createItem(item.value, () => this.doCmdPopup(dropdownName, item.value));
            const labelElement = builder.createLabel(item.title);
            optionElement.append(labelElement);
            return optionElement;
        };

        const dropdownContent = builder.createContainer();

        GB.UI.DROPDOWNS.LINE_HEIGHTS.forEach((item) => {
            dropdownContent.append(createLineHeightOptionElement(item));
        });

        builder.registerDropdown(dropdownName, DROPDOWN_WIDTH, dropdownContent, button);
        return dropdownName;
    }

    dropdownQuoteBlock(button) {
        const dropdownName = button.dataset.name;
        const QUOTE_PREVIEW_TEXT = '가나다라';
        const DROPDOWN_WIDTH = 100;
        const builder = this.createDropdownBuilder();

        if (builder.ensureDropdownExists(dropdownName)) {
            return dropdownName;
        }

        const createQuoteBlockItem = quoteBlockStyle => {
            const itemElement = this.createElement('div');
            const quoteElement = this.createElement('div');
            const isVerticalBarStyle = quoteBlockStyle.menu === 'vertical-bar';

            itemElement.className = 'dropdown-item-quote';

            if (isVerticalBarStyle) {
                const previewTextElement = this.createElement('span');
                previewTextElement.append(QUOTE_PREVIEW_TEXT);
                quoteElement.append(previewTextElement);
                quoteElement.className = 'vertical-bar';
            } else {
                quoteElement.style.cssText = quoteBlockStyle.menu;
                quoteElement.append(QUOTE_PREVIEW_TEXT);
            }

            quoteElement.onclick = () => this.doCmdPopup(dropdownName, quoteBlockStyle.apply);
            itemElement.append(quoteElement);

            return itemElement;
        };

        const outputHtml = builder.createContainer();

        GB.UI.DROPDOWNS.QUOTE_BLOCKS
            .map(createQuoteBlockItem)
            .forEach(quoteBlockItem => outputHtml.append(quoteBlockItem));

        builder.registerDropdown(dropdownName, DROPDOWN_WIDTH, outputHtml, button);
        return dropdownName;
    }

    dropdownTextAlignButtonChecked(toolbarButton, dropdownElement) {
        const CHECKED_CLASS_NAME = 'checked';
        const DROPDOWN_ITEM_SELECTOR = '.dropdown-item';
        const toolbarIcon = toolbarButton.querySelector('use');
        const selectedIconId = toolbarIcon.getAttribute('href');

        dropdownElement.querySelectorAll(DROPDOWN_ITEM_SELECTOR)
            .forEach(dropdownItem => {
                const isSelectedItem = dropdownItem.dataset.value === selectedIconId;
                dropdownItem.classList.toggle(CHECKED_CLASS_NAME, isSelectedItem);
            });
    }

    dropdownTextAlign(button) {
        const dropdownName = button.dataset.name;
        const builder = this.createDropdownBuilder();

        if (builder.ensureDropdownExists(dropdownName)) {
            this.dropdownTextAlignButtonChecked(button, this.dropdown[dropdownName]);
            return dropdownName;
        }

        const DROPDOWN_WIDTH = 40;
        const DROPDOWN_TYPE = 'text-align';
        const ICON_PREFIX = '#icon-text-align-';
        const dropdownContent = builder.createContainer();
        const createTextAlignmentOption = ({align, title, execCommand}) => {
            const optionElement = this.createElement('div');
            const iconId = `${ICON_PREFIX}${align}`;

            this.addEvent(optionElement, 'click', () => this.execEditorCommand(execCommand));

            if (align === 'left') {
                optionElement.classList.add('checked');
            }

            optionElement.dataset.value = iconId;
            optionElement.append(this.createSvgIcon(iconId));

            this.createButtonHint(this.appRoot, optionElement, title, true, 'right');
            return optionElement;
        };

        GB.UI.DROPDOWNS.TEXT_ALIGNMENTS
            .map(createTextAlignmentOption)
            .forEach(optionElement => dropdownContent.appendChild(optionElement));

        builder.registerDropdown(dropdownName, DROPDOWN_WIDTH, dropdownContent, button, DROPDOWN_TYPE);
        this.dropdownTextAlignButtonChecked(button, this.dropdown[dropdownName]);

        return dropdownName;
    }

    setDefaultCss(ar) {
        let found = false, href, css;

        ar = ar || { css: 'editarea.css', doc: this.doc };

        const css_file = this.config.path.css + '/' + ar.css,
            head = ar.doc.getElementsByTagName('head')[0];

        if (this.isUndefined(head)) {
            return;
        }

        for (const child of head.children) {
            if (child.tagName === 'LINK') {
                href = child.getAttribute('href');
                if (href && href === css_file) {
                    found = true;
                    break;
                }
            }
        }

        if (!found) {
            css = head.appendChild(ar.doc.createElement('link'));
            css.setAttribute('type', 'text/css');
            css.setAttribute('rel', 'stylesheet');
            css.setAttribute('media', 'all');
            css.setAttribute('href', css_file);
        }
    }

    pauseSelectionTracking() {
        this.selectionTracking = false;
    }

    resumeSelectionTracking() {
        setTimeout(() => this.selectionTracking = true, 0);
    }

    editorEventHandler() {
        if (this.initEventHandler) return;

        let shouldRestoreClickState = false;
        let hasFocus = true;

        const setTargetActiveState = (isActive, node) => {
            node.classList.toggle('active', isActive);
            node.classList.toggle('disabled', !isActive);
        };

        const handleBogusCaretMouseDown = (evt, caret) => {
            const caretTarget = caret.fakeNode?.targetNode;
            if (!caretTarget) return;

            const evtTarget = evt.target;

            if (caretTarget.contains(evtTarget)) {
                if (!caret.hasInputFocus(evtTarget) && !caret.disabled) {
                    this.stopEvent(evt);
                    this.pauseSelectionTracking();
                    caret.selectNodeContents();
                    this.resumeSelectionTracking();
                }
                return;
            }

            this.editareaEventHandler(evt);

            const curCaret = this.hasBogusCaret();
            if (caret.fakeNode === curCaret?.fakeNode) {
                this.removeElementController();
                return;
            }

            this.stopEvent(evt);
        };

        const handleMouseDown = (evt) => {
            if (!this.doc.hasFocus() && !hasFocus) {
                this.editareaFocus();
            }

            const caret = this.hasBogusCaret();
            if (caret) {
                handleBogusCaretMouseDown(evt, caret);
            } else {
                this.getSelection().collapse(evt.target);
            }

            this.closeDropdownMenu();
        };

        const handleFocusOut = () => {
            hasFocus = false;

            const caret = this.hasBogusCaret();
            const targetNode = caret?.fakeNode?.targetNode;
            if (!targetNode) return;

            if (targetNode.querySelector('img')) {
                setTargetActiveState(false, targetNode);
            }
        };

        const handleFocusIn = () => {
            hasFocus = true;

            const caret = this.hasBogusCaret();
            const targetNode = caret?.fakeNode?.targetNode;
            if (!targetNode) return;

            setTargetActiveState(true, targetNode);
        };

        const handleSelectionChange = (evt) => {
            if (!this.selectionTracking) return;

            clearTimeout(this.selectionChangeEventTimer);

            this.selectionChangeEventTimer = setTimeout(() => {
                this.editareaEventHandler(evt);
            }, this.selectionChangeEventDelay);
        };

        const handleInteractiveWidgetEvent = (evt) => {
            this.stopEvent(evt);
            shouldRestoreClickState = true;
        };

        const handleClick = () => {
            if (shouldRestoreClickState) {
                shouldRestoreClickState = false;
            }
        };

        const registerDocumentEvents = () => {
            const focusInEvent = GB.browser.firefox ? 'focus' : 'focusin';
            const focusOutEvent = GB.browser.firefox ? 'blur' : 'focusout';

            this.addEvent(this.doc, focusInEvent, handleFocusIn);
            this.addEvent(this.doc, focusOutEvent, handleFocusOut);
            this.addEvent(this.doc, 'keydown', this.onKeydown.bind(this));
            this.addEvent(this.doc, 'keypress', this.onKeypress.bind(this));
            this.addEvent(this.doc, 'keyup', this.onKeyup.bind(this));
            this.addEvent(this.doc, 'click', handleClick);
            this.addEvent(this.doc, 'mousedown', handleMouseDown);
            this.addEvent(this.doc, 'image-resizing', handleInteractiveWidgetEvent);
            this.addEvent(this.doc, 'click-popover', handleInteractiveWidgetEvent);
            this.addEvent(this.doc, 'paste', this.handlePaste.bind(this));
            this.addEvent(this.doc, 'selectionchange', handleSelectionChange);
        };

        const registerTagSelectorEvents = () => {
            if (!this.config.showTagSelector) return;

            const tagSelector = this.cheditor.htmlTagSelector;
            const isSelectableTag = (evt) => evt.target.tagName === 'A' && !this.elementResizer;

            this.addEvent(tagSelector, 'mousedown', (evt) => {
                this.stopEvent(evt);
                this.editareaFocus();

                if (isSelectableTag(evt)) {
                    this.tagSelection(evt.target.el);
                }
            });

            this.addEvent(tagSelector, 'mouseover', (evt) => {
                if (isSelectableTag(evt)) {
                    this.showNodeRange(evt.target.el);
                }
            });

            this.addEvent(tagSelector, 'mouseout', (evt) => {
                if (isSelectableTag(evt)) {
                    this.hideNodeRange(evt.target.el);
                }
            });
        };

        const registerObservers = () => {
            this.observer = new MutationObserver(this.applyFontStyle.bind(this));
            this.classChangeObserver = new MutationObserver(this.createHandleClassChange.bind(this));
            this.removeNode = this.removeNodeProxy(this.removeNodeTarget);
        };

        registerDocumentEvents();
        registerObservers();
        registerTagSelectorEvents();

        this.initEventHandler = true;
    }

    applyFontStyle(mutations, observer) {
        observer.disconnect();
        const rules = observer.modify.rules;
        const marker = this.saveRangeMarker(this.getRange());

        for (const mutation of mutations) {
            switch (mutation.type) {
                case 'attributes':
                    this.muHandleAttribute(mutation);
                    break;
                case 'childList':
                    for (const node of mutation.addedNodes) {
                        if (this.isElementNode(node)) {
                            this.muProcessAddedNode(node, observer, rules);
                        }
                    }
                    break;
            }
        }

        this.restoreRangeMarker(marker);
    }

    muProcessAddedNode(node, observer, rules) {
        if (node.nodeName !== observer.modify.oldName) {
            if (this.isTextFormatElement(node)) {
                if (!node.hasChildNodes()) {
                    node.remove();
                } else {
                    this.muHandleTransparentProperty(node, rules.attributeNewValue);
                }
            }
            return;
        }

        const range = this.createRange();
        range.selectNodeContents(node);

        if (observer.modify.type === 'replace') {
            this.muReplaceNode(node, range, observer.modify.newName);
        } else {
            this.muApplyStyleRulesToNode(node, rules, range, observer.modify.newName);
        }
    }

    muReplaceNode(node, range, newNodeName) {
        const newElement = this.createElement(newNodeName);
        newElement.appendChild(range.extractContents());
        node.replaceWith(newElement);

        if (newElement.hasChildNodes()) {
            this.replaceTextFormatElement(newElement);
        }
    }

    muHandleTransparentProperty(node, prop) {
        if (prop !== 'color' && prop !== 'background-color') return;

        const color = node.style[prop];
        if (!color) return;

        if (color.startsWith('rgba')) {
            node.style.removeProperty(prop);
            if (node.style.length === 0) {
                const range = this.createRange();
                range.selectNodeContents(node);
                node.before(range.extractContents());
                node.remove();
            }
        }
    }

    muHandleAttribute(mutation) {
        const target = mutation.target;
        const styleAttributes = target.getAttribute('style');

        if (!styleAttributes || styleAttributes.length === 0) {
            target.removeAttribute('style');
            return;
        }

        this.muHandleTransparentProperty(target, 'background-color');
        this.muHandleTransparentProperty(target, 'color');
    }

    muHasMatchingStyles(node, refStyles, refStyleCount) {
        const nodeStyles = this.cssProperties(node);
        return (nodeStyles.length === refStyleCount &&
            nodeStyles.every((style, i) =>
                style.name === refStyles[i].name && style.value === refStyles[i].value
            )
        );
    }

    muApplyStyleRulesToNode(node, styleRules, range, newNodeName) {
        let styleValue = (
            styleRules.name === 'color' ||
            styleRules.name === 'backgroundColor' ||
            styleRules.name === 'fontFamily')
            ? node.getAttribute(styleRules.attributeNewValue) || styleRules.attributeNewValue
            : styleRules.attributeNewValue;
        const extractedContents = range.extractContents();

        if (['color', 'backgroundColor'].includes(styleRules.name)) {
            if (styleValue.startsWith('rgba')) {
                node.before(extractedContents);
                node.remove();
                return;
            }
        }

        if (node.parentNode?.childNodes.length === 1 && node.parentNode.nodeName === 'SPAN') {
            node.parentNode.style[styleRules.name] = styleValue;
            node.before(extractedContents);
            node.remove();
        } else {
            const newElement = this.createElement(newNodeName);
            newElement.style[styleRules.name] = styleValue;

            if (extractedContents.childNodes.length === extractedContents.children.length) {
                const refNodes = [...extractedContents.children];
                const refNode = refNodes.shift();
                const refNodeStyles = this.cssProperties(refNode);
                let stylesMatch = false;

                if (refNodeStyles) {
                    stylesMatch = refNodes
                        .every(child => this.muHasMatchingStyles(child, refNodeStyles, refNodeStyles.length));
                }

                if (stylesMatch) {
                    refNodes.unshift(refNode);
                    refNodes.forEach(child => {
                        const styles = this.cssProperties(child);
                        if (!styles) {
                            return;
                        }

                        styles.forEach((style) => {
                            const prop = node.style.getPropertyValue(style.name);
                            if (!prop || prop === style.value) {
                                newElement.style[style.name] = style.value;
                                child.style.removeProperty(style.name);
                            }
                        });

                        if (child.style.length === 0) {
                            child.removeAttribute('style');
                            if (child.attributes.length === 0) {
                                const range = this.createRange();
                                range.selectNodeContents(child);
                                child.before(range.extractContents());
                                child.remove();
                            }
                        }
                    });
                }
            }

            newElement.appendChild(extractedContents);
            newElement.normalize();
            node.replaceWith(newElement);
        }
    }

    addEvent(target, type, handler, passive = false) {
        if (target?.addEventListener) {
            target.addEventListener(type, handler, { passive: passive });
        }
    }

    removeEvent(elem, type, listener) {
        elem?.removeEventListener?.(type, listener);
    }

    stopEvent(evt) {
        evt?.preventDefault?.();
        evt?.stopPropagation?.();
    }

    getElement(elem, tagName) {
        if (!elem || !tagName) {
            return null;
        }

        const normalizedTagName = tagName.toUpperCase();
        let curElem = elem;

        while (curElem) {
            if (curElem.tagName === normalizedTagName) {
                return curElem;
            }

            if (this.isBody(curElem)) {
                return null;
            }

            curElem = curElem.parentNode;
        }

        return null;
    }

    removeHyperLink() {
        const selection = this.getSelection();

        if (selection.type === 'None') {
            return;
        }
        if (selection.type === 'Range') {
            this.queryCommand('UnLink');
            return;
        }

        const range = this.getRange();
        const anchor = this.getRangeElement(range).closest('a');

        if (anchor && anchor.nodeName === 'A') {
            const parent = anchor.parentNode;
            const staticRange = this.createStaticRange(range);
            const anchorRange = this.createRange();
            anchorRange.selectNodeContents(anchor);
            anchor.before(anchorRange.extractContents());
            anchor.remove();
            this.restoreStaticRange(selection, staticRange);
            parent.normalize();
        }
    }

    hyperLinkCollapsedRange(range, attr) {
        const anchor = this.getRangeElement(range).closest('a');
        const text = this.doc.createTextNode(attr.href);

        if (!anchor) {
            range.insertNode(text);
            range.selectNode(text);
            return null;
        }

        let staticRange = null;

        if (anchor.href === anchor.textContent.trim()) {
            anchor.replaceChildren(text);
        } else {
            staticRange = this.createStaticRange(range.cloneRange());
        }

        range.selectNodeContents(anchor);
        return staticRange;
    }

    setAnchorAttributes(anchor, range, attr) {
        const LINK_NODE_NAME = 'A';

        while (anchor && range.intersectsNode(anchor)) {
            if (anchor.nodeName === LINK_NODE_NAME) {
                anchor.setAttribute('href', attr.href);
                if (this.config.linkTargetAttr) {
                    anchor.setAttribute('target', this.config.linkTargetAttr);
                }
                if (attr.title) {
                    anchor.setAttribute('title', attr.title);
                }
                if (!this.isBlockElement(this.getRootNode(anchor))) {
                    anchor.id = this.makeRandomString();
                    this.queryCommand('formatBlock', 'p');

                    anchor = this.doc.getElementById(anchor.id);
                    anchor.removeAttribute('id');
                    range = this.getRange();
                }
            }
            anchor = this.getNextElement(anchor, LINK_NODE_NAME);
        }
    }

    restoreSelectionRange(selection, range, staticRange) {
        if (staticRange) {
            this.restoreStaticRange(selection, staticRange);
        } else {
            range.collapse(false);
            selection.empty();
            selection.addRange(range);
        }
    }

    createHyperLink(attr) {
        const selection = this.getSelection();

        if (selection.type === 'None') {
            return;
        }

        let range = selection.getRangeAt(0);
        const isCollapsed = range.collapsed;
        let staticRange = null;

        if (isCollapsed) {
            staticRange = this.hyperLinkCollapsedRange(range, attr);
        }

        this.queryCommand("CreateLink", attr.href);
        range = this.getRange();

        let anchorElem = range.startContainer;
        this.setAnchorAttributes(anchorElem, range, attr);

        if (isCollapsed) {
            this.restoreSelectionRange(selection, range, staticRange);
        }
    }

    insertParagraph() {
        const hr = this.createHorizontalRule();
        if (!hr) {
            return null;
        }
        const para = this.createEmptyParagraph();
        hr.replaceWith(para);
        return para;
    }

    createHorizontalRule() {
        const scrollPos = this.editareaScrollXY();
        const scrollTo = () => {
            requestAnimationFrame(() => {
                this.editarea.scrollTo(scrollPos.x, scrollPos.y);
            });
        };
        let hr;

        if (GB.browser.firefox) {
            const rng = this.getRange();
            if (!rng.collapsed) this.queryCommand('delete');

            this.queryCommand('insertHorizontalRule');
            scrollTo();

            hr = this.body.querySelector('hr[_moz_dirty=""]');
            if (!hr) return null;

            hr.removeAttribute('_moz_dirty');
        } else {
            const id = this.makeRandomString();

            this.queryCommand('insertHorizontalRule', id);
            scrollTo();

            hr = this.doc.getElementById(id);
            if (!hr) return null;

            hr.removeAttribute('id');
        }

        return hr;
    }

    insertHorizontalRule() {
        const hr = this.createHorizontalRule();

        if (!hr) return;

        hr.setAttribute('style', GB.STYLES.HR);

        const nextSibling = hr.nextSibling;
        if (!nextSibling || this.removeBrElement(nextSibling) && !hr.nextSibling) {
            hr.after(this.createEmptyParagraph());
        }

        const prevSibling = hr.previousSibling;
        if (!prevSibling || this.removeBrElement(prevSibling) && !hr.previousSibling) {
            hr.before(this.createEmptyParagraph());
        }

        let nextNode = hr.nextSibling;
        while (nextNode.firstChild) {
            nextNode = nextNode.firstChild;
        }

        this.getSelection().setPosition(nextNode);
    }

    getCompatProperty(docProp, bodyProp) {
        const isCSS1Compat = (this.doc.compatMode || '') === 'CSS1Compat';
        return isCSS1Compat ? this.doc.documentElement[docProp] : this.body[bodyProp];
    }

    getOffsetLeft(node) {
        let currNode = node;
        let offsetLeft = 0;
        while (currNode) {
            offsetLeft += currNode.offsetLeft;
            currNode = currNode.offsetParent;
        }
        return offsetLeft;
    }

    getOffsetTop(node) {
        let currNode = node, offsetTop = 0;

        while (currNode) {
            offsetTop += currNode.offsetTop;
            currNode = currNode.offsetParent;
        }

        return offsetTop;
    }

    editareaScrollXY() {
        const y = this.editarea.scrollY;
        const x = this.editarea.scrollX;
        return { x, y };
    }

    scrollXY() {
        const scrollTop = this.getCompatProperty('scrollTop', 'scrollTop');
        const scrollLeft = this.getCompatProperty('scrollLeft', 'scrollLeft');
        return { scrollTop, scrollLeft };
    }

    clientXY() {
        const clientTop = this.getCompatProperty('clientTop', 'clientTop');
        const clientLeft = this.getCompatProperty('clientLeft', 'clientLeft');
        return { clientTop, clientLeft };
    }

    getOffsetBox(elem) {
        if (!elem) return null;

        const rect = elem.getBoundingClientRect();
        const { scrollTop, scrollLeft } = this.scrollXY();
        const { clientTop, clientLeft } = this.clientXY();
        const left = Math.round(rect.left + scrollLeft - clientLeft);
        return {
            top: Math.round(rect.top + scrollTop - clientTop),
            bottom: Math.round(rect.bottom + scrollTop - clientTop),
            left: left,
            center: left + Math.round(rect.width / 2),
            width: Math.round(rect.width),
            height: Math.round(rect.height)
        };
    }

    prepareNodeForBlockquote(node) {
        if (this.isInlineElement(node)) {
            node = this.wrapInlineNodeInBlockquote(node);
        }
        return node;
    }

    wrapContentInBlockquote(startNode, endNode, style) {
        const quoteElem = this.createElement('blockquote');
        quoteElem.style.cssText = style;

        startNode.before(quoteElem);
        let currNode = startNode;

        while (currNode && currNode !== endNode) {
            currNode = this.prepareNodeForBlockquote(currNode, endNode);
            if (currNode.contains(endNode)) {
                break;
            }
            const nextNode = currNode.nextSibling;
            quoteElem.append(currNode);
            currNode = nextNode;
        }

        if (currNode) {
            currNode = this.prepareNodeForBlockquote(currNode, endNode);
            if (currNode) {
                quoteElem.append(currNode);
            }
        }
    }

    wrapInlineNodeInBlockquote(node) {
        const paraElem = this.createElement('p');
        let currBlockElem = null;
        let currNode = node;

        while (currNode) {
            if (this.isInlineElement(currNode)) {
                if (!currBlockElem) {
                    currBlockElem = paraElem.cloneNode(false);
                    currNode.before(currBlockElem);
                }
                currBlockElem.append(currNode);
                currNode = currBlockElem;
            } else {
                break;
            }
            currNode = currNode.nextSibling;
        }

        return currBlockElem || node;
    }

    removeBlockquote(blockquote) {
        if (blockquote) {
            this.editareaFocus();
            const range = this.getRange();
            const staticRange = this.createStaticRange(range);
            range.selectNodeContents(blockquote);
            blockquote.before(range.extractContents());
            blockquote.remove();
            this.restoreStaticRange(this.getSelection(), staticRange);
        }
    }

    blockquoteCommand(style) {
        const range = this.getRange();
        const staticRange = this.createStaticRange(range);
        const {startContainer, endContainer} = staticRange;
        const startNode = this.getRootNode(startContainer);
        const endNode = this.getRootNode(endContainer);
        const selection = this.getSelection();
        const quoteAncestor = this.isElementNode(startNode)
            ? startNode.closest('blockquote') : null;

        if (quoteAncestor) {
            quoteAncestor.style.cssText = style;
            this.restoreStaticRange(selection, staticRange);
            return;
        }

        this.wrapContentInBlockquote(startNode, endNode, style);
        this.restoreStaticRange(selection, staticRange);
    }

    insertHtmlPopup(elem) {
        this.insertHtmlAtSelection(elem);
    }

    insertHTML(html) {
        this.insertHtmlAtSelection(html);
    }

    placeCaretAt(targetElem, collapseToStart = false) {
        if (!targetElem) {
            return;
        }

        const caretRange = this.createRange();
        const lastChild = targetElem.lastChild;
        const shouldCollapseToStart = collapseToStart || this.isBrElement(lastChild);

        try {
            caretRange.selectNodeContents(targetElem);
        } catch (e) {
            try {
                caretRange.selectNode(targetElem);
            } catch (ex) {
                console.warn('placeCaretAt: Cannot select target element', ex);
                return;
            }
        }

        try {
            const selection = this.getSelection();
            if (!selection) {
                console.warn('placeCaretAt: Cannot get selection');
                return;
            }

            selection.empty();
            caretRange.collapse(shouldCollapseToStart);
            selection.addRange(caretRange);
        } catch (e) {
            if (!this.isBody(targetElem)) {
                this.placeCaretAt(this.body, shouldCollapseToStart || false);
            } else {
                console.error('placeCaretAt: Failed to place caret', e);
            }
        }
    }

    insertNodeAtSelection(html) {
        const range = this.getRange();

        if (!range.collapsed) {
            range.deleteContents();
        }

        const shadow = this.createElement('temp-shadow');
        shadow.append(html);

        const newRange = this.createRange();
        newRange.selectNodeContents(shadow);

        range.insertNode(newRange.extractContents());
        range.collapse(false);

        const node = this.getRangeElement(range);
        node.normalize();
    }

    insertAIContents(html) {
        if (!html || typeof html !== 'string') {
            return;
        }

        this.editareaFocus();

        const placeholder = this.insertParagraph();
        const shadowNode = this.createElement('temp-shadow');
        shadowNode.insertAdjacentHTML('afterbegin', html);

        const lastChild = shadowNode.lastChild;

        while (shadowNode.firstChild) {
            placeholder.before(shadowNode.firstChild);
        }

        const range = this.getRange();
        if (lastChild) {
            range.setStartAfter(lastChild);
            range.collapse(true);
        }

        const selection = this.getSelection();
        selection.empty();
        selection.addRange(range);

        placeholder.remove();
    }

    insertHtmlAtSelection(html) {
        if (typeof html !== 'string') {
            return;
        }

        this.editareaFocus();

        let rng = this.getRange();
        const fragment = rng.createContextualFragment(html);

        rng.deleteContents();
        rng.insertNode(fragment);
        rng.collapse(false);

        const hasBlockParent = this.findClosestBlockElement(rng.startContainer);
        if (!hasBlockParent) {
            this.queryCommand('formatBlock', 'p');
            rng = this.getRange();
        }

        const containerNode = this.getRangeElement(rng);
        containerNode.normalize();

        const sel = this.getSelection();
        sel.empty();
        sel.addRange(rng);
    }

    applyLineHeight(opt) {
        const rng = this.getRange();
        const collapsed = rng.collapsed;
        const staticRange = this.createStaticRange(rng);
        const sel = this.getSelection();
        const { startContainer, endContainer } = staticRange;
        const startNode = this.findClosestBlockElement(startContainer);
        const endNode = this.findClosestBlockElement(endContainer);
        let rootNode = startNode;

        if (!startNode.contains(endNode)) {
            rootNode = rootNode.parentNode;
            while (rootNode && !rootNode.contains(endNode)) {
                rootNode = rootNode.parentNode;
            }
        }

        const walker = this.doc.createTreeWalker(rootNode,
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT,
            {
                acceptNode: function (node) {
                    if (collapsed) {
                        return NodeFilter.FILTER_ACCEPT;
                    }
                    return rng.intersectsNode(node)
                        ? NodeFilter.FILTER_ACCEPT
                        : NodeFilter.FILTER_REJECT;
                }
            });

        let curNode = startNode;
        walker.currentNode = curNode;

        let p = null;
        let applyNode = null;

        while (curNode) {
            if (applyNode && applyNode.contains(curNode)) {
                curNode = walker.nextNode();
                continue;
            }

            if (GB.TAGS.LINE_HEIGHT.has(curNode.nodeName)) {
                curNode.style.lineHeight = opt;
                applyNode = curNode;
                p = null;
                curNode = walker.nextNode();
            } else {
                const isTextOrInline = curNode.nodeType === Node.TEXT_NODE ||
                    this.isInlineElement(curNode.nodeName);

                if (isTextOrInline) {
                    if (!p) {
                        p = this.createElement('p');
                        p.style.lineHeight = opt;
                        curNode.before(p);
                    }
                    const next = walker.nextNode();
                    p.append(curNode);
                    curNode = next;
                } else {
                    p = null;
                    applyNode = null;
                    curNode = walker.nextNode();
                }
            }
        }

        this.restoreStaticRange(sel, staticRange);
    }

    processImage(data) {
        if (!data) {
            return null;
        }
        const createStyledElement = (tagName, style, attrs = []) => {
            const el = this.createElement(tagName);
            el.setAttribute('style', style);
            attrs.forEach(({name, value}) => el.setAttribute(name, value));
            return el;
        };

        const align = GB.STYLES.FIGURE.alignment;
        const fig = createStyledElement('figure', GB.STYLES.FIGURE.css, GB.STYLES.FIGURE.attrs);
        const pic = createStyledElement('picture', GB.STYLES.PICTURE);

        const createImage = (attr) => {
            const img = new Image();
            img.src =  attr.fileUrl;
            img.sizes = "100vw";
            img.srcset = `${attr.fileUrl} 2x`;
            img.width = attr.width;
            img.height = attr.height;
            img.setAttribute('style', GB.STYLES.IMAGE);
            img.setAttribute('alt',this.config.imgSetAttrAlt ? attr.origName : '');
            return img;
        };
        const createVideo = (attr) => {
            const vod = this.createElement('video');
            const src = this.createElement('source');
            let mimeType = attr.mimeType;
            const noVideoMessage = this.createEmptyParagraph();
            noVideoMessage.replaceChildren('죄송합니다. 현재 브라우저에서 이 비디오 영상을 재생할 수 없습니다.');

            if (attr.mimeType === 'video/quicktime') {
                mimeType = 'video/mp4; codecs="avc1.42e01e, mp4a.40.2"';
            }

            src.setAttribute('src', attr.fileUrl);
            src.setAttribute('type', mimeType);

            vod.append(src, noVideoMessage);
            vod.setAttribute('controls', 'true');
            vod.setAttribute('width', attr.width);
            vod.setAttribute('height', attr.height);
            vod.setAttribute('preload', 'auto');

            if (attr.video.autoplay) {
                vod.setAttribute('autoplay', 'true');
            }
            if (attr.video.loop) {
                vod.setAttribute('loop', 'true');
            }

            fig.classList.add('video');
            return vod;
        };

        let margin = null;
        if (data.alignment && Object.hasOwn(align, data.alignment)) {
            margin = align[data.alignment];
        }
        if (margin) {
            fig.style.margin = margin;
        }

        const shadow = this.createElement('temp-shadow');

        data.images.forEach((attr) => {
            const isVideo = this.isVideo(attr.mimeType);
            const img = isVideo ? createVideo(attr) : createImage(attr);
            const newFig = fig.cloneNode(false);

            if (!isVideo) {
                const newPic = pic.cloneNode(false);
                newPic.appendChild(img);
                newFig.appendChild(newPic);
            } else {
                newFig.appendChild(img);
            }

            shadow.appendChild(newFig);
        });

        return shadow;
    }

    isVideo(mimeType) {
        return GB.MIME_TYPES.VIDEO.includes(mimeType);
    }

    doInsertImage(data) {
        const shadow = this.processImage(data);
        if (!shadow) {
            return;
        }

        const p = this.insertParagraph();
        if (!p) {
            return;
        }

        const rng = this.createRange();
        rng.selectNodeContents(shadow);
        p.before(rng.extractContents());

        const nextSibling = p.nextSibling || p;
        if (nextSibling !== p) {
            p.remove();
        }

        data.images.forEach((img) => {
            if (img.video) {
                this.videos.push(img);
            } else {
                this.images.push(img);
            }
        })

        this.placeCaretAt(nextSibling, true);
    }

    insertVideo(data) {
        const fig = this.createElement('figure');
        fig.setAttribute('style', GB.STYLES.FIGURE.css);
        fig.setAttribute('contenteditable', 'false');
        fig.className = 'video';

        const rng = this.createRange();
        const wrapper = this.createElement('div');
        wrapper.className = 'video-wrapper';
        wrapper.appendChild(rng.createContextualFragment(data.source));
        fig.appendChild(wrapper);

        const p = this.insertParagraph();
        p.replaceWith(fig);
    }

    checkHyperLinks() {
        const links = this.doc.links;
        const len = links.length;
        const host = location.host;
        let i, href;

        this.cheditor.links = [];

        for (i = 0; i < len; i++) {
            if (!this.config.includeHostname) {
                href = links[i].href;
                if (href.indexOf(host) !== -1) {
                    links[i].setAttribute('href',
                        href.substring(href.indexOf(host) + host.length));
                }
            }
            if (this.config.linkTargetAttr) {
                if (!links[i].getAttribute('target')) {
                    links[i].setAttribute('target', this.config.linkTargetAttr);
                }
            }
        }
    }

    checkInsertedImages() {
        const images = this.doc.images;
        const len = images.length;
        const host = location.host;
        let i = 0, imgUrl;

        for (; i < len; i++) {
            if (!this.config.includeHostname) {
                imgUrl = images[i].src;
                if (imgUrl) {
                    if (imgUrl.indexOf(host) !== -1) {
                        images[i].src = imgUrl.substring(imgUrl.indexOf(host) + host.length);
                    }
                }
            }
            if (images[i].style.width) {
                images[i].removeAttribute('width');
            }
            if (images[i].style.height) {
                images[i].removeAttribute('height');
            }
        }
    }

    createNbspTextNode() {
        return this.doc.createTextNode('\u00a0');
    }

    getNodeTree(root, cb) {
        function Nodes(node) {
            this.node = node;
            this.name = node.nodeName.toLowerCase();
            this.type = node.nodeType;
            this.parent = node.parentNode;
            this.indent = 0;
            this.attrs = node.attributes;
            this.close = false;
            this.self_closing = true;
        }

        (function recurse(parentNode, indent) {
            let i,
                node = new Nodes(parentNode),
                nodes = parentNode.childNodes,
                len = nodes.length;

            node.indent = indent;

            if (!node.node.isSameNode(root)) {
                if (node.type === Node.ELEMENT_NODE &&
                    !GB.TAGS.VOID.has(node.node.nodeName))
                {
                    node.self_closing = false;
                }
                cb(node);
            }

            for (i = 0; i < len; i++) {
                recurse(nodes[i], indent + 1);
            }

            if (!node.self_closing) {
                node.close = true;
                cb(node);
            }
        })(root, -1);
    }

    domPurify(html, options = {}) {
        const defaultOptions = {
            FORBID_TAGS: this.config.blockTags,
            FORBID_ATTR: this.config.blockAttributes,
            ADD_TAGS: this.config.allowedTags,
            ADD_ATTR: this.config.allowedAttributes,
        };
        return CHEditorDOMPurify.sanitize(html, {...defaultOptions, ...options});
    }

    getContents(allowedIndent = false) {
        const self = this;
        const replaceOnEventAttributes = (content) =>
            this.config.allowedOnEvent
                ? content
                : content.replace(/\s+on([A-Za-z]+)=("[^"]*"|'[^']*'|[^\s>]*)/g, '');
        const replaceColorAttributes = (content) => {
            if (this.config.colorToHex) {
                return content.replace(
                    /(background-color|color)\s*([:=])\s*(rgba?)\(\s*(\d+)\s*,\s*(\d+),\s*(\d+)\)/ig,
                    (all, property, separator, rgb, r, g, b) =>
                        `${property}${separator} ${this.colorConvert(`${rgb}(${r},${g},${b})`, 'hex')}`
                );
            }
            return content.replace(
                /(background-color|color)\s*([:=])\s*(#[A-Fa-f0-9]{3,6})/ig,
                (all, property, separator, hex) =>
                    `${property}${separator} ${self.colorConvert(hex, 'rgb')}`
            );
        };

        this.checkHyperLinks();
        this.checkInsertedImages();

        let contents = this.getBodyHTML();
        contents = contents.replace(/^\s*[\r\n]/gm, '')
            .replace(/<[^>]+>/gm, (match) => {
                match = replaceOnEventAttributes(match);
                match = replaceColorAttributes(match);
                return match;
            });

        return allowedIndent ? this.indentHTML(contents) : contents;
    }

    htmlTokenize(html) {
        // 패턴 우선순위: 주석 → DOCTYPE → 닫는태그 → 여는태그 → 텍스트
        const RE =
            /(<!--[\s\S]*?-->)|(<!DOCTYPE[^>]*>)|(<\/([a-zA-Z][^\s>]*)([^>]*)>)|(<([a-zA-Z][^\s\/>]*)(\s[^>]*)?(\/?)>)|([^<]+)/gi;
        const tokens = [];
        let m;
        while ((m = RE.exec(html)) !== null) {
            const raw = m[0];
            if (m[1]) tokens.push({ type: 'comment', raw });
            else if (m[2]) tokens.push({ type: 'doctype', raw });
            else if (m[3]) tokens.push({ type: 'close', raw, tag: m[4].toUpperCase() });
            else if (m[6]) tokens.push({ type: 'open', raw, tag: m[7].toUpperCase(), selfClose: m[9] === '/' });
            else tokens.push({ type: 'text', raw });
        }
        return tokens;
    }

    isInlineable(tokens, i) {
        let depth = 1;
        let j = i + 1;
        while (j < tokens.length && depth > 0) {
            const t = tokens[j++];
            if (t.type === 'open' && !GB.TAGS.VOID.has(t.tag) && !t.selfClose) {
                if (this.isBlockElement(t.tag)) return false;
                depth++;
            } else if (t.type === 'close') depth--;
        }
        return true;
    }

    collectInline(tokens, start) {
        const parts = [tokens[start].raw];
        let depth = 1;
        let j = start + 1;
        while (j < tokens.length && depth > 0) {
            const t = tokens[j++];
            parts.push(t.raw);
            if (t.type === 'open' && !GB.TAGS.VOID.has(t.tag) && !t.selfClose) depth++;
            else if (t.type === 'close') depth--;
        }
        return { text: parts.join('').replace(/\s+/g, ' '), end: j - 1 };
    }

    indentHTML(html) {
        const tokens = this.htmlTokenize(html);
        const lines = [];
        const indent = this.config.tabIndent || '  ';
        let level = 0;
        let inRaw = false;
        let rawTag = '';
        let rawBuf = [];

        for (let i = 0; i < tokens.length; i++) {
            const tok = tokens[i];
            if (inRaw) {
                if (tok.type === 'close' && tok.tag === rawTag) {
                    const inner = rawBuf.join('');
                    const pad = indent.repeat(level);
                    if (inner.includes('\n')) {
                        inner.split('\n').forEach(line => lines.push(pad + indent + line));
                    } else if (inner.trim()) {
                        lines[lines.length - 1] += inner;
                    }
                    lines.push(pad + tok.raw);
                    inRaw = false;
                    rawTag = '';
                    rawBuf = [];
                } else {
                    rawBuf.push(tok.raw);
                }
                continue;
            }
            const pad = indent.repeat(level);
            switch (tok.type) {
                case 'doctype':
                case 'comment':
                    lines.push(pad + tok.raw);
                    break;
                case 'open': {
                    const tag = tok.tag;
                    if (GB.TAGS.RAW.has(tag)) {
                        lines.push(pad + tok.raw);
                        inRaw = true; rawTag = tag;
                        break;
                    }
                    if (GB.TAGS.VOID.has(tag) || tok.selfClose) {
                        lines.push(pad + tok.raw);
                        break;
                    }
                    if (this.isInlineable(tokens, i)) {
                        const { text, end } = this.collectInline(tokens, i);
                        lines.push(pad + text);
                        i = end;
                    } else {
                        lines.push(pad + tok.raw);
                        level++;
                    }
                    break;
                }
                case 'close':
                    if (!GB.TAGS.VOID.has(tok.tag)) {
                        level = Math.max(0, level - 1);
                        lines.push(indent.repeat(level) + tok.raw);
                    }
                    break;
                case 'text': {
                    const text = tok.raw.trim();
                    if (text) lines.push(pad + text);
                    break;
                }
            }
        }
        return lines.join('\n');
    }

    returnContents(html) {
        this.setDesignMode(true);
        this.cheditor.inputForm.value = html;
        return html;
    }

    br2nl(html, mode) {
        return html.replace(/<\/?(br|br[\s/]+?[^>]*?)>/ig, mode ? '\n' : '');
    }

    nl2br(text, mode) {
        return (text + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
            mode ? '$1<br>' : '$1<br>$2');
    }

    removeNls(text) {
        return (text + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)\s*/g, '$1');
    }

    removeEmptyTags(text) {
        const re = /<(?<open>\w+)[^>]*?><\/(?<close>[^>]+)>/g;
        let cleanedText = this.removeNls(text);
        let match;

        while ((match = re.exec(cleanedText)) !== null) {
            if (match.groups.open === match.groups.close) {
                const beforeMatch = cleanedText.substring(0, match.index);
                cleanedText = beforeMatch + cleanedText.substring(match.index + match[0].length);
                re.lastIndex = 0;
            }
        }

       return cleanedText;
    }

    removeEmptyNode(node) {
        if (!node.hasChildNodes()) {
            node.remove();
        }
    }

    escapeHTML(html) {
        return html.replace(GB.HTML_ENTITY.ESCAPE.regex, char => GB.HTML_ENTITY.ESCAPE.map[char] || char);
    }

    unescapeHTML(text) {
        return text.replace(GB.HTML_ENTITY.UNESCAPE.regex, char => GB.HTML_ENTITY.UNESCAPE.map[char] || char);
    }

    getOutputContents() {
        return this.removeNls(this.getBodyContents());
    }

    createOutputHTML() {
        const contents = `
        <!DOCTYPE html>
        <html lang="ko">
          <head>
            <title>${this.config.docTitle}</title>
          </head>
          <body>
          ${this.getBodyContents()}
          </body>
        </html>`;
        return this.removeNls(contents);
    }

    outputHTML() {
        return this.returnContents(this.createOutputHTML());
    }

    getBodyContents() {
        this.clearHelperNodes();
        return this.getContents();
    }

    outputBodyHTML() {
        return this.returnContents(this.getOutputContents());
    }

    outputBodyText() {
        return this.returnContents(this.getBodyText());
    }

    getBodyHTML(includeBodyTag = false) {
        return includeBodyTag ? this.body.outerHTML : this.getInnerHTML(this.body);
    }

    getBodyText() {
        return this.trimSpace(this.body.textContent);
    }

    getFiles() {
        return { images: this.getImages(), videos: this.getVideos() };
    }

    getImages() {
        const docImages = [...this.doc.querySelectorAll('img')];
        return this.images.filter(img => {
            const docImg = docImages.find(docImg => docImg.src === img.fileUrl);
            return docImg ? docImg.complete && docImg.naturalWidth > 0 : false;
        });
    }

    getVideos() {
        const docVideos = [...this.doc.querySelectorAll('source')];
        return this.videos.filter(vod => {
            const docVod = docVideos.find(docVod => docVod.src === vod.fileUrl);
            return !!docVod;
        });
    }

    returnFalse() {
        let images = this.doc.images, i;
        this.editareaFocus();

        for (i = 0; i < images.length; i++) {
            const image = images[i];
            if (image.src) {
                if (image.getAttribute('onload')) {
                    image.onload = 'true';
                }
            } else {
                images.removeAttribute('onload');
                images.removeAttribute('className');
            }
        }
        return false;
    }

    removeZeroSpace(text) {
        if (typeof text !== 'string') return '';
        return text.replace(GB.SPECIAL_CHARS.ZERO_WIDTH_REGEX, '');
    }

    trimSpace(text) {
        if (typeof text !== 'string') return '';
        return text.trim().replace(GB.SPECIAL_CHARS.ZERO_WIDTH_TRIM_REGEX, '');
    }

    makeRandomString() {
        const chars  = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz';
        const len = 16;
        let rand = '';

        for (let i = 0; i < len; i++) {
            rand += chars[Math.floor(Math.random() * chars.length)];
        }

        return rand;
    }

    calcContentsLength(str) {
        let len = str.length, multiBytes = 0, i, c;

        for (i = 0; i < len; i++) {
            c = str.charCodeAt(i);
            if (c > 128) {
                multiBytes++;
            }
        }

        return len - multiBytes + multiBytes * 2;
    }

    contentsLengthAll() {
        return this.calcContentsLength(this.createOutputHTML());
    }

    contentsLength() {
        const content = this.trimSpace(this.getOutputContents());
        if (!content) {
            return 0;
        }
        return this.calcContentsLength(content);
    }

    inputLength() {
        const content = this.getBodyText();
        if (!content) {
            return 0;
        }
        return this.calcContentsLength(content);
    }

    showDropdownMenu(button, id) {
        const dropdown = this.dropdown[id];
        this.backupRange();
        this.closeDropdownMenu(id);

        dropdown.querySelectorAll('.dropdown-item').forEach(elem => {
            if (elem.dataset.value === this.toolbar[id].data) {
                elem.classList.add('active');
            } else {
                elem.classList.remove('active');
            }
        });

        dropdown.popper.update();
        dropdown.classList.remove('d-none');

        setTimeout(() => {
            this.removeEvent(dropdown, 'transitionend', this.dropdownEffectEvent);
            dropdown.classList.add('show');
        }, 10);

        dropdown.style.zIndex = (this.modalZIndex + 1).toString();

        const dropdownShowEvent = new CustomEvent('dropdown-show', {
            cancelable: true,
            bubbles: true,
            detail: id
        });
        this.doc.dispatchEvent(dropdownShowEvent);
    }

    dropdownEffectEvent(evt) {
        evt.target.classList.add('d-none');
    }

    closeDropdownMenu(showId = null) {
        for (const btn in this.dropdown) {
            const dropdown = this.dropdown[btn];

            if (dropdown.classList.contains('show')) {
                this.addEvent(dropdown, 'transitionend', this.dropdownEffectEvent);
                dropdown.classList.remove('show');
            }

            const displayNone = !showId ? true : btn !== showId;

            if (displayNone && this.toolbar[btn].checked) {
                this.toolbar[btn].checked = false;
                this.toolbar[btn].elem.classList.remove('active');
            }
        }
    }

    createDropdown(name, width, elem, button, className = null) {
        const dropdown = this.createElement('div');
        let popperRefNode = button;

        if (name === 'UnOrderedListCombo' || name === 'OrderedListCombo') {
            popperRefNode = popperRefNode.previousElementSibling;
        }

        dropdown['popper'] = this.createPopper(popperRefNode, dropdown, {
            placement: 'bottom-start',
            modifiers: [{
                name: 'offset', options: {offset: [0, 2]}
            }]
        });

        elem.className = "dropdown-container";
        if (width > 0) {
            elem.style.setProperty("width", `${width}px`, "important");
        }

        if (elem.childElementCount > 0) {
            for (const child of elem.children) {
                if (!child.classList.contains("dropdown-item-quote") &&
                    !child.classList.contains("table-container")) {
                    child.classList.add("dropdown-item");
                    if (className) {
                        child.classList.add(className);
                    }
                }
            }
        }

        dropdown.className = 'dropdown-frame fade d-none';
        dropdown.append(elem);

        this.dropdown[name] = dropdown;
        this.cheditor.toolbarWrapper.append(dropdown);
    }

    createTableDropdown() {
        const TABLE_CELL_SIZE = 15;
        const CLASS_NAMES = {
            dropdown: 'dropdown-item-table',
            container: 'table-container',
            outer: 'table-outer',
            info: 'info',
        };
        const dropdown = this.createElement('div');
        const outer = dropdown.cloneNode(false);
        const container = dropdown.cloneNode(false);
        const info = dropdown.cloneNode(false);
        const maxRow = GB.STYLES.DEFAULT_TABLE.rows;
        const maxCol = GB.STYLES.DEFAULT_TABLE.cols;
        const table = this.createElement('table');

        for (let i = 0; i < maxRow; i++) {
            const row = table.insertRow();
            for (let j = 0; j < maxCol; j++) {
                const cell = row.insertCell();
                cell.append(GB.SPECIAL_CHARS.ZERO_WIDTH_SPACE);
            }
        }

        outer.append(table);
        dropdown.className = CLASS_NAMES.dropdown;
        container.className = CLASS_NAMES.container;
        outer.className = CLASS_NAMES.outer;
        info.className = CLASS_NAMES.info;

        container.append(outer, info);
        dropdown.append(container);

        const updateSelection = (row, col) => {
            for (let i = 0; i < maxRow; i++) {
                for (let j = 0; j < maxCol; j++) {
                    const cell = table.rows[i].cells[j];
                    if (i + 1 <= row && j + 1 <= col) {
                        cell.className = 'selected';
                        info.dataset.row = String(i + 1);
                        info.dataset.col = String(j + 1);
                        info.textContent = `${i + 1} X ${j + 1}`;
                    } else {
                        cell.removeAttribute('class');
                    }
                }
            }
        };

        this.addEvent(this.doc, 'dropdown-show', (evt) => {
            this.stopEvent(evt);
            if (evt.detail === 'Table') {
                updateSelection(1, 1);
            }
        });

        let prevRow = 1, prevCol = 1;

        this.addEvent(outer, 'mousemove', (evt) => {
            const rect = outer.getBoundingClientRect();
            const row = Math.min(Math.max(Math.ceil((evt.clientY - rect.top) / TABLE_CELL_SIZE), 1), maxRow);
            const col = Math.min(Math.max(Math.ceil((evt.clientX - rect.left) / TABLE_CELL_SIZE), 1), maxCol);

            if (prevRow !== row || prevCol !== col) {
                updateSelection(row, col);
                prevRow = row;
                prevCol = col;
            }
        });

        this.addEvent(outer, 'mouseup', (evt) => {
            this.stopEvent(evt);
            this.closeDropdownMenu();
            this.createTable(info.dataset.row, info.dataset.col);
        });

        return dropdown;
    }

    createTableEventHandler(table, figure = null) {
        const RESIZER_POSITION_ADJUSTMENT = 4.5;
        const columnsResizer = [];
        let columnMinWidth = parseFloat(this.getComputedStyleValue(this.doc.documentElement, 'font-size'));
        let cursorStartX = 0;
        let currColumn = null;
        let currColumnWidth = 0;
        let nextColumn = null;
        let nextColumnWidth = 0;
        let figureRect = null;
        let currResizer = null;
        let isDragging = false;
        let rootNodeWidth = 0;
        let figureWidth = 0;
        let isMouseLeave = false;
        let minTableWidth = 0;
        let targetColumn = null;

        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const cell = entry.target;
                const rect = cell.getBoundingClientRect();
                const resizer = columnsResizer[cell.cellIndex];
                resizer.style.left = setResizerPosition(rect.right, figureRect.left);
            }
        });

        if (columnMinWidth < 15) {
            columnMinWidth *= 2;
        }

        if (!figure) {
            figure = table.closest('figure');
            if (!figure) {
                figure = this.createElement('figure');
                const range = this.createRange();
                range.selectNode(table);
                range.surroundContents(figure);
            }
            figure.setAttribute('style', GB.STYLES.FIGURE.css);
            figure.setAttribute('contenteditable', 'false');
        }

        const setResizerPosition = (x1, x2) => {
            return `${x1 - (x2 + RESIZER_POSITION_ADJUSTMENT)}px`;
        };

        const columnResizeHandler = (evt) => {
            if (evt.movementX === 0) {
                return;
            }
            const movementX = evt.pageX - cursorStartX;
            const updateCurrColumnWidth = currColumnWidth + movementX;
            let updateNextColumnWidth = 0;

            if (nextColumn) {
                updateNextColumnWidth = nextColumnWidth - movementX;

                if (updateCurrColumnWidth < columnMinWidth || updateNextColumnWidth < columnMinWidth) {
                    this.stopEvent(evt);
                    return;
                }

                targetColumn.style.width =
                    `${((updateCurrColumnWidth / figureWidth) * 100).toFixed(2)}%`;
                nextColumn.style.width = `${((updateNextColumnWidth / figureWidth) * 100).toFixed(2)}%`;
            } else {
                const updateFigureWidth = figureWidth + (movementX * 2);
                let newFigureWidth = ((updateFigureWidth / rootNodeWidth) * 100).toFixed(2);

                if (updateFigureWidth < minTableWidth) {
                    this.stopEvent(evt);
                    return;
                }

                if (newFigureWidth > 100) {
                    this.stopEvent(evt);
                    newFigureWidth = 100;
                }

                figure.style.width = `${newFigureWidth}%`;
                figureRect = figure.getBoundingClientRect();
            }
        };

        const removeResizer = () => {
            columnsResizer.forEach(rect => rect.remove());
            columnsResizer.length = 0;
        };

        this.addEvent(figure, 'mouseenter', (evt) => {
            isMouseLeave = false;

            if (isDragging) {
                this.stopEvent(evt);
                return;
            }

            this.createTableButton(figure);

            const columnResizer = this.createElement('div');
            const colGroup = figure.querySelector('table colgroup');

            columnResizer.className = 'table-col-resizer';
            figureRect = figure.getBoundingClientRect();

            const stopResizerHandler = () => {
                this.removeEvent(this.doc, 'mousemove', columnResizeHandler);
                this.removeEvent(this.doc, 'mouseup', stopResizerHandler);
                isDragging = false;

                figure.classList.remove('col-resizing');

                if (isMouseLeave) {
                    removeResizer();
                    this.removeTableButton(figure);
                    return;
                }

                currResizer.classList.remove('active');
            };
            const getColumnsRect = () => {
                const row = table.rows[0];
                return [...row.cells].map((cell, idx, cells) => {
                    const rect = cell.getBoundingClientRect();
                    const isLast = idx === cells.length - 1;
                    rect.node = cell;
                    rect.col = colGroup.children[idx];
                    rect.nextCol = isLast ? null : colGroup.children[idx + 1];
                    rect.nextCell = isLast ? null : cells[idx + 1];
                    rect.index = idx;
                    rect.isLastChild = isLast;
                    return rect;
                });
            };
            const createResizerNodes = () => {
                const columnsRect = getColumnsRect();

                minTableWidth = columnsRect.length * columnMinWidth;

                columnsRect.forEach((rect) => {
                    const cloneResizer = columnResizer.cloneNode(false);
                    cloneResizer.style.left = setResizerPosition(rect.right, figureRect.left);
                    figure.append(cloneResizer);
                    columnsResizer.push(cloneResizer);

                    resizeObserver.observe(rect.node);

                    if (rect.isLastChild) {
                        cloneResizer.classList.add('last-child');
                    }

                    this.addEvent(cloneResizer, 'mousedown', (evt) => {
                        this.stopEvent(evt);

                        currColumn = rect.node;
                        cursorStartX = evt.pageX;
                        currColumnWidth = currColumn.getBoundingClientRect().width;
                        currResizer = cloneResizer;
                        currResizer.dataset.column = String(rect.index);
                        currResizer.classList.add('active');
                        isDragging = true;
                        rootNodeWidth = this.getElementWidth(figure.parentElement);
                        figureWidth = this.getElementWidth(figure);
                        figure.classList.add('col-resizing');

                        targetColumn = rect.col;
                        nextColumn = rect.nextCol;

                        if (nextColumn) {
                            nextColumnWidth = rect.nextCell.getBoundingClientRect().width;
                        }

                        this.addEvent(this.doc, 'mousemove', columnResizeHandler);
                        this.addEvent(this.doc, 'mouseup', stopResizerHandler);
                    });
                });
            };

            createResizerNodes();
        });

        this.addEvent(figure, 'mouseleave', () => {
            if (!isDragging) {
                resizeObserver.disconnect();
                removeResizer();
                this.removeTableButton(figure);
            }
            isMouseLeave = true;
        });
    }

    createTableColumnGroup(count) {
        const PERCENTAGE_WIDTH = (100 / count).toFixed(2);
        const colGroup = this.createElement('colgroup');
        for (let i = 0; i < count; i++) {
            const col = this.createElement('col');
            col.style.width = `${PERCENTAGE_WIDTH}%`;
            colGroup.append(col);
        }
        return colGroup;
    }

    insertTableRows(table, rowCount, colCount) {
        for (let i = 0; i < rowCount; i++) {
            const row = table.insertRow();
            this.insertTableCells(row, colCount);
        }
        return table;
    }

    insertTableCells(row, count) {
        for (let i = 0; i < count; i++) {
           const cell = row.insertCell();
           cell.append(this.createElement('br'));
        }
    }

    applyTableCellAttributes(cell) {
        cell.setAttribute('contenteditable', 'true');
        cell.setAttribute('style', GB.STYLES.DEFAULT_TABLE.cell);
    }

    applyTableCellsAttributes(cells) {
        cells.forEach(cell => this.applyTableCellAttributes(cell));
    }

    createTable(rowCount, colCount) {
        const TABLE_STYLE = GB.STYLES.DEFAULT_TABLE.table;
        const FIGURE_STYLE = GB.STYLES.FIGURE.css;

        // Step 1: 테이블 행, 열 생성
        const table = this.createElement('table');
        table.prepend(this.createTableColumnGroup(colCount));
        this.insertTableRows(table, rowCount, colCount);

        // 테이블 속성 지정
        const tableId = this.makeRandomString();
        table.id = tableId;
        table.setAttribute('style', TABLE_STYLE);

        // Step 2: 테이블 삽입
        this.queryCommand('insertHTML', table.outerHTML);
        this.editareaFocus();

        const insertedTable = this.doc.getElementById(tableId);
        const firstCell = insertedTable.querySelector('td');
        insertedTable.removeAttribute('id');
        this.applyTableCellsAttributes([...insertedTable.querySelectorAll('td')]);

        // Step 3: 테이블을 figure로 감싸서 이벤트 처리
        const figure = this.createElement('figure');
        const range = this.createRange();
        range.selectNode(insertedTable);
        range.surroundContents(figure);
        figure.setAttribute('style', FIGURE_STYLE);
        figure.setAttribute('contenteditable', 'false');
        figure.className = 'table';

        // Step 4: 테이블 컬럼 크기 조절, 이벤트 처리
        this.createTableEventHandler(insertedTable, figure);

        this.placeCaretAt(firstCell);
    }

    setColorTable(aCommand) {
        const TOOLTIP_SHOW = '더 많은 색 보기';
        const TOOLTIP_HIDE = '감추기';
        const createElementWithClass = (tag, className, attrs = null) => {
            const elem = this.createElement(tag);
            if (className) {
                elem.className = className;
            }
            if (!attrs) {
                return elem;
            }

            Object.entries(attrs).forEach(([attr, value]) => {
                value = value.toString();
                if (value.startsWith('rgba')) {
                    elem.classList.add('remove');
                } else {
                    elem.style.backgroundColor = value;
                }
                elem.setAttribute(attr, value);
            });

            return elem;
        };
        const buildColorCell = color => {
            const cellBorder = createElementWithClass('span', 'color-cell');
            const cell = createElementWithClass('span', 'color', {'data-color': color});
            cell.textContent = '\u00a0';
            cell.onclick = evt => this.doCmdPopup(aCommand, evt.target.dataset.color);
            cell.onmouseover = evt => colorPicker.fromString(evt.target.dataset.color);
            cellBorder.appendChild(cell);
            return cellBorder;
        };
        const togglePickerVisibility = () => {
            const colorNode = this.toolbar[aCommand].colorNode;
            const isVisible = colorNode.showPicker;
            const newState = !isVisible;

            colorPicker[newState ? 'showPicker' : 'hidePicker']();
            colorNode.showPicker = newState;
            pickerSwitch.setAttribute('title', newState ? TOOLTIP_HIDE : TOOLTIP_SHOW);
        };

        const dropdown = this.createElement('div');
        const container = createElementWithClass('div', 'color-container');
        const selected = createElementWithClass('input', '', {type: 'text', maxlength: '7', spellcheck: 'false'});
        const selectedValue = createElementWithClass('input', '', {type: 'text'});
        const paletteWrapper = createElementWithClass('div', 'palette-wrapper', {style: 'position:relative'});
        const pickerSwitch = createElementWithClass('span', 'show-picker', {'title': TOOLTIP_SHOW});
        const submitButton = createElementWithClass('span', 'btn btn-xs');
        const palette = createElementWithClass('div', 'palette');
        const inputGroup = createElementWithClass('div', 'input-wrapper');
        const colorPicker = new GB.colorDropper(selected, {iconDir: this.config.path.icon});

        GB.COLORS.forEach(color => palette.appendChild(buildColorCell(color)));

        selectedValue.onfocus = () => selected.focus();
        pickerSwitch.textContent = '\u00a0';
        pickerSwitch.onclick = togglePickerVisibility;
        submitButton.onclick = () => this.doCmdPopup(aCommand, selected.value);

        inputGroup.append(selectedValue, selected, pickerSwitch, submitButton);
        paletteWrapper.append(palette, inputGroup);
        container.appendChild(paletteWrapper);
        dropdown.appendChild(container);

        Object.assign(this.toolbar[aCommand].colorNode, {selectedValue, colorPicker});
        return dropdown;
    }

    isElementNode(node) {
        return !!node && node.nodeType === Node.ELEMENT_NODE;
    }

    isTextNode(node) {
        return !!node && node.nodeType === Node.TEXT_NODE;
    }

    getParentIfTextNode(node) {
        return this.isTextNode(node) ? node.parentNode : node;
    }

    removeInvisibleText(removeNode, cb) {
        const node = cb(removeNode);
        removeNode.remove();
        return node;
    }

    handleForceElementRemove(node) {
        if (!node || node.nodeType !== Node.ELEMENT_NODE) {
            return;
        }

        try {
            const nodeName = node.nodeName;
            if (nodeName !== 'FIGURE') {
                this.removeNode(node);
                return;
            }

            const hasImage = node.querySelector(':scope > picture > img, :scope > img');
            if (hasImage) {
                this.createImageFigure(node);
                return;
            }
            if (node.classList?.contains('video')) {
                this.handleFigureCommand(node);
                return;
            }

            this.removeNode(node);
        } catch (error) {
            console.error('handleForceElementRemove failed:', error);
            try {
                if (node.isConnected) {
                    this.removeNode(node);
                }
            } catch (_) { }
        }
    }

    handleBackwardDelete(node) {
        let prevNode = this.getPreviousSibling(node);
        return this.processInvisibleText(prevNode, this.getPreviousSibling);
    }

    handleForwardDelete(node) {
        if (!node) return null;
        const nextNode = this.getNextSibling(node);
        return this.normalizeForwardDeleteCandidate(nextNode);
    }

    normalizeForwardDeleteCandidate(node) {
        let currNode = node;
        let steps = 0;
        const MAX_STEPS = 1000;

        while (currNode && steps < MAX_STEPS) {
            const processedNode = this.processInvisibleText(currNode, (n) => this.getNextSibling(n));
            if (processedNode !== currNode) {
                currNode = processedNode;
                steps++;
                continue;
            }
            if (this.isBrElement(currNode)) {
                const nextNode = this.getNextSibling(currNode);
                if (nextNode === currNode) {
                    break;
                }
                currNode = nextNode;
            }
            break;
        }

        return currNode || null;
    }

    processInvisibleText(node, siblingGetter) {
        let currNode = node;
        let steps = 0;
        const MAX_STEPS = 1000;

        while (currNode && this.isTextNode(currNode) && !this.isTextVisible(currNode.data)) {
            const nextNode = this.removeInvisibleText(currNode, siblingGetter);
            if (nextNode === currNode) {
                break;
            }

            currNode = nextNode;

            if (++steps >= MAX_STEPS) {
                break;
            }
        }

        return currNode;
    }

    removeNodeFromKeyEvent(node, direction) {
        let currNode = node;

        currNode = direction === 'backward'
            ? this.handleBackwardDelete(currNode)
            : this.handleForwardDelete(currNode);

        if (!currNode || this.isBody(currNode)) {
            return false;
        }

        if (this.isForceRemoveElement(currNode)) {
            this.handleForceElementRemove(currNode);
            return true;
        }

        return false;
    }

    docSelectionChangeEventHandler(evt) {
        // const caret = this.hasBogusCaret();
        // if (caret && !caret.hasInputFocus()) {
        //     this.removeElementController();
        // }
        this.editareaEventHandler(evt);
    }

    modifySelectionAndGetPosition(selection, direction, cloneRange) {
        const fallbackResult = () => {
            const refRange = this.getRange();
            return {
                refRange,
                refOffset: refRange.startOffset,
                refNode: refRange.startContainer,
                emptyParagraph: this.isEmptyParagraph(refRange.commonAncestorContainer),
                comparePos: GB.COMPARE_POS.before
            };
        };

        if (!selection || typeof selection.modify !== 'function') {
            return fallbackResult();
        }

        try {
            selection.modify("extend", direction, "lineBoundary");
        } catch (error) {
            return fallbackResult();
        }

        const refRange = this.getRange();
        const refOffset = refRange.startOffset;
        const refNode = refRange.startContainer;
        const emptyParagraph = this.isEmptyParagraph(refRange.commonAncestorContainer);

        let isCollapsed = refRange.collapsed;
        if (!isCollapsed) {
            try {
                const rect = refRange.getBoundingClientRect();
                isCollapsed = !rect || rect.width < 1 || rect.height < 1;
            } catch (error) {
                isCollapsed = false;
            }
        }

        let comparePos = GB.COMPARE_POS.before;
        if (!isCollapsed && cloneRange && typeof cloneRange.comparePoint === 'function') {
            try {
                comparePos = cloneRange.comparePoint(refNode, refOffset);
                if (comparePos === GB.COMPARE_POS.before) {
                    comparePos = GB.COMPARE_POS.after;
                }
            } catch (error) {
                comparePos = GB.COMPARE_POS.before;
            }
        }

        selection.empty();
        selection.addRange(cloneRange);

        return { refRange, refOffset, refNode, emptyParagraph, comparePos };
    }

    processNodeRemoval(refNode, refOffset, direction, comparePos) {
        const isValidDirection = direction === 'forward' || direction === 'backward';
        if (!refNode || !isValidDirection) {
            return { direction, comparePos };
        }

        let nextComparePos = comparePos;

        if (comparePos === GB.COMPARE_POS.before) {
            nextComparePos = this.resolveBeforeNodeRemoval(refNode, refOffset, direction);
        } else if (comparePos === GB.COMPARE_POS.after) {
            nextComparePos = this.resolveAfterNodeRemoval(refNode, direction);
        }

        return { direction, comparePos: nextComparePos };
    }

    resolveBeforeNodeRemoval(refNode, refOffset, direction) {
        if (direction === 'backward') {
            return refOffset > 0
                ? GB.COMPARE_POS.backward
                : GB.COMPARE_POS.before;
        }

        if (!this.isElementNode(refNode)) {
            return GB.COMPARE_POS.before;
        }

        const childNodes = refNode.childNodes;
        if (refOffset < 0 || refOffset >= childNodes.length) {
            return GB.COMPARE_POS.before;
        }

        const currNode = childNodes[refOffset];
        if (!this.isBrElement(currNode)) {
            return GB.COMPARE_POS.before;
        }

        const nextNode = this.processInvisibleText(
            currNode,
            (node) => this.getNextSibling(node)
        );

        return nextNode && refNode.lastChild === nextNode
            ? GB.COMPARE_POS.before
            : GB.COMPARE_POS.after;
    }

    resolveAfterNodeRemoval(refNode, direction) {
        const textContent = refNode.textContent || '';

        if (direction === 'backward' && textContent.includes('\n')) {
            refNode.textContent = textContent.replace(/^\n+/, '');
            return GB.COMPARE_POS.before;
        }

        if (direction === 'forward' && textContent.length === 0) {
            return GB.COMPARE_POS.before;
        }

        return GB.COMPARE_POS.after;
    }

    validateEmptyParagraph(direction, emptyParagraph) {
        return direction === 'backward' &&
            emptyParagraph &&
            this.body.firstChild.isSameNode(emptyParagraph);
    }

    handleImageNodeInRange(range, selection) {
        if (range.endContainer.nodeName === 'IMG') {
            let prevNode = this.getPreviousSibling(range.endContainer);
            if (prevNode) {
                if (this.isTextNode(prevNode) && !this.isTextVisible(prevNode.data)) {
                    prevNode = this.getPreviousSibling(prevNode);
                }
                range.setEndBefore(prevNode.nextSibling);
                selection.empty();
                selection.addRange(range);
            }
            return true;
        } else if (range.startContainer.nodeName === 'IMG') {
            let nextNode = this.getNextSibling(range.startContainer);
            if (nextNode) {
                range.setStart(nextNode, 0);
                selection.empty();
                selection.addRange(range);
            }
            return true;
        }
        return false;
    }

    handleBogusCaretRemoval() {
        const fakeCaret = this.hasBogusCaret();

        if (fakeCaret && fakeCaret.hasCaret) {
            const figure = fakeCaret.fakeNode?.targetNode;

            if (figure) {
                if (this.removeNode(figure)) {
                    this.removeElementController();
                    return true;
                }
            }
        }

        return false;
    }

    keyDirection(keyName) {
       return keyName === 'Delete' ? 'forward' : 'backward';
    }

    prepareDeletionContext(evt) {
        const range = this.getRange();

        return {
            selection: this.getSelection(),
            range: range,
            cloneRange: range.cloneRange(),
            direction: this.keyDirection(evt.key)
        };
    }

    handleCollapsedDeletion(evt, selection, direction, cloneRange) {
        const {
            refNode,
            refOffset,
            emptyParagraph,
            comparePos: initialComparePos,
        } = this.modifySelectionAndGetPosition(selection, direction, cloneRange);

        const {
            direction: updatedDirection,
            comparePos,
        } = this.processNodeRemoval(refNode, refOffset, direction, initialComparePos);

        if (comparePos === GB.COMPARE_POS.before) {
            const stopEvent = this.removeNodeFromKeyEvent(refNode, updatedDirection);

            if (stopEvent && emptyParagraph) {
                this.removeNode(emptyParagraph);
            }
            if (stopEvent) {
                this.stopEvent(evt);
                return;
            }
        }
        if (this.handleBogusCaretRemoval()) {
            this.stopEvent(evt);
        }
    }

    handleRangeDeletion(evt, range, selection) {
        this.handleImageNodeInRange(range, selection);
        const stopEvent = this.handleBogusCaretRemoval();
        if (stopEvent) {
            this.stopEvent(evt);
        }
    }

    handleDeleteKeyPress(evt) {
        const { selection, range, cloneRange, direction } = this.prepareDeletionContext(evt);

        if (!selection.isCollapsed) {
            this.handleRangeDeletion(evt, range, selection);
            return;
        }

        this.handleCollapsedDeletion(evt, selection, direction, cloneRange);
    }

    onKeydown(evt) {
        if (!GB.KEY_NAMES.DELETE.has(evt.key)) {
            return;
        }
        this.handleDeleteKeyPress(evt);
    }

    onKeyup(evt) {
        const { key } = evt;

        if (!GB.KEY_NAMES.ALLOW_KEY_UP.has(key)) {
            return;
        }

        const selection = this.getSelection();
        const { anchorNode, anchorOffset } = selection;

        if (!anchorNode) {
            return;
        }

        if (key === 'Enter') {
            this.handleEnterKeyUp(anchorNode);
        } else {
            const direction = this.keyDirection(key);
            this.handleDeletionKeyUp(selection, anchorNode, anchorOffset, direction);
        }
    }

    handleEnterKeyUp(anchorNode) {
        const anchorEl = this.getParentIfTextNode(anchorNode);
        if (anchorEl) {
            // this.updateToolbar();
        }
    }

    handleDeletionKeyUp(selection, anchorNode, anchorOffset, direction) {
        const brElem = this.findTargetBrElement(selection, anchorNode, anchorOffset, direction);
        if (!brElem) {
            return;
        }

        const staticRange = this.createStaticRange();
        this.setSelectionLine();

        const range = this.getRange();
        const isLineEmpty = range.getBoundingClientRect().width === 0;

        if (isLineEmpty) {
            this.handleEmptyLineReplacement(brElem, selection);
        } else {
            this.restoreStaticRange(selection, staticRange);
        }
    }

    findTargetBrElement(selection, anchorNode, anchorOffset, direction) {
        if (direction === 'forward' && this.isTextNode(anchorNode) && !this.isTextVisible(anchorNode.textContent)) {
            const br = this.isBrElement(anchorNode.nextSibling);
            if (br) {
                selection.setPosition(br);
                return br;
            }
        }
        return this.isBrElement(anchorNode?.childNodes[anchorOffset]);
    }

    findTargetAncestor(node) {
        let curNode = node.parentNode;
        while (curNode && !GB.TAGS.REMOVE_BREAK.has(curNode.nodeName)) {
            curNode = curNode.parentNode;
        }
        return curNode;
    }

    handleEmptyLineReplacement(br, sel) {
        const tgtEl = this.findTargetAncestor(br);
        if (!tgtEl) return;

        if (this.isBody(tgtEl)) {
            const p = this.createEmptyParagraph();
            br.replaceWith(p);
            sel.setPosition(p, 0);
        }
    }

    onKeypress(evt) {
        if (evt.key !== 'Enter') return;

        const caret = this.hasBogusCaret();
        if (caret) {
            this.stopEvent(evt);
            const node = caret.fakeNode?.targetNode;
            if (!caret.hasInputFocus(evt.target)) {
                this.insertParagraphTopBottom('insert-paragraph-bottom', node, this.getSelection());
            }
        }

        this.setDefaultParagraphSeparator();
    }
    
    removeNodeTarget(node, sel = null, res = false) {
        if (!node) {
            return res;
        }
        node.remove();
        return true;
    }

    removeNodeProxy(func) {
        const self = this;

        return new Proxy(func, {
            apply(target, editorInstance, args) {
                const tgtNode = args[0];

                if (self.isForceRemoveElement(tgtNode)) {
                    const sel = args[1] ??= self.getSelection();
                    const p = self.createEmptyParagraph();

                    tgtNode.replaceWith(p);
                    sel.empty();
                    sel.setPosition(p, 0);

                    args[0] = null;
                    args[2] = true;
                }

                return Reflect.apply(target, editorInstance, args);
            }
        });
    }

    setWindowPosition(oWindow, windowSize) {
        const OFFSET_Y = 10;
        const isMobile = this.browser.mobile;

        const popper = this.createPopper(this.cheditor.toolbarWrapper, oWindow, {
            placement: 'bottom',
            strategy: 'fixed',
            modifiers: [
                { name: 'offset', options: {offset: [0, 0]} },
                { name: 'flip', enabled: false },
                { name: 'hide', enabled: false },
                {
                    name: 'computeStyles',
                    enabled: true,
                    fn({state}) {
                        let top = 0;
                        const windowHalf = (windowSize.innerHeight - state.rects.popper.height) / 2;

                        if (!isMobile && state.rects.popper.height < 500) {
                            top = state.rects.reference.y + state.rects.reference.height + OFFSET_Y;
                            if (top + state.rects.popper.height >= windowSize.innerHeight) {
                                top = windowHalf;
                            }
                        } else {
                            top = windowHalf;
                        }

                        state.styles.popper = {
                            ...state.styles.popper,
                            left: `${(window.innerWidth - state.rects.popper.width) / 2}px`,
                            top: `${top}px`,
                        }
                    }
                }
            ]
        });
    }

    getWindowSize(doc = document) {
        const rect = this.cheditor.container.getBoundingClientRect();
        const documentMetrics = {
                width: doc.body.clientWidth,
                height: doc.body.clientHeight,
                scrollHeight: doc.body.scrollHeight,
                scrollWidth: doc.body.scrollWidth,
                scrollY: window.scrollY,
                scrollX: window.scrollX,
                innerHeight: window.innerHeight,
                innerWidth: window.innerWidth,
                clientTop: doc.body.clientTop || 0,
                clientLeft: doc.body.clientLeft || 0
            };
        return {
            ...documentMetrics,
            editorRect: rect,
            offsetLeft: rect.left + documentMetrics.scrollX - documentMetrics.clientLeft
        };
    }
    
    popupWindowConfirm(popup, obj) {
        this.confirm(obj.message, (yes) => {
            if (yes) {
                this.postMessage(popup, {type: "confirm", action: true});
            }
        });
    }

    popupWindowAlert(obj) {
        this.alert(obj.message, obj.title);
    }

    postMessage(obj, message) {
        obj.contentWindow.postMessage(message, '*');
    }

    isValidURL(str) {
        let url;
        try {
            url = new URL(str);
        } catch (e) {
            return null;
        }
        return url.protocol === 'http:' || url.protocol === 'https:' || url.protocol === 'mailto:';
    }

    getHyperlink() {
        const selection = this.getSelection(), links = {};

        if (selection.type === 'None') {
            return links;
        }

        const range = this.getRange();
        let container = range.commonAncestorContainer;

        if (container.nodeType === Node.TEXT_NODE) {
            container = container.parentNode;
        }

        container = container.closest('a');
        if (container && this.isValidURL(container.href)) {
            links.href = container.href;
            links.title = container.title;
        }

        return links;
    }

    popupWindowExecHandle(exec, argv) {
        let isReturn = true,
            isCancel = false;

        this.setDesignMode(true);
        this.restoreRange();

        switch (exec) {
            case 'insertHTML': this.insertHtmlAtSelection(argv); break;
            case 'insertAIContents': this.insertAIContents(argv); break;
            case 'createLink': this.createHyperLink(argv); break;
            case 'insertImage': this.doInsertImage(argv); break;
            case 'insertVideo': this.insertVideo(argv); break;
            case 'applySourceCode': this.loadContents(argv); break;
            case 'cancel':
                this.popupWindowCancel();
                isCancel = true;
                break;
            default:
                isReturn = false;
        }
        if (!isCancel) {
            this.popupWindowClose();
        }
        return isReturn;
    }

    popupWindowLoad(popupAttr) {
        // 1. Iframe 생성
        const popupWindow = this.createPopupIframe(popupAttr);
        const closeFunc = () => this.postMessage(popupWindow, { type: 'close' });

        // 2. 이벤트 핸들러 정의 (Self-referencing을 위해 변수에 할당)
        const messageHandler = (evt) => this.handlePopupMessage(evt, popupWindow, messageHandler, closeFunc);
        const loadHandler = () => this.onPopupLoad(popupWindow, popupAttr, loadHandler);

        // 3. 이벤트 바인딩
        this.addEvent(window, 'message', messageHandler);
        this.addEvent(popupWindow, 'load', loadHandler);
        this.addEvent(this.cheditor.modal.closeButton, 'click', closeFunc);

        // 4. UI 구성 및 표시
        try {
            this.setupModalUI(popupWindow, popupAttr);
        } catch (e) {
            console.error('오류:', e.toString());
        }
    }

    createPopupIframe(popupAttr) {
        const popupWindow = this.createElement('iframe');
        popupWindow.setAttribute('name', popupAttr.tmpl);
        popupWindow.setAttribute('src', `${this.config.path.popup}/${popupAttr.tmpl}`);
        popupWindow.id = popupAttr.tmpl;
        return popupWindow;
    }

    handlePopupMessage(evt, popupWindow, messageHandler, closeFunc) {
        const { exec, value } = evt.data;
        let isReturn = false;

        switch (exec) {
            case 'requestSelected':
                this.postMessage(popupWindow, {
                    type: 'responseData',
                    value: this.getHyperlink()
                });
                break;
            case 'setDialog':
                this.adjustDialogSize(popupWindow, value);
                break;
            case 'confirm':
                this.popupWindowConfirm(popupWindow, value);
                break;
            case 'alert':
                this.popupWindowAlert(value);
                break;
            default:
                isReturn = this.popupWindowExecHandle(exec, value);
        }

        if (isReturn) {
            this.removeEvent(window, 'message', messageHandler);
            this.removeEvent(this.cheditor.modal.closeButton, 'click', closeFunc);
        }
    }

    adjustDialogSize(popupWindow, value) {
        this.cheditor.modal.frameWrapper.style.height = `${value.bodyScrollHeight}px`;
        popupWindow.setAttribute('height', '100%');
        popupWindow.setAttribute('width', value.bodyScrollWidth);

        this.setWindowPosition(this.cheditor.modal, this.getWindowSize());
        this.cheditor.modal.showModal();
        this.cheditor.modal.classList.add('show');
    }

    onPopupLoad(popupWindow, popupAttr, loadHandler) {
        this.setDesignMode(false);

        const additionalData = popupAttr.tmpl === 'code.html'
            ? { body: this.getContents(true) }
            : {};
        const initMessage = {
            type: 'init',
            value: {
                ...this.config,
                supportedVideoMimeTypes: GB.MIME_TYPES.VIDEO,
                supportedImageMimeTypes: GB.MIME_TYPES.IMAGE,
                supportedMimeTypes: GB.supportedMimeTypes,
                ...additionalData,
            }
        };

        popupWindow.contentWindow.focus();
        this.postMessage(popupWindow, initMessage);
        this.removeEvent(popupWindow, 'load', loadHandler);
    }

    setupModalUI(popupWindow, popupAttr) {
        const modal = this.cheditor.modal;

        if (!modal || !modal.titleText || !modal.frameWrapper || !modal.closeButton || !modal.titleBar) {
            throw new Error('팝업 창이 초기화되지 않았습니다.');
        }

        if (!(popupWindow instanceof Node)) {
            throw new TypeError('popupWindow는 DOM 노드가 아닙니다.');
        }

        modal.titleText.textContent = popupAttr.title ?? '';
        modal.frameWrapper.replaceChildren(popupWindow);
        modal.style.display = 'block';

        const disableDrag = (evt) => {
            if (evt.dataTransfer) {
                evt.dataTransfer.effectAllowed = 'none';
                evt.dataTransfer.dropEffect = 'none';
            }
            this.removeEvent(modal, 'dragover', disableDrag);
        };

        this.addEvent(modal, 'dragover', disableDrag);

        const titleBar = modal.titleBar;
        titleBar.pointerEvents = this.pointerEvents;
        titleBar.isTouchEvent = this.isTouchEvent;

        GB.dragWindow.init(titleBar, modal);
    }

    popupWindowCancel() {
        this.popupWindowClose();
    }

    popupWindowClose() {
        const modal = this.cheditor.modal;
        if (!modal) return;

        modal.ontransitionend = () => {
            if (!modal.classList.contains('show')) {
                this.emptyChildren(modal.frameWrapper);
                modal.style.removeProperty('display');
            }
        };

        modal.classList.remove('show');
        modal.close();

        if (this.modalReSize) {
            if (GB.browser.opera) {
                self.removeEvent(window, 'resize', this.modalReSize);
            }
            this.modalReSize = null;
        }

        if (this.toolbar[modal.id]?.checked) {
            this.toolbarButtonChecked(this.toolbar[modal.id], false);
        }
    }

    clearStoredSelections() {
        this.storedSelections.length = 0;
    }

    restoreRange() {
        this.editareaFocus();
        if (this.storedSelections.length > 0) {
            const selection = this.getSelection();
            selection.empty();

            for (const storedRange of this.storedSelections) {
                selection.addRange(storedRange);
            }
        }
        this.clearStoredSelections();
    }

    keyPressBackupRange() {
        const selection = this.getSelection();

        for (let i = 0; i < selection.rangeCount; i++) {
            this.keyPressStoredSelections.push(selection.getRangeAt(i));
        }
    }

    backupRange() {
        const selection = this.getSelection();

        this.clearStoredSelections();
        for (let i = 0; i < selection.rangeCount; i++) {
            this.storedSelections.push(selection.getRangeAt(i));
        }
    }

    getSelection() {
        return this.editarea.getSelection();
    }

    clearSelection() {
        const selection = this.getSelection();

        if (selection.rangeCount > 0) {
            selection.empty();
        }

        return selection;
    }

    isBackwardSelection(selection) {
        const position = selection.anchorNode.compareDocumentPosition(selection.focusNode);

        return !position && selection.anchorOffset > selection.focusOffset ||
            position === Node.DOCUMENT_POSITION_PRECEDING;
    }

    getRange() {
        let selection = this.getSelection(),
            range;

        if (selection.getRangeAt) {
            range = selection.rangeCount ? selection.getRangeAt(0) : this.createRange();
        } else {
            range = this.createRange();
            if (this.isBackwardSelection(selection)) {
                range.setStart(selection.focusNode, selection.focusOffset);
                range.setEnd(selection.anchorNode, selection.anchorOffset);
            } else {
                range.setStart(selection.anchorNode, selection.anchorOffset);
                range.setEnd(selection.focusNode, selection.focusOffset);
            }
        }

        this.range = range;
        return range;
    }

    createRange() {
        return this.doc.createRange();
    }

    getRangeElement(range) {
        const { startContainer, startOffset, endContainer, endOffset, collapsed } = range;
        const shouldUseChildNode = () => {
            return (
                !collapsed &&
                this.isElementNode(startContainer) &&
                startContainer === endContainer &&
                endOffset - startOffset === 1 &&
                startContainer.hasChildNodes()
            );
        };
        const node = shouldUseChildNode()
            ? startContainer.childNodes[startOffset]
            : startContainer;

        return this.getParentIfTextNode(node);
    }

    getSelectionType() {
        const selection = this.getSelection();
        let selectionType = selection.type;

        if (selectionType === 'None') {
            return 1;
        }

        if (selectionType === 'Range' && !selection.toString()) {
            return 3;
        }

        return 2;
    }

    popupWindowOpen(button) {
        this.closeDropdownMenu();
        this.editareaFocus();
        this.backupRange();

        const popup = GB.UI.POPUPS[button.argv];
        if (this.isUndefined(popup)) {
            alert("사용할 수 없는 명령입니다.");
            return;
        }

        this.popupWindowLoad(popup);
        this.cheditor.modal.id = button.name;
        this.toolbarButtonChecked(button, true);
    }

    fontSizeUpDown(command) {
        const currSize = Number(this.toolbar["FontSize"].data);
        let idx;

        if (isNaN(currSize) || currSize < 1) {
            return;
        }

        if (command === "FontSizeDown") {
            idx = GB.UI.DROPDOWNS.FONT_SIZES.findLastIndex(size => size <= currSize);
            if (idx > 0) {
                idx = idx - 1;
            }
        } else {
            idx = GB.UI.DROPDOWNS.FONT_SIZES.findIndex(size => size >= currSize);
            if (idx < GB.UI.DROPDOWNS.FONT_SIZES.length - 1) {
                idx = idx + 1;
            }
        }

        const selection = this.getSelection();
        if (selection.isCollapsed) {
            const range = selection.getRangeAt(0);
            let ancestor = selection.focusNode;

            if (!this.isTextNode(ancestor)) {
                return;
            }

            ancestor = this.findTextFormatAncestor(selection.focusNode);
            const staticRange = this.createStaticRange(range);

            selection.selectAllChildren(ancestor);
            this.doCmdPopup("FontSize", GB.UI.DROPDOWNS.FONT_SIZES[idx], ancestor);
            this.restoreStaticRange(selection, staticRange);
            return;
        }

        this.doCmdPopup("FontSize", GB.UI.DROPDOWNS.FONT_SIZES[idx]);
    }

    pageBreak() {
        const hr = this.createHorizontalRule();
        hr.setAttribute('style', GB.STYLES.PAGE_BREAK);
        if (hr.nextSibling) {
            this.placeCaretAt(hr.nextSibling, true);
        }
    }

    getPreviousSibling(node) {
        while (!node?.previousSibling) {
            node = node?.parentNode;
            if (this.body.isSameNode(node) || !node) {
                return node;
            }
        }
        return node.previousSibling;
    }

    getPreviousLeaf(node) {
        let leaf = this.getPreviousSibling(node),
            iterationLimit = 1000;

        if (!leaf) {
            return null;
        }

        while (leaf.lastChild && iterationLimit-- > 0) {
            leaf = leaf.lastChild;
        }

        if (iterationLimit === 0) {
            console.warn('getPreviousElementLeaf: DOM 구조를 더 이상 순환할 수 없습니다.');
            return null;
        }
        return leaf;
    }

    getPreviousElementSibling(elem) {
        while (!elem.previousElementSibling) {
            elem = elem.parentElement;
            if (elem === this.body || !elem) {
                return elem;
            }
        }
        return elem.previousElementSibling;
    }

    getPreviousElementLeaf(elem) {
        let leaf = this.getPreviousElementSibling(elem),
            iterationLimit = 1000;

        if (!leaf) {
            return null;
        }

        while (leaf.lastElementChild && iterationLimit-- > 0) {
            leaf = leaf.lastElementChild;
        }

        if (iterationLimit === 0) {
            console.warn('getPreviousElementLeaf: DOM 구조를 더 이상 순환할 수 없습니다.');
            return null;
        }

        return leaf;
    }

    getNextSibling(node) {
        while (!node?.nextSibling) {
            node = node?.parentNode;
            if (!node) {
                return node;
            }
        }
        return node.nextSibling;
    }

    getNextLeaf(node) {
        let leaf = this.getNextSibling(node),
            iterationLimit = 1000;

        if (!leaf) {
            return null;
        }

        while (leaf.firstChild && iterationLimit-- > 0) {
            leaf = leaf.firstChild;
        }

        if (iterationLimit === 0) {
            console.warn('getNextLeaf: DOM 구조를 더 이상 순환할 수 없습니다.');
            return null;
        }

        return leaf;
    }

    getNextElementSibling(elem) {
        while (!elem.nextElementSibling) {
            elem = elem.parentElement;
            if (!elem) {
                return elem;
            }
        }
        return elem.nextElementSibling;
    }

    getNextElementLeaf(elem) {
        let leaf = this.getNextElementSibling(elem),
            iterationLimit = 1000;

        if (!leaf) {
            return null;
        }

        while (leaf.firstElementChild && iterationLimit-- > 0) {
            leaf = leaf.firstElementChild;
        }

        if (iterationLimit === 0) {
            console.warn('getNextElementLeaf: DOM 구조를 더 이상 순환할 수 없습니다.');
            return null;
        }

        return leaf;
    }

    isTextVisible(text) {
        return (text ?? '').trim().length > 0;
    }

    isBrElement(node) {
        if (!this.isElementNode(node) || node.nodeName !== 'BR') {
            return null;
        }
        return node;
    }

    isEmptyParagraph(node) {
        if (!this.isElementNode(node) ||
            node.nodeName !== 'P' && node.nodeName !== 'DIV') {
            return null;
        }
        return this.getTextValue(node).trim() === '' &&
            this.getChildElementsExceptBr(node).length === 0 ? node : null;
/*
        return Array.prototype.filter.call(node.childNodes, child => {
            return this.isElementNode(child) && child.nodeName !== 'BR' ||
                this.isTextNode(child) && this.isTextVisible(child.textContent);
        }).length === 0;
*/
    }

    checkCssValue (el, prop) {
        return this.cssProperties(el)?.find(c => c.name === prop) ?? null;
    }

    cssProperties(el) {
        const style = el?.style;
        if (!style) return null;

        const props = Object.keys(style)
            .filter(prop => Object.hasOwn(style, prop) && !Number.isNaN(parseInt(prop, 10)))
            .map(prop => this.extractCssProperty(style, prop));

        return props.length > 0 ? props : null;
    }

    extractCssProperty(prop, idx) {
        const name = prop[idx];
        return {
            name: name,
            value: prop.getPropertyValue(name)
        };
    }

    makeFontCss (command, opt, elem) {
        switch (command) {
            case 'font-size' : elem.style.fontSize = opt + 'px'; break;
            case 'font-family' : elem.style.fontFamily = opt; break;
            case 'color': elem.style.color = opt; break;
            case 'background-color': elem.style.backgroundColor = opt; break;
        }
        return elem;
    }

    insertRangeMarker(range, toStart) {
        const boundaryRange = range.cloneRange();
        const rangeMarker = this.createElement('range-marker');
        rangeMarker.create(boundaryRange, toStart);
        return rangeMarker;
    }

    restoreRangeMarker(staticRange) {
        const selection = this.getSelection();
        const anchorMarker = staticRange.startContainer;

        if (staticRange.collapsed) {
            const parent = anchorMarker.parentNode;
            selection.setPosition(anchorMarker.nextSibling);
            anchorMarker.className = GB.removeZeroWidthSpaceAttr;
            anchorMarker.className = GB.removeRangeMarkerAttr;
            parent.normalize();
        } else {
            const focusMarker = staticRange.endContainer;
            const range = this.createRange();

            anchorMarker.className = GB.removeZeroWidthSpaceAttr;
            focusMarker.className = GB.removeZeroWidthSpaceAttr;

            range.setStartAfter(anchorMarker);
            range.setEndBefore(focusMarker);

            selection.empty();
            selection.addRange(range);

            anchorMarker.className = GB.removeRangeMarkerAttr;
            focusMarker.className = GB.removeRangeMarkerAttr;
        }

        return selection;
    }

    createStaticRange(range = this.getRange()) {
        return new StaticRange({
            startContainer: range.startContainer,
            startOffset: range.startOffset,
            endContainer: range.endContainer,
            endOffset: range.endOffset
        });
    }

    restoreStaticRange(selection, staticRange) {
        selection.empty();
        selection.setBaseAndExtent(
            staticRange.startContainer,
            staticRange.startOffset,
            staticRange.endContainer,
            staticRange.endOffset
        );
    }

    saveRangeMarker(range) {
        const marker = this.insertRangeMarker(range, true);
        return new StaticRange({
            startContainer: marker,
            startOffset: 0,
            endContainer: range.collapsed ? marker : this.insertRangeMarker(range, false),
            endOffset: 0,
            collapsed: range.collapsed
        });
    }

    restoreAndSaveRangeMarker(staticRange, rangeHandler) {
        this.restoreRangeMarker(staticRange);
        const range = this.getRange();
        rangeHandler(range);
        return this.saveRangeMarker(range);
    }

    restoreAndCreateStaticRange(selection, staticRange, rangeHandler) {
        this.restoreStaticRange(selection, staticRange);
        const range = this.getRange();
        rangeHandler(range);
        return this.createStaticRange(range);
    }

    isLastElementIndex(arr, idx) {
        return idx === arr.length - 1;
    }

    getComputedStyleValue(elem, prop) {
        const computedStyle = window.getComputedStyle(elem);
        const propValue = computedStyle?.getPropertyValue(prop);
        return propValue || null;
    }

    getChildNodeIndex(node) {
        const parent = node.parentNode;
        return Array.prototype.findIndex
            .call(parent.childNodes, (child) => child === node);
    }

    isListStartElement(elem) {
        if (!this.isElementNode(elem)) {
            return false;
        }
        return GB.TAGS.LIST.STARTS.has(elem.nodeName);
    }

    getListItemElement(elem) {
        if (!elem) return null;
        const current = this.getParentIfTextNode(elem);
        return current.closest([...GB.TAGS.LIST.ITEMS].join(','));
    }
    
    getListStartElement(elem) {
        if (!elem) return null;

        const listItem = this.getListItemElement(elem);
        if (!listItem) {
            return null;
        }

        const listStart = listItem.parentNode;
        if (GB.TAGS.LIST.STARTS.has(listStart.nodeName)) {
            return listStart;
        }

        return null;
    }

    checkListsElementStructure(listStartElement) {
        const rootNode = this.checkListElement(listStartElement);
        if (!rootNode) return null;

        const treeWalker = this.doc.createTreeWalker(
            rootNode,
            NodeFilter.SHOW_ELEMENT,
            {
                acceptNode: (node) => {
                    return GB.TAGS.LIST.ENTIRE.includes(node.nodeName)
                        ? NodeFilter.FILTER_ACCEPT
                        : NodeFilter.FILTER_REJECT;
                }
            }
        );

        let nextNode = treeWalker.nextNode();

        while (nextNode) {
            const currNode = treeWalker.currentNode;
            if (this.isListStartElement(currNode) && this.isListStartElement(currNode.parentElement)) {
                let prevNode = currNode.previousElementSibling;

                if (prevNode && GB.TAGS.LIST.ITEMS.has(prevNode.nodeName)) {
                    prevNode.append(currNode);
                    treeWalker.currentNode = prevNode;
                } else {
                    prevNode = this.createElement('li');
                    currNode.before(prevNode);
                    prevNode.append(currNode);
                    treeWalker.currentNode = prevNode;
                }
            } else {
                nextNode = treeWalker.nextNode();
            }
        }

        return rootNode;
    }

    isSameElementName(elem, otherName) {
        if (!otherName || !this.isElementNode(elem)) {
            return false;
        }
        return elem.nodeName === otherName.toUpperCase();
    }

    findClosestBlockElement(el) {
        let curNode = el;

        while (!this.isBody(curNode)) {
            if (this.isBlockElement(curNode)) {
                return curNode;
            }
            curNode = curNode.parentNode;
        }

        return null;
    }

    getRootNode(node) {
        let curNode = node;
        const isNotRootNode = (el) => el?.parentNode && !this.isBody(el.parentNode);

        while (isNotRootNode(curNode)) {
            curNode = curNode.parentNode;
        }

        return curNode;
    }

    getNextElement(el, otherName = null) {
        const findNextSiblingAncestor = (curEl, otherName) => {
            while (!curEl.nextElementSibling) {
                curEl = curEl.parentElement;
                if (!curEl || this.isSameElementName(curEl, otherName)) {
                    return curEl;
                }
            }
            return curEl.nextElementSibling;
        };
        const findFirstChildMatch = (curEl, otherName) => {
            while (curEl.firstElementChild) {
                curEl = curEl.firstElementChild;
                if (this.isSameElementName(curEl, otherName)) {
                    break;
                }
            }
            return curEl;
        };

        let currElem = findNextSiblingAncestor(el, otherName);
        if (!currElem || this.isSameElementName(currElem, otherName)) {
            return currElem;
        }

        return findFirstChildMatch(currElem, otherName);
    }

    checkListElement(node) {
        const NESTED_LIST_SELECTOR = 'ol > ol, ol > ul, ol > dl, ul > ul, ul > ol, ul > dl, dl > dl, dl > ol, dl > ul';
        let current = node;

        while (current.parentNode &&
            !this.isBody(current.parentNode) &&
            GB.TAGS.LIST.ENTIRE.includes(current.parentNode.nodeName)) {
            current = current.parentNode;
        }

        return current.querySelector(NESTED_LIST_SELECTOR) ? current : null;
    }

    copyAttributes(sourceEl, targetEl) {
        const shouldSkipAttribute = (attributeName) => attributeName === 'id';

        Array.from(sourceEl.attributes).forEach(attribute => {
            if (!shouldSkipAttribute(attribute.nodeName)) {
                targetEl.setAttributeNode(attribute.cloneNode(true));
            }
        });
    }

    removeAttributes(el, exceptAttributes = []) {
        if (!el?.hasAttributes()) {
            return;
        }

        const attrs = new Set(exceptAttributes);

        el.getAttributeNames().forEach(attr => {
            if (!attrs.has(attr) || el.getAttribute(attr) === '') {
                el.removeAttribute(attr)
            }
        });
    }

    handleListStyle(cmd, val) {
        const btn = this.toolbar[cmd];
        let rng = this.getRange();
        let ancestor = rng.commonAncestorContainer;

        ancestor.normalize();
        ancestor = this.getParentIfTextNode(ancestor);

        if (!btn.checked) {
            btn.elem.click();
        }

        while (ancestor && ancestor.nodeName !== 'BODY') {
            if (this.isListStartElement(ancestor)) {
                ancestor.style.listStyleType = (val === 'desc' || val === 'decimal') ? '' : val;
                break;
            }
            ancestor = ancestor.parentNode;
        }
    }
    
    convertToPx(val) {
        const CSS_LENGTH_REG_EXP = /^(\d+(?:\.\d+)?)\s*(px|pt|%|em|rem)$/i;
        const CSS_FONT_SIZE_KEYWORDS = {
            'xx-small': 9,
            'x-small': 10,
            'small': 13,
            'medium': 16,
            'large': 18,
            'x-large': 24,
            'xx-large': 32
        };
        const PT_TO_PX_RATIO = 4 / 3;
        const PX_UNIT = 'px';
        const DEFAULT_FONT_SIZE = 16;

        if (typeof val !== 'string') {
            return 0;
        }

        const normalizedValue = val.trim().toLowerCase();

        if (Object.hasOwn(CSS_FONT_SIZE_KEYWORDS, normalizedValue)) {
            return CSS_FONT_SIZE_KEYWORDS[normalizedValue] + PX_UNIT;
        }

        const match = normalizedValue.match(CSS_LENGTH_REG_EXP);

        if (!match) {
            return 0;
        }

        const numericValue = Number.parseFloat(match[1]);
        const unit = match[2].toLowerCase();
        const rootFontSize = Number.parseFloat(this.getComputedStyleValue(this.doc.documentElement, 'font-size')) || DEFAULT_FONT_SIZE;
        let pixelValue;

        switch (unit) {
            case 'px':
                pixelValue = numericValue;
                break;
            case 'pt':
                pixelValue = numericValue * PT_TO_PX_RATIO;
                break;
            case '%':
                pixelValue = DEFAULT_FONT_SIZE * numericValue / 100;
                break;
            case 'em':
                pixelValue = DEFAULT_FONT_SIZE * numericValue;
                break;
            case 'rem':
                pixelValue = rootFontSize * numericValue;
                break;
            default:
                return 0;
        }

        return Math.round(pixelValue) + PX_UNIT;
    }

    handleFontStyle(cmd, val, el) {
        const styleAttributesMap = {
            FontSize: { name: "fontSize", attributeNewValue: `${val}px` },
            FontName: { name: "fontFamily", attributeNewValue: "face" },
            ForeColor: { name: "color", attributeNewValue: "color" },
            BackColor: { name: "backgroundColor", attributeNewValue: val }
        };

        const attrs = styleAttributesMap[cmd];
        const rng = this.getRange();
        const ancestor = el || this.findTextFormatAncestor(rng.commonAncestorContainer);

        this.observer.modify = {
            rules: attrs,
            type: "fontStyle",
            newName: "SPAN",
            oldName: "FONT",
            isSameStyle: (node) => {
                const attrVal = node.style?.[attrs.name];
                return node.hasAttribute('style') && attrVal === attrs.value;
            },
        };

        this.observer.observe(ancestor, {
            childList: true,
            subtree: true,
            attributeOldValue: true,
            attributes: true,
            attributeFilter: ['style']
        });

        const finalValue = (cmd === 'FontSize') ? '2' : val;
        this.queryCommand(cmd, finalValue);
    }

    doCmdPopup(cmd, val = null, el = null) {
        this.closeDropdownMenu();
        this.restoreRange();

        try {
            switch (cmd) {
                case 'LineHeight':
                    this.applyLineHeight(val);
                    break;
                case 'QuoteBlock':
                    this.blockquoteCommand(val);
                    break;
                case 'OrderedList':
                case 'UnOrderedList':
                    this.handleListStyle(cmd, val);
                    break;
                case 'FontSize':
                case 'ForeColor':
                case 'BackColor':
                case 'FontName':
                    this.handleFontStyle(cmd, val, el);
                    break;
                default:
                    this.queryCommand(cmd, val);
            }
        } catch (err) {
            alert(err.toString());
        }

        if (this.config.showTagSelector) {
            this.outputTagSelector();
        }
    }

    isTextFormatElement(node) {
        return this.isElementNode(node) ? GB.TAGS.FORMATTING.has(node.nodeName) : false;
    }
    isForceRemoveElement(node) {
        return this.isElementNode(node) ? GB.TAGS.FORCE_REMOVE.has(node.nodeName) : false;
    }
    isBlockElement(node) {
        return this.isElementNode(node) ? !GB.TAGS.INLINE.has(node.nodeName) : false;
    }
    isInlineElement(node) {
        return this.isElementNode(node) ? !this.isBlockElement(node) : false;
    }
    isTextIndentElement(node) {
        return this.isElementNode(node) ? GB.TAGS.INDENT.has(node.nodeName) : false;
    }

    calcIndentOffset(elem, direction) {
        const currentOffset = Number.parseInt(elem.style.getPropertyValue('margin-left'), 10);

        if (isNaN(currentOffset)) {
            return direction === 'decrease' ? 0 : GB.defaultOffsetIncrement;
        }

        const newOffset = direction === 'decrease' ? -GB.defaultOffsetIncrement
            : GB.defaultOffsetIncrement;

        return Math.max(currentOffset + newOffset, 0);
    }

    setIndentOffset(elem, command) {
        const offset = this.calcIndentOffset(elem, command === 'Indent' ? 'increase' : 'decrease');

        if (offset < 1) {
            elem.style.removeProperty('margin-left');
            if (elem.style.length === 0) {
                elem.removeAttribute('style');
            }
        } else {
            elem.style.marginLeft = `${offset}px`;
        }
    }

    extendSelection(selection, direction, granularity) {
        selection.modify('extend', direction, granularity);
    }

    setSelectionLine(useBoundary = true) {
        const selection = this.getSelection();
        const granularity = useBoundary ? "lineBoundary" : "line";

        this.extendSelection(selection, "backward", granularity);
        selection.collapseToStart();
        this.extendSelection(selection, "forward", granularity);

        return selection;
    }

    isAfterNode(container, offset, node) {
        let compare = node, i = offset;

        while (compare.parentNode !== container) {
            compare = compare.parentNode;
        }

        while (compare && i > 0) {
            compare = compare.previousSibling;
            i -= 1;
        }

        return i > 0;
    }

    compareCaretPositions(firstNode, firstOffset, secondNode, secondOffset) {
        if (firstNode === secondNode) {
            return firstOffset - secondOffset;
        }

        const compare = firstNode.compareDocumentPosition(secondNode);

        if ((compare & Node.DOCUMENT_POSITION_CONTAINED_BY) !== 0) {
            return this.isAfterNode(firstNode, firstOffset, secondNode) ? 1 : -1;
        }
        if ((compare & Node.DOCUMENT_POSITION_CONTAINS) !== 0) {
            return this.isAfterNode(secondNode, secondOffset, firstNode) ? -1 : 1;
        }
        if ((compare & Node.DOCUMENT_POSITION_FOLLOWING) !== 0) {
            return -1;
        }
        if ((compare & Node.DOCUMENT_POSITION_PRECEDING) !== 0) {
            return 1;
        }
    }

    stringifyElementStart(node, isNewline) {
        if (this.isBrElement(node)) {
            return '\n';
        }
        if (node.nodeName === 'P' || node.nodeName === 'DIV') {
            if (!isNewline) {
                return '\n';
            }
        }
        return '';
    }

    *positions(node, isNewline = true) {
        let child = node.firstChild, offset = 0;
        yield {
            node: node,
            offset: offset,
            text: this.stringifyElementStart(node, isNewline)
        };

        while (child) {
            if (this.isTextNode(child)) {
                yield {
                    node: child,
                    offset: 0/0,
                    text: child.data
                };
                isNewline = false;
            } else {
                isNewline = yield* this.positions(child, isNewline);
            }
            child = child.nextSibling;
            offset += 1;
            yield {
                node: node,
                offset: offset,
                text: ''
            };
        }

        return isNewline;
    }

    getTextOffset(ctxNode, selectionNode, selectionOffset) {
        let offset = 0;

        for (let pos of this.positions(ctxNode)) {
            if (!this.isTextNode(selectionNode) && selectionNode === pos.node &&
                selectionOffset === pos.offset) {
                return offset;
            }

            if (this.isTextNode(selectionNode) && selectionNode === pos.node) {
                return offset + selectionOffset;
            }

            offset += pos.text.length;
        }

        return this.compareCaretPositions(selectionNode, selectionOffset, ctxNode, 0) < 0
            ? 0
            : offset;
    }

    getCaretPosition(ctxNode, textPosition) {
        let textOffset = 0, lastNode = null, lastOffset = 0;

        for (let pos of this.positions(ctxNode)) {
            if (pos.text.length > textPosition - textOffset) {
                return {
                    node: pos.node,
                    offset: this.isTextNode(pos.node) ? textPosition - textOffset : pos.offset
                };
            }

            textOffset += pos.text.length;
            lastNode = pos.node;
            lastOffset = this.isTextNode(pos.node) ? pos.text.length : pos.offset;
        }

        return { node: lastNode, offset: lastOffset };
    }

    getTextValue(node) {
        let value = '';
        for (const pos of this.positions(node)) {
            value += pos.text;
        }
        return value;
    }

    getChildElementsExceptBr(node) {
        return Array.prototype.filter.call(node.children, child => {
            return child.nodeName !== 'BR';
        });
    }

    setSelectionRange(node, start, end) {
        const selection = this.getSelection();
        const sPos = this.getCaretPosition(node, start);
        const ePos = this.getCaretPosition(node, end);
        selection.setBaseAndExtent(sPos.node, sPos.offset, ePos.node, ePos.offset);
    }

    getSelectionStart(ctxNode) {
        const selection = this.getSelection();
        const compare = this.compareCaretPositions(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
        return compare < 0
            ? this.getTextOffset(ctxNode, selection.anchorNode, selection.anchorOffset)
            : this.getTextOffset(ctxNode, selection.focusNode, selection.focusOffset);
    }

    getSelectionEnd(ctxNode) {
        const selection = this.getSelection();
        const compare = this.compareCaretPositions(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
        return compare < 0
            ? this.getTextOffset(ctxNode, selection.focusNode, selection.focusOffset)
            : this.getTextOffset(ctxNode, selection.anchorNode, selection.anchorOffset);
    }

    rangeCompareNode(range, node) {
        const nodeRange = this.createRange();

        try {
            nodeRange.selectNode(node);
        } catch (e) {
            nodeRange.selectNodeContents(node);
        }

        const nodeIsBefore = range.compareBoundaryPoints(Range.START_TO_START, nodeRange) === 1;
        const nodeIsAfter = range.compareBoundaryPoints(Range.END_TO_END, nodeRange) === -1;

        // NODE_BEFORE (0)
        if (nodeIsBefore && !nodeIsAfter) {
            return 0;
        }
        // NODE_AFTER (1)
        if (!nodeIsBefore && nodeIsAfter) {
            return 1;
        }
        // NODE_BEFORE && NODE_AFTER (2)
        if (nodeIsBefore && nodeIsAfter) {
            return 2;
        }
        // NODE_INSIDE (3)
        return 3;
    }

    findLeftBlockElement(node) {
        let leaf;

        while (!node.previousElementSibling) {
            node = node.parentElement;
            if (!node || this.isBlockElement(node)) {
                return node;
            }
        }

        leaf = node.previousElementSibling;

        while (leaf && !this.isBlockElement(leaf)) {
            leaf = leaf.previousElementSibling;
        }

        return leaf;
    }

    findTextFormatAncestor(node) {
        node = this.getParentIfTextNode(node);
        while (this.isTextFormatElement(node)) {
            node = node.parentNode;
        }
        return node;
    }

    replaceTextFormatElement(rootElem) {
        const OLD_ELEMENTS = ['STRIKE', 'B', 'I'];
        const NEW_ELEMENTS = ['S', 'STRONG', 'EM'];

        const walker = this.doc.createTreeWalker(
            rootElem,
            NodeFilter.SHOW_ELEMENT,
            {
                acceptNode: node => OLD_ELEMENTS.includes(node.nodeName)
                    ? NodeFilter.FILTER_ACCEPT
                    : NodeFilter.FILTER_REJECT
            }
        );

        let currNode = walker.nextNode();
        while (currNode) {
            const idx = OLD_ELEMENTS.indexOf(currNode.nodeName);
            if (idx > -1) {
                const newElem = this.createReplacementElement(currNode, NEW_ELEMENTS[idx]);
                currNode.replaceWith(newElem);
                walker.currentNode = newElem;
            }
            currNode = walker.nextNode();
        }
    }

    createReplacementElement(oldNode, newElementName) {
        const newElem = this.createElement(newElementName);
        this.nodeReplaceWith(oldNode, newElem);
        return newElem;
    }

    applyTextFormat(command, args = null) {
        const styleAttr = {
            Strikethrough: {
                name: 'textDecorationLine',
                type: 'replace',
                newName: 'S',
                tagName: 'STRIKE',
                attributeNewValue: 'lineThrough'
            },
            Bold: {
                name: 'bold',
                type: 'replace',
                newName: 'STRONG',
                tagName: 'B',
                attributeNewValue: 'fontWeight'
            },
            Underline: {
                name: 'underline',
                type: 'replace',
                newName: 'U',
                tagName: 'U',
                attributeNewValue: 'underline'
            },
            Italic: {
                name: 'italic',
                type: 'replace',
                newName: 'EM',
                tagName: 'I',
                attributeNewValue: 'italic'
            },
        };

        this.editareaFocus();

        if (!Object.hasOwn(styleAttr, command)) {
            this.queryCommand(command, args);
            this.body.normalize();
            return;
        }

        const range = this.getRange();
        let ancestor = this.findTextFormatAncestor(range.commonAncestorContainer);

        this.observer.modify = {
            rules: styleAttr[command],
            type: styleAttr[command].type,
            newName: styleAttr[command].newName,
            oldName: styleAttr[command].tagName
        };

        this.observer.observe(ancestor, {
            childList: true,
            subtree: true,
            attributeOldValue: true
        });

        const selection = this.getSelection();
        selection.empty();
        selection.addRange(range);
        this.queryCommand(command, args);
    }

    getInnerHTML(elem) {
        if (!this.isElementNode(elem)) {
            return null;
        }
        if (typeof elem.getHTML === 'function') {
            return elem.getHTML();
        }
        if (typeof elem.innerHTML === 'string') {
            return elem.innerHTML;
        }

        const outerHTML = elem.outerHTML || '';
        const tagName = elem.tagName;
        const regex = new RegExp(String.raw`^<${tagName}[^>]*>([\s\S]*)<\/${tagName}>$`, 'i');
        const match = outerHTML.match(regex);
        return match ? match[1] : outerHTML;
    }

    setDefaultParagraphSeparator() {
        this.execCommand('defaultParagraphSeparator', 'p');
    }

    queryCommand(command, opt = null) {
        if (command === 'insertParagraph') {
            this.setDefaultParagraphSeparator();
        }
        return this.execCommand(command, opt);
    }

    execCommand(command, opt = null) {
        return this.doc.execCommand(command, false, opt);
    }

    queryCommandWithRange(command, opt, range) {
        const staticRange = this.saveRangeMarker(range);
        this.queryCommand(command, opt);
        this.restoreRangeMarker(staticRange);
    }

    emptyChildren(node = null) {
        if (!node) {
            this.body.replaceChildren();
            return;
        }
        node.replaceChildren();
    }

    removeBrElement(node) {
        if (this.isElementNode(node) && node.nodeName === 'BR') {
            node.remove();
            return true;
        }
        return false;
    }

    createEmptyParagraph() {
        const p = this.createElement('p');
        p.appendChild(this.createElement('br'));
        return p;
    }

    getTopmostParent(node, singleChildOnly = true) {
        let currentNode = node;
        let topNode = currentNode;

        while (currentNode && !this.isBody(currentNode.parentNode)) {
            const parentNode = currentNode.parentNode;

            if (singleChildOnly && parentNode.children.length !== 1) {
                break;
            }

            currentNode = parentNode;

            if (this.isElementNode(currentNode)) {
                topNode = currentNode;
            }
        }

        return topNode;
    }

    cleanNestedParagraph(node) {
        const topmostBlock = this.getTopmostParent(node);

        while (topmostBlock.childNodes.length === 1 &&
            GB.TAGS.LIST.REPLACE_PARENTS.has(topmostBlock.firstChild.nodeName))
        {
            const nestedParagraph = topmostBlock.firstChild;
            topmostBlock.append(...nestedParagraph.childNodes);
            nestedParagraph.remove();
        }

        return topmostBlock;
    }

    nodeReplaceWith(oldNode, newNode, attributes = true) {
        newNode.append(...oldNode.childNodes);
        if (attributes) {
            this.copyAttributes(oldNode, newNode);
        }
        oldNode.replaceWith(newNode);
    }

    setupDialog(type, titleText, message) {
        const dialog = this.cheditor.dialog;
        const title = dialog.querySelector('.dialog-title');
        const content = dialog.querySelector('.dialog-body');

        dialog.setAttribute('type', type);
        title.replaceChildren(this.doc.createTextNode(titleText));
        content.replaceChildren();
        content.insertAdjacentHTML('afterbegin', message);

        return dialog;
    }

    dialogAddEventHandlers(dialog, confirmHandler, cancelHandler, closeHandler) {
        const confirmButton = dialog.querySelector('button[name="submit"]');
        const cancelButton = dialog.querySelector('button[name="cancel"]');

        this.addEvent(confirmButton, 'click', confirmHandler);
        if (cancelHandler) this.addEvent(cancelButton, 'click', cancelHandler);
        this.addEvent(dialog, 'close', closeHandler);
    }

    dialogRemoveEventHandlers(dialog, confirmHandler, cancelHandler, closeHandler) {
        const confirmButton = dialog.querySelector('button[name="submit"]');
        const cancelButton = dialog.querySelector('button[name="cancel"]');

        this.removeEvent(confirmButton, 'click', confirmHandler);
        if (cancelHandler) this.removeEvent(cancelButton, 'click', cancelHandler);
        this.removeEvent(dialog, 'close', closeHandler);
    }

    alert(message, title = '알림') {
        const dialog = this.setupDialog('alert', title, message);
        const cancelButton = dialog.querySelector('button[name="cancel"]');
        cancelButton.classList.add('d-none');

        const confirmHandler = (evt) => {
            this.stopEvent(evt);
            dialog.close();
        };
        const closeHandler = () => {
            this.dialogRemoveEventHandlers(dialog, confirmHandler, null, closeHandler);
            cancelButton.classList.remove('d-none');
            this.editareaFocus();
        };

        this.dialogAddEventHandlers(dialog, confirmHandler, null, closeHandler);
        dialog.showModal();
    }

    confirm(message, cb) {
        const dialog = this.setupDialog('confirm', '확인', message);
        const cancelHandler = (evt) => {
            this.stopEvent(evt);
            dialog.close('no');
        };

        const confirmHandler = (evt) => {
            this.stopEvent(evt);
            dialog.close('yes');
        };

        const closeHandler = () => {
            this.dialogRemoveEventHandlers(dialog, confirmHandler, cancelHandler, closeHandler);
            this.editareaFocus();
            cb(dialog.returnValue === 'yes');
        };

        this.dialogAddEventHandlers(dialog, confirmHandler, cancelHandler, closeHandler);
        dialog.showModal();
    }

    handleNewDocument() {
        const newDocumentButton = this.toolbar['NewDocument'];
        const confirmMessage = '작성한 글 내용이 모두 사라집니다. 이 작업은 되돌릴 수 없습니다.<br>계속하시겠습니까?';

        this.toolbarButtonChecked(newDocumentButton, true);
        this.confirm(confirmMessage, (yes) => {
            if (yes) {
                this.emptyChildren();
                this.initDefaultParagraphSeparator();
            }
            this.toolbarButtonChecked(newDocumentButton, false);
        });
    }

    handleClearTag() {
        const clearTagButton = this.toolbar['ClearTag'];
        const clearTagConfirmMessage = 'P, BR 태그를 제외한 모든 HTML 태그를 제거합니다. 이 작업은 되돌릴 수 없습니다.<br>계속하시겠습니까?';

        this.toolbarButtonChecked(clearTagButton, true);
        this.confirm(clearTagConfirmMessage, (yes) => {
            if (yes) {
                const bodyHTML = this.getBodyHTML();
                this.emptyChildren();
                this.body.insertAdjacentHTML('afterbegin', this.clearNonEssentialHtmlTags(bodyHTML));
            }
            this.toolbarButtonChecked(clearTagButton, false);
        });
    }

    clearNonEssentialHtmlTags(contents) {
        const shadow = this.createElement('temp-shadow');
        const isEssentialElement = (element) => {
            if (element.nodeName === 'P') {
                return true;
            }
            return element.nodeName === 'BR' && element.closest('p');
        };
        const unwrapElement = (element) => {
            while (element.firstChild) {
                element.before(element.firstChild);
            }
            element.remove();
        };
        const normalizeParagraph = (paragraph) => {
            const lastChild = paragraph.lastChild;

            if (this.isBrElement(lastChild) && paragraph.childNodes.length > 1) {
                lastChild.remove();
            }
            if (!paragraph.hasChildNodes()) {
                paragraph.appendChild(this.createElement('br'));
            }
        };

        shadow.insertAdjacentHTML('afterbegin', contents);

        const walker = this.doc.createTreeWalker(
            shadow,
            NodeFilter.SHOW_ELEMENT,
            {
                acceptNode: (node) => node === shadow
                    ? NodeFilter.FILTER_SKIP
                    : NodeFilter.FILTER_ACCEPT
            }
        );

        let currentNode = walker.nextNode();

        while (currentNode) {
            const nextNode = walker.nextNode();

            if (!isEssentialElement(currentNode)) {
                unwrapElement(currentNode);
            } else {
                this.removeAttributes(currentNode);
                if (currentNode.nodeName === 'P') {
                    normalizeParagraph(currentNode);
                }
            }

            currentNode = nextNode;
        }

        shadow.querySelectorAll('p').forEach(normalizeParagraph);
        return this.getInnerHTML(shadow);
    }

    handleJustifyCommand(command) {
        const range = this.getRange();
        const currElem = this.findClosestBlockElement(range.commonAncestorContainer);

        if (currElem && currElem.nodeName === 'FIGCAPTION') {
            currElem.style.textAlign = GB.STYLES.TEXT_ALIGNMENTS[command];
            return;
        }
        if (GB.browser.firefox) {
            this.firefoxJustifyCorrectionObserver(command, range);
        }

        this.queryCommand(command);
    }

    firefoxJustifyCorrectionObserver(command, range) {
        const rootNode = this.getJustifyRootNode(range);
        const applyJustifyCorrection = (node) => {
            node.style.textAlign = GB.STYLES.TEXT_ALIGNMENTS[command];
            node.removeAttribute('align');
            if (node.nodeName === 'DIV') {
                this.nodeReplaceWith(node, this.createElement('p'));
            }
        };

        if (rootNode) {
            const observer = new MutationObserver((mutations) => {
                observer.disconnect();
                const staticRange = this.createStaticRange();
                const selection = this.getSelection();

                mutations.forEach(mutation => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'align') {
                        applyJustifyCorrection(mutation.target);
                    }
                    mutation.addedNodes.forEach(node => {
                        if (this.isElementNode(node) && node.nodeName === 'DIV') {
                            applyJustifyCorrection(node);
                        }
                    });
                });
                this.restoreStaticRange(selection, staticRange);
            });

            let targetNode = rootNode;

            if (targetNode.nodeName === 'P') {
                targetNode.style.textAlign = GB.STYLES.TEXT_ALIGNMENTS[command];
            } else if (['THEAD', 'TBODY', 'TR', 'TFOOT'].includes(rootNode.nodeName)) {
                const tbl = targetNode.closest('TABLE');
                if (tbl) {
                    targetNode = tbl;
                }
            }

            observer.observe(targetNode, {
                childList: true, subtree: true, attributeOldValue: true, attributes: true
            });
        }
    }

    getJustifyRootNode(range) {
        let ancestor = this.getParentIfTextNode(range.commonAncestorContainer);
        const isNotRootNode = (elem) => !this.isBlockElement(ancestor) && !this.isBody(elem);
        while (isNotRootNode(ancestor)) {
            ancestor = ancestor.parentNode;
        }
        return ancestor;
    }

    execEditorCommand(command) {
        this.closeDropdownMenu();
        this.editareaFocus();

        switch (command) {
            case 'NewDocument':
                this.handleNewDocument();
                break;
            case 'Print':
                this.editarea.print();
                break;
            case 'PageBreak':
                this.pageBreak();
                break;
            case 'ClearTag':
                this.handleClearTag();
                break;
            case 'InsertHorizontalRule':
                this.insertHorizontalRule();
                break;
            case 'JustifyLeft': case 'JustifyCenter': case 'JustifyRight': case 'JustifyFull':
                this.backupRange();
                this.handleJustifyCommand(command);
                this.restoreRange();
                break;
            case 'Indent': case 'Outdent':
                this.indentListCommand(command);
                break;
            case 'InsertOrderedList': case 'InsertUnOrderedList':
                this.insertListCommand(command);
                break;
            case 'UnLink':
                this.removeHyperLink();
                break;
            case 'SelectAll':
                this.selectAll();
                break;
            case 'RemoveFormat': case 'Copy':
                this.queryCommand(command);
                break;
            case 'Cut':
                this.cutSelectedNode();
                break;
            default:
                break;
        }
    }

    selectAll() {
        const selection = this.getSelection();
        selection.selectAllChildren(this.body);
    }

    canIndentOutdent(node) {
        return node
            && GB.TAGS.LIST.ITEMS.has(node.nodeName)
            && node.previousElementSibling;
    }

    createListElementForNode(node, parentNodeName) {
        const elementName = parentNodeName || 'ul';
        const startElem = this.createElement(elementName);
        startElem.append(node);
        return startElem;
    }

    indentListElement(node) {
        if (!node || !this.canIndentOutdent(node)) {
            return;
        }

        const prevSibling = node.previousElementSibling;
        if (!prevSibling) {
            return;
        }

        if (this.isListStartElement(prevSibling)) {
            prevSibling.append(node);
        } else if (prevSibling.nodeName === 'LI') {
            const lastChild = prevSibling.lastElementChild;

            if (lastChild && this.isListStartElement(lastChild)) {
                lastChild.append(node);
            } else {
                const startElem = this.createListElementForNode(node, node.parentNode?.nodeName);
                prevSibling.append(startElem);
            }
        }
    }

    indentListCommand(command) {
        const range = this.getRange();
        const ancestor = this.getParentIfTextNode(range.commonAncestorContainer);
        const liStart = this.getListStartElement(ancestor);

        if (liStart) {
            if (command === 'Outdent') {
                this.outdentListElement(range);
                return;
            }

            const staticRange = this.saveRangeMarker(range);
            const tagsName = GB.TAGS.LIST.ENTIRE.toString();
            let [sc, ec] = [range.startContainer, range.endContainer];
            let prevNode = null;

            sc = this.getParentIfTextNode(sc).closest(tagsName);
            ec = this.getParentIfTextNode(ec).closest(tagsName);

            if (!sc || !ec) {
                return;
            }

            const nodes = sc.contains(ec)
                ? [sc]
                : [...ancestor.children].filter((el) => {
                    return GB.TAGS.LIST.ITEMS.has(el.tagName);
                });

            for (let node of nodes) {
                if (node.compareDocumentPosition(ec) & Node.DOCUMENT_POSITION_PRECEDING) {
                    break;
                }
                if (node.compareDocumentPosition(sc) & Node.DOCUMENT_POSITION_FOLLOWING) {
                    continue;
                }
                if (prevNode &&
                    node.compareDocumentPosition(prevNode) & Node.DOCUMENT_POSITION_CONTAINS) {
                    continue;
                }

                this.indentListElement(node);
                prevNode = node;
            }

            this.restoreRangeMarker(staticRange);
            return;
        }

        const staticRange = this.saveRangeMarker(range);
        let prevNode = null;
        const self = this;
        const walker = this.doc.createTreeWalker(
            ancestor,
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT,
            {
                acceptNode(node) {
                    if (range.intersectsNode(node)) {
                        return (node.nodeType === Node.TEXT_NODE &&
                            !self.isTextVisible(node.nodeValue) ||
                            node.nodeName === 'RANGE-MARKER') ?
                            NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
                    }
                    return NodeFilter.FILTER_REJECT;
                }
            });
        const applyIndentOffset = ((elem, isRoot) => {
            const isTextIndented = this.isTextIndentElement(elem);
            if (isTextIndented) {
                this.setIndentOffset(elem, command);
            }
            if (isTextIndented || this.isListStartElement(elem)) {
                return isRoot ? null : true;
            }
            return isRoot ? walker.firstChild() : false;
        });
        const handleElementNode = (currNode) => {
            if (applyIndentOffset(currNode, false)) {
                prevNode = currNode;
                if (!currNode.nextSibling) {
                    while (!currNode.nextSibling) {
                        currNode = currNode.parentNode;
                        if (currNode === walker.root) {
                            break;
                        }
                    }
                    walker.currentNode = currNode;
                }
                return walker.nextSibling();
            } else {
                return walker.nextNode();
            }
        };
        const handleTextNodeFormatting = (currNode) => {
            if (prevNode && prevNode.contains(currNode)) {
                walker.currentNode = prevNode;
                return walker.nextSibling();
            } else {
                const selection = this.getSelection();
                const nodeRange = this.createRange();
                nodeRange.selectNode(currNode);
                selection.empty();
                selection.addRange(nodeRange);

                this.queryCommand('formatBlock', 'p');

                currNode = this.getParentIfTextNode(selection.focusNode).closest('p');
                selection.selectAllChildren(currNode);

                this.setIndentOffset(currNode, command);

                walker.currentNode = currNode;
                prevNode = null;
                return walker.nextSibling();
            }
        };

        let node = applyIndentOffset(walker.root, true);

        while (node) {
            node = this.isElementNode(walker.currentNode)
                ? handleElementNode(node)
                : handleTextNodeFormatting(node);
        }

        this.restoreRangeMarker(staticRange);
    }

    outdentListElement(range) {
        const currElem = this.getRangeElement(range);
        const listStart = this.getListStartElement(currElem);

        if (!listStart) {
            return;
        }

        let staticRange = this.saveRangeMarker(range);

        if (this.checkListsElementStructure(listStart)) {
            staticRange = this.restoreAndSaveRangeMarker(staticRange, (newRange) => range = newRange);
        }

        const entire = GB.TAGS.LIST.ENTIRE.toString();
        const ancestor = this.getParentIfTextNode(range.commonAncestorContainer).closest(entire);

        if (!ancestor) {
            return;
        }

        const sc = this.getListItemElement(range.startContainer);
        const ec = this.getListItemElement(range.endContainer);
        const walker = this.doc.createTreeWalker(
            ancestor,
            NodeFilter.SHOW_ELEMENT,
            {
                acceptNode(node) {
                    return GB.TAGS.LIST.ENTIRE.includes(node.nodeName)
                        ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
                }
            }
        );

        const targetNodes = [];
        const RELATIVE_POSITION_BEFORE = 0;
        const RELATIVE_POSITION_AFTER = 1;
        const RELATIVE_POSITION_WITHIN = 2;

        const getNodeRelativePosition = (targetNode) => {
            if (sc.compareDocumentPosition(targetNode) & Node.DOCUMENT_POSITION_PRECEDING) {
                return RELATIVE_POSITION_BEFORE;
            }
            if (ec.compareDocumentPosition(targetNode) & Node.DOCUMENT_POSITION_FOLLOWING) {
                return RELATIVE_POSITION_AFTER;
            }
            return RELATIVE_POSITION_WITHIN;
        };
        const getValidNextNodes = (startNode) => {
            const nodes = [];
            let node = startNode.nextElementSibling;

            while (node) {
                if (GB.TAGS.LIST.ITEMS.has(node.nodeName)) {
                    nodes.push(node);
                }
                node = node.nextElementSibling;
            }
            return nodes;
        };
        const getNodeInformation = (node) => {
            const parentNode = node.parentNode;
            const listItem = this.getListItemElement(parentNode);
            let refNode = null;

            if (listItem) {
                refNode = listItem.nextElementSibling || listItem;
            }

            return {
                listItem: node,
                listStart: parentNode,
                firstChild: parentNode.firstElementChild === node,
                lastChild: parentNode.lastElementChild === node,
                refNode: refNode
            };
        };

        let currNode = walker.root;
        const getNextValidNode = (treeWalker, curNode) => {
            let nextNode = treeWalker.nextSibling();
            if (!nextNode) {
                nextNode = treeWalker.nextNode();
                while (nextNode && curNode.contains(nextNode)) {
                    nextNode = treeWalker.nextNode();
                }
            }
            return nextNode;
        };

        while (currNode) {
            const position = getNodeRelativePosition(currNode);
            if (position === RELATIVE_POSITION_AFTER) {
                break;
            }
            if (position === RELATIVE_POSITION_WITHIN) {
                const nodeInfo = getNodeInformation(currNode);
                targetNodes.push(nodeInfo);

                if (currNode === walker.root) {
                    break;
                }

                currNode = getNextValidNode(walker, currNode);
            } else {
                currNode = walker.nextNode();
            }
        }

        const createNewListElement = (listStart, lastChild) => {
            return lastChild && this.isListStartElement(lastChild)
                ? lastChild
                : this.createElement(listStart ? listStart.nodeName : 'OL');
        };

        const handleLastNode = (nodes, idx, lastChild, currElem) => {
            if (!lastChild && nodes.length === idx + 1) {
                const listStart = this.getListStartElement(currElem);
                const newListStart = createNewListElement(listStart, currElem.lastChild);
                const validNextNodes = getValidNextNodes(currElem);

                if (validNextNodes.length) {
                    newListStart.append(...validNextNodes);
                }

                currElem.append(newListStart);
            }
        };

        const RANGE_ACTIONS = {
            createWrappedParagraph: (range, itemNode) => {
                const p = this.createElement('p');
                range.selectNode(itemNode);
                range.surroundContents(p);
                return p;
            },
            insertParagraphAfterNode: (paragraph, refNode, altNode) => {
                if (altNode) {
                    altNode.after(paragraph);
                } else {
                    refNode.after(paragraph);
                }
            },
            moveItemContentsToParagraph: (range, listItem, parentNode, insertAfterNode) => {
                const paragraph = RANGE_ACTIONS.createWrappedParagraph(range, listItem);
                RANGE_ACTIONS.insertParagraphAfterNode(paragraph, parentNode, insertAfterNode);

                range.selectNodeContents(listItem);
                paragraph.appendChild(range.extractContents());
                listItem.remove();
                this.removeEmptyNode(parentNode);

                return paragraph;
            }
        };

        const insertNodeAtRefNode = (refNode, currItem, currStart, insertAfterNode) => {
            if (!refNode) {
                return insertAfterNode;
            }

            if (refNode.contains(currStart)) {
                const targetNode = insertAfterNode || refNode;
                targetNode.after(currItem);
                return currItem;
            }
            refNode.before(currItem);
            return insertAfterNode;
        };

        let insertAfterNode = null, insertAfterRefNode = null;
        const processInsertPosition = (refNode, currItem, currStart, range) => {
            if (refNode) {
                insertAfterRefNode = insertNodeAtRefNode(refNode, currItem, currStart, insertAfterRefNode);
                this.removeEmptyNode(currStart);
            } else {
                const paragraph = RANGE_ACTIONS.moveItemContentsToParagraph(range, currItem, currStart, insertAfterNode);
                const listStart = paragraph.querySelector([...GB.TAGS.LIST.STARTS].join(','));

                if (listStart) {
                    paragraph.after(listStart);
                    insertAfterNode = listStart;
                } else {
                    insertAfterNode = paragraph;
                }
            }
        };

        targetNodes.forEach(({listItem, listStart, firstChild, lastChild, refNode}, idx) => {
            handleLastNode(targetNodes, idx, lastChild, listItem);
            processInsertPosition(refNode, listItem, listStart, this.createRange());
        });

        this.restoreRangeMarker(staticRange);
    }

    insertListCommand(command) {
        const button = this.toolbar[command.substring(6)];
        const range = this.getRange();

        if (button.checked) {
            this.outdentListElement(range);
            return;
        }

        const selection = this.getSelection();
        const currElem = this.getRangeElement(range);
        const existingList = this.getListStartElement(currElem);

        if (existingList) {
            this.handleExistingList(command, range, selection, currElem, existingList);
        } else {
            this.createNewList(command, range, currElem);
        }
    }

    handleExistingList(command, range, selection, currElem, existingList) {
        const endContainerParent = this.getParentIfTextNode(range.endContainer);
        const rangeMarker = this.saveRangeMarker(range);
        const isEndOutsideList = !this.getListStartElement(endContainerParent);

        if (isEndOutsideList) {
            selection.empty();
            range.setStartAfter(existingList);
            range.setEndAfter(endContainerParent);
            selection.addRange(range);
            command = null;
        } else if (command) {
            this.toggleListType(command, existingList);
            command = null;
        }

        this.restoreRangeMarker(rangeMarker);

        if (command) {
            this.queryCommand(command);
        }

        this.cleanupListStructure(selection);
    }

    createNewList(command, range, focusElem) {
        const INSERT_COMMAND = 'InsertUnOrderedList';
        const rangeMarker = this.saveRangeMarker(range);

        try {
            const listTagName = command === INSERT_COMMAND ? 'UL' : 'OL';
            const { listNode, liNode } = this.createListWithItem(listTagName);

            let currElem = focusElem;
            let targetElem = null;
            let shouldReplaceTarget = false;

            while (currElem) {
                targetElem = currElem;

                if (GB.TAGS.LIST.VALID_PARENTS.has(currElem.nodeName)) {
                    shouldReplaceTarget = true;
                    break;
                }

                if (this.isBlockElement(currElem)) {
                    shouldReplaceTarget = false;
                    break;
                }

                const parentNode = currElem.parentNode;

                if (parentNode && this.isBody(parentNode)) {
                    shouldReplaceTarget = true;
                    break;
                }

                currElem = parentNode;
            }

            if (!targetElem || this.isBody(targetElem)) {
                return;
            }

            listNode.append(liNode);

            if (!shouldReplaceTarget) {
                targetElem = this.cleanNestedParagraph(targetElem);
                targetElem.before(listNode);

                if (GB.TAGS.LIST.REPLACE_PARENTS.has(targetElem.nodeName)) {
                    liNode.append(...targetElem.childNodes);
                    targetElem.remove();
                } else {
                    liNode.append(targetElem);
                }

                if (liNode.innerHTML.trim() === '') {
                    liNode.append(this.createElement('br'));
                }

                return;
            }

            liNode.prepend(...targetElem.childNodes);
            targetElem.append(listNode);
        } finally {
            this.restoreRangeMarker(rangeMarker);
        }
    }

    createListWithItem(listTagName) {
        return {
            listNode: this.createElement(listTagName),
            liNode: this.createElement('li'),
        };
    }

    toggleListType(aCommand, existingList) {
        const targetTag = aCommand === 'InsertUnOrderedList' ? 'UL' : 'OL';
        if (existingList.nodeName !== targetTag) {
            const newList = this.createElement(targetTag);
            newList.replaceChildren(...existingList.childNodes);
            existingList.replaceWith(newList);
        }
    }

    cleanupListStructure(selection) {
        const range = selection.getRangeAt(0);
        const staticRange = this.createStaticRange(range);
        const finalElement = this.getRangeElement(staticRange);
        const finalRefList = this.getListStartElement(finalElement);

        if (finalRefList) {
            const parentNode = finalRefList.parentNode;
            console.log(parentNode);
            if (parentNode && parentNode.nodeName === 'P' && parentNode.childNodes.length === 1) {
                parentNode.replaceWith(parentNode.firstChild);
            }
        }

        this.restoreStaticRange(selection, staticRange);
    }

    setPictureResizer(resizer, picture) {
        const rect = picture.getBoundingClientRect();
        resizer.style.width = `${rect.width}px`;
        resizer.style.height = `${rect.height}px`;
    }

    createImageResizeEventHandler(resizerWrapper) {
        const MINIMUM_SIZE = 16;

        const findRootBlockElement = (node) => {
            let root = node.parentElement;
            while (root && !this.isBody(root) && !this.isBlockElement(root)) {
                root = root.parentElement;
            }
            return root;
        };

        const calculateNewWidth = (currentWidth, mouseX, evt, resizer) => {
            const xPos = this.getPageX(evt) - mouseX;
            const isRightHandle = resizer.classList.contains('resizer-handle-bottom-right') ||
                resizer.classList.contains('resizer-handle-top-right');
            return isRightHandle ? currentWidth + xPos : currentWidth - xPos;
        };

        resizerWrapper.childNodes.forEach((resizerNode) => {
            this.addEvent(resizerNode, this.pointerEvents.start, (startEvent) => {
                this.stopEvent(startEvent);

                const targetNode = resizerNode.closest('figure');
                if (!targetNode) return;

                this.classChangeObserver.disconnect();
                this.popover.hidePopover();

                const pictureNode = targetNode.querySelector('picture');
                const status = this.createElement('div');
                status.className = 'image-resize-status';
                targetNode.appendChild(status);

                const rootNode = findRootBlockElement(targetNode);
                const rootNodeWidth = this.getElementWidth(rootNode);
                const initialTargetWidth = this.getElementWidth(targetNode);
                const initialMouseX = this.getPageX(startEvent);

                const resizeHandler = (moveEvent) => {
                    const newWidth = calculateNewWidth(initialTargetWidth, initialMouseX, moveEvent, resizerNode);
                    if (newWidth > MINIMUM_SIZE) {
                        const newWidthPercent = ((100 * newWidth) / rootNodeWidth).toFixed(1);
                        targetNode.style.width = `${newWidthPercent}%`;
                        status.textContent = `${newWidthPercent}%`;
                        resizerWrapper.style.height = `${pictureNode.offsetHeight}px`;
                    }
                };

                const stopResizeHandler = () => {
                    this.removeEvent(this.doc, this.pointerEvents.move, resizeHandler);
                    this.removeEvent(this.doc, this.pointerEvents.end, stopResizeHandler);
                    status.remove();

                    this.classChangeObserver.observe(targetNode, { attributes: true });
                    targetNode.classList.add('active');
                };

                this.addEvent(this.doc, this.pointerEvents.move, resizeHandler);
                this.addEvent(this.doc, this.pointerEvents.end, stopResizeHandler);
                this.addEventPictureBogusCaret();
            });
        });
    }

    addEventPictureBogusCaret() {
        const imageResizingEvent = new CustomEvent("image-resizing", {
            cancelable: true,
            bubbles: true,
            detail: 'image-resizing',
        });

        this.bogusCaret.dispatchEvent(imageResizingEvent);
    }

    getElementWidth(elem) {
        return parseFloat(getComputedStyle(elem, null)
            .getPropertyValue('width')
            .replace('px', ''));
    }

    createModifyImageHandler(fig) {
        const pic = fig.querySelector('picture');
        if (!pic) return;

        const resizer = this.cheditor.imageResizer.cloneNode(true);
        this.setPictureResizer(resizer, pic);

        fig.appendChild(resizer);

        this.createImageResizeEventHandler(resizer);
        this.createBogusCaret(fig);
        this.elementResizer = resizer;
    }

    hasBogusCaret(sel = null) {
        if (!this.bogusCaret) return null;

        sel = sel || this.getSelection();
        if (sel.type === 'None') return null;

        const caret = this.bogusCaret;
        const collapsed = sel.isCollapsed;
        const tgtNode = caret.targetNode;
        const figCap = tgtNode.querySelector('figcaption');

        return {
            isCollapsed: collapsed,
            hasCaret: !collapsed && sel.focusNode.isSameNode(caret),
            fakeNode: caret,
            figcaption: figCap,
            disabled: tgtNode.classList.contains('disabled'),
            hasInputFocus: (el) => figCap?.contains(el || sel.focusNode),
            selectNodeContents: () => sel.selectAllChildren(caret),
        };
    }

    clearHelperNodes() {
        const disabledFigureNodes = this.doc.querySelectorAll('figure.disabled');
        disabledFigureNodes.forEach(node => {
            node.classList.remove('disabled');
        });

        const contentEditableNodes = this.doc.querySelectorAll('[contenteditable="true"]');
        contentEditableNodes.forEach(node => {
            node.removeAttribute('contenteditable');
        });

        this.removeElementController();
    }

    removeBogusCaret() {
        if (this.hasBogusCaret()) {
            return false;
        }
        this.removeElementController();
        return true;
    }

    selectionBogusCaret(selection = null) {
        const fakeCaret = this.hasBogusCaret();

        if (fakeCaret?.isCollapsed) {
            selection = selection || this.getSelection();
            selection.selectAllChildren(fakeCaret.fakeNode);
        }
    }

    createBogusCaret(tgtNode) {
        const caret = this.createElement('div');

        caret.className = 'is-bogus-caret active';
        caret.textContent = 'is fake caret node.';
        caret.targetNode = tgtNode;

        this.bogusCaret = this.body.appendChild(caret);

        const sel = this.getSelection();
        sel.selectAllChildren(this.bogusCaret);
    }

    isInBody(node) {
        return this.isBody(node) ? false : this.body.contains(node);
    }

    isBody(node) {
        return this.body.isSameNode(node);
    }

    determineCurrentNode(node) {
        const range = this.getRange();
        const commonAncestor = range.commonAncestorContainer;

        if (!this.isElementNode(node) || !this.isInBody(node)) {
            return this.getParentIfTextNode(commonAncestor);
        }

        if (range.collapsed) {
            return node;
        }

        const fakeCaret = this.hasBogusCaret();
        const rangeNode = this.getRangeElement(range);

        if (fakeCaret) {
            if (!fakeCaret.fakeNode?.isSameNode(commonAncestor)) {
                node = rangeNode;
                range.selectNodeContents(fakeCaret.fakeNode);
            }
            return node;
        }

        return rangeNode;
    }

    updateEditBlock(command, curNode) {
        if (command === 'img') {
            const figure = curNode.closest('figure');
            if (figure) {
                this.pauseSelectionTracking();
                this.createImageFigure(figure, curNode);
                this.figCaptionFocus(figure);
                this.resumeSelectionTracking();
            }
        }
    }

    removeTableButton(figure) {
        const btn = figure.querySelector('.btn-figure');
        if (btn) {
            btn.remove();
        }
    }

    createTableButton(figure) {
        const buttonWrapper = this.createElement('div');
        const btnRemove = this.createElement('div');
        buttonWrapper.append(btnRemove);
        buttonWrapper.className = 'btn-figure';
        btnRemove.className = 'btn-remove';

        this.addEvent(btnRemove, 'mousedown', evt => this.stopEvent(evt));
        this.addEvent(btnRemove, 'click', () => this.removeNode(figure));

        figure.append(buttonWrapper);
    }

    createTagLabel(text) {
        const span = this.createElement('span');
        span.className = 'tag-name';
        span.append(text);
        return span;
    }

    createTagItemNode() {
        const li = this.createElement('li');
        li.className = 'tag-selector-item';
        return li;
    }

    createTagSelector(tag) {
        const tagName = tag.tagName;
        let anchor;

        if (tagName === 'FIGURE') {
            anchor = this.createTagLabel(tagName);
        } else {
            anchor = this.createElement('a');
            anchor.href = '#';
            anchor.el = tag;
            anchor.textContent = tagName;
        }

        const item = this.createTagItemNode();
        return { anchor: anchor, item };
    }

    buildTagHierarchy(node) {
        const hierarchy = [];
        while (node && !this.isBody(node)) {
            hierarchy.unshift(node);
            node = node.parentNode;
        }
        return hierarchy;
    }

    outputTagSelector(currElem) {
        const { htmlTagSelector } = this.cheditor;
        this.emptyChildren(htmlTagSelector);

        if (!currElem) {
            currElem = this.getRangeElement(this.getRange());
        }

        const { anchor:startAnchor, item:startItem } = this.createTagSelector(this.body);

        startItem.append(startAnchor);
        htmlTagSelector.append(startItem);

        if (this.isBody(currElem)) {
            htmlTagSelector.append(this.createTagItemNode());
            return;
        }

        let lastItem;
        const hasBogusCaret = this.hasBogusCaret() || currElem.closest('figcaption');

        if (hasBogusCaret && hasBogusCaret.fakeNode === currElem) {
            currElem = currElem.targetNode?.querySelector('img');
        }

        this.buildTagHierarchy(currElem).forEach((elem, idx) => {
            const { anchor, item } = this.createTagSelector(elem);
            const isTableInFigure = elem.tagName === 'TABLE' && elem.parentElement.tagName === 'FIGURE';
            const isQuickInsertTarget = !hasBogusCaret && GB.TAGS.QUICK_INSERT_PARAGRAPH.has(elem.tagName) && !isTableInFigure;

            if (idx === 0 || isQuickInsertTarget) {
                const insertTop = this.quickInsertParagraphEventHandler(elem, 'top');
                const insertBottom = this.quickInsertParagraphEventHandler(elem, 'bottom');
                item.append(insertTop, anchor, insertBottom);
            } else {
                const label = hasBogusCaret ? this.createTagLabel(anchor.textContent) : anchor;
                item.append(label);
            }

            htmlTagSelector.append(item);
            lastItem = item;
        });

        if (lastItem) {
            const endNode = lastItem.cloneNode(false);
            endNode.append(this.createNbspTextNode());
            htmlTagSelector.append(endNode);
        }
    }

    quickInsertParagraphEventHandler(targetEl, pos) {
        const btn = this.createElement('span');

        btn.dataset.insert = pos;
        btn.el = targetEl;
        btn.className = `insert-paragraph-btn-${pos}`;

        this.addEvent(btn, 'mouseenter', e => {
            this.showInsertParagraphLine(e);
            this.showNodeRange(e.target.el);
        });
        this.addEvent(btn, 'mouseleave', e => {
            this.cheditor.insertParagraphLine.classList.add('d-none');
            this.hideNodeRange(e.target.el);
        });
        this.addEvent(btn, 'click', e => {
            this.insertParagraphTopBottom(`insert-paragraph-${pos}`,
                e.target.el, this.getSelection());
            this.cheditor.insertParagraphLine.classList.add('d-none');
            this.hideNodeRange(e.target.el);
        });

        return btn;
    }

    showNodeRange(elem) {
        elem.classList.add('show-node-range');
    }

    hideNodeRange(elem) {
        elem.classList.remove('show-node-range');
        if (elem.classList.length === 0) {
            elem.removeAttribute('class');
        }
    }

    showInsertParagraphLine(evt) {
        const { scrollTop } = this.scrollXY();
        const targetElement = evt.target.el;
        const position = evt.target.dataset;
        const rect = this.getOffsetBox(targetElement);
        let targetOffsetTop = rect.top;

        const updateParagraphLinePosition = (position) => {
            this.cheditor.insertParagraphLine.style.top = position + 'px';
            this.cheditor.insertParagraphLine.style.left = 5 + 'px';
            this.cheditor.insertParagraphLine.style.width = this.body.scrollWidth - 10 + 'px';
            this.cheditor.insertParagraphLine.classList.remove('d-none');
        };

        if (position.insert === 'bottom') {
            targetOffsetTop += rect.height;
        }

        const paragraphLinePosition = targetOffsetTop - scrollTop;
        updateParagraphLinePosition(paragraphLinePosition);

        // this.body.append(this.cheditor.insertParagraphLine);
        // console.log(position, targetElement);
        // const self = this;
        // const popper = this.createPopper(targetElement, this.cheditor.insertParagraphLine, {
        //     placement: position.insert,
        //     modifiers: [
        //         {
        //             name: 'offset',
        //             options: {
        //                 offset: ({ placement, reference, popper }) => {
        //                     console.log(placement, reference, popper);
        //                     return [0, -32];
        //                 },
        //             },
                // }, {
                //     name: 'preventOverflow',
                //     enabled: true,
                //     phase: 'main',
                //     options: {
                //         mainAxis: false,
                        // tether: false,
                        // boundary: self.appRoot,
                        // rootBoundary: 'document',
                        // elementContext: 'reference',
                    // },
                // }, {
                //     name: 'detectOverflow',
                //     enabled: true,
                //     phase: 'main',
                //     requireIfExists: ['offset'],
                //     fn({ state }) {
                //         const overflow = self.popper.detectOverflow(state, {
                //             boundary: self.appRoot,
                //             rootBoundary: 'document',
                //             elementContext: 'reference',
                //         });
                //         const popper = {
                //             ...state.rects,
                //             popper: { ...state.rects.popper, x: 0, y: overflow.top },
                //         };
                //         const stateWithOverflow = { ...state, rects: popper };
                //         console.log(stateWithOverflow);
                //         console.log(state.elements.popper);
                //         return { ...state, stateWithOverflow };
                //     }
        //         }
        //     ],
        // });
    }

/*
    getTableCellIndex(cell) {
        const row = cell.closest('tr');
        const rowRect = row.getBoundingClientRect();
        const colRect = cell.getBoundingClientRect();
        let colWidth = (colRect.width / rowRect.width) * 100;

        return { rowIndex: row.rowIndex, cellIndex: cell.cellIndex };
    }
*/

    handleFirefoxEditableMode(elem, isFirefoxEditable) {
        if (isFirefoxEditable) {
            const blurEventHandler = () => {
                this.setDesignMode(true);
                this.removeEvent(elem, 'blur', blurEventHandler);
            };
            this.addEvent(elem, 'blur', blurEventHandler);
            this.setDesignMode(false);
            elem.focus();
        }
        return 'table';
    }

    isValidFigureElement(elem) {
        return elem?.classList.contains('video');
    }

    handleFigureCommand(elem) {
        if (!this.isValidFigureElement(elem)) return;

        elem.classList.add('active');
        this.createBogusCaret(elem);
        this.createPopover(elem);
    }

    figCaptionFocus(figure) {
        const figcaption = figure.querySelector('figcaption');
        if (figcaption) {
            const selection = this.getSelection();
            selection.selectAllChildren(figcaption);
            selection.collapseToEnd();
        }
    }

    getCommandFromElement(elem) {
        if (!elem?.tagName) return null;

        if (elem.classList.contains('video-wrapper')) {
            elem = elem.closest('figure');
        }

        const isFirefoxEditableCell =
            GB.browser.firefox && elem.hasAttribute('contenteditable');

        switch (elem.tagName.toLowerCase()) {
            case 'img':
                return 'img';
            case 'td': case 'th':
                return this.handleFirefoxEditableMode(elem, isFirefoxEditableCell);
            case 'figure':
                if (elem.classList.contains('video')) {
                    this.handleFigureCommand(elem);
                    this.figCaptionFocus(elem);
                }
                break;
            default:
                return elem.classList.contains('resizer') ? 'resizer' : null;
        }
    }

    resolveTargetNode(targetNode) {
        if (!targetNode) return null;

        let curNode = targetNode;

        if (this.isBody(curNode)) {
            curNode = this.getSelection().focusNode;
            if (!curNode) return null;
        }

        curNode = this.getParentIfTextNode(curNode);

        if (curNode.nodeName === 'FIGCAPTION' || curNode.nodeName === 'PICTURE') {
            const fig = curNode.closest('figure');
            if (fig) {
                curNode = fig;
            }
        }

        if (curNode.nodeName === 'FIGURE') {
            const img = curNode.querySelector('img');
            if (img) {
                return img;
            }
        }

        return curNode;
    }

    editareaEventHandler(evt) {
        const targetNode = this.resolveTargetNode(evt.target);
        if (!targetNode) return;

        const curNode = this.determineCurrentNode(targetNode);
        const cmd = this.getCommandFromElement(curNode);

        this.updateEditBlock(cmd, curNode);
        this.updateToolbar(evt, curNode);
    }

    createImageFigure(fig, img = null) {
        if (!img) {
            img = fig.querySelector('img');
            if (!img) return;
        }

        const fakeCaret = this.hasBogusCaret();
        if (fakeCaret?.fakeNode?.targetNode === fig) {
            return;
        }

        fig.ondragstart = () => false;
        this.createElementController(fig);
    }

    popoverBtnEventHandler(evt) {
        const btn = evt.target;
        const popover = btn.closest('.image-control-popover');

        if (!popover.hasAttribute('popover')) {
            return;
        }

        const fig = popover['targetNode'];
        const cmd = btn.dataset.cmd;

        if (this.isUndefined(cmd) || this.isUndefined(fig)) {
            return;
        }

        const resizer = fig.querySelector('.resizer');
        const pic = fig.querySelector('picture');
        const sel = this.getSelection();
        let figCap = null;

        switch (cmd) {
            case 'insert-paragraph-top':
            case 'insert-paragraph-bottom':
                this.insertParagraphTopBottom(cmd, fig, sel);
                break;
            case 'remove':
                if (this.removeNode(fig, sel)) {
                    this.removeElementController();
                }
                break;
            case 'figcaption':
                figCap = fig.querySelector('figcaption');
                if (figCap) {
                    figCap.remove();
                    btn.classList.remove('active');
                    this.addEventPictureBogusCaret();
                    this.selectionBogusCaret(sel);
                    this.updateCaptionButtonTooltip(btn);
                } else {
                    this.handleCaptionCreation(fig, sel);
                }
                popover.popper.update();
                break;
            case 'left': case 'center': case 'right':
                this.alignFigure(cmd, fig, resizer, pic);
                this.setPopoverAlignButton(fig);
                popover.popper.update();
                break;
            case 'reset':
                this.alignFigure(cmd, fig, resizer, pic);
                break;
            default:
                popover.hidePopover();
        }
    }

    insertParagraphTopBottom(cmd, el, sel) {
        const p = this.createEmptyParagraph();

        if (cmd === 'insert-paragraph-bottom') {
            el.after(p);
        } else {
            el.before(p);
        }

        this.removeElementController();
        sel.empty();
        sel.setPosition(p, 0);
    }

    createFigCaptionElement() {
        const el = this.createElement('figcaption');
        el.setAttribute('style', GB.STYLES.CAPTION.css);
        GB.STYLES.CAPTION.attrs.forEach(attr => el.setAttribute(attr.name, attr.value));
        return el;
    }

    createFigCaptionEventHandler(fig, figCap, sel) {
        this.addEvent(figCap, 'focus', () => {
            if (this.bogusCaret?.targetNode !== fig) {
                this.createElementController(fig);
            }
        });

        if (GB.browser.firefox) {
            this.addEvent(figCap, 'blur', () => this.handleCaptionBlur(sel));
            this.addEvent(figCap, 'mousedown', () => this.setDesignMode(false));
            this.setDesignMode(false);
        }
    }

    updateCaptionButtonTooltip(btn) {
        const popper = btn.popper;
        if (popper) {
            popper.state.elements.popper.firstChild.textContent =
                btn.classList.contains('active') ? '캡션 삭제' : '캡션 넣기';
        }
    }

    handleCaptionCreation(fig, sel) {
        const attrName = 'contenteditable';
        const toggleEditable = (state) => figCap.setAttribute(attrName, state);
        const figCap = this.createFigCaptionElement();

        figCap.append(this.createElement('br'));
        fig.append(figCap);

        const figCapBtn = this.popover.querySelector('.btn-figcaption').parentNode;
        figCapBtn.classList.add('active');
        this.updateCaptionButtonTooltip(figCapBtn);

        this.createFigCaptionEventHandler(fig, figCap, sel);

        if (!figCap.hasAttribute(attrName)) {
            toggleEditable(true);
        }

        sel.setPosition(figCap, 0);
    }

    alignFigure(cmd, fig, resizer, pic) {
        if (cmd === 'reset') {
            fig.style.removeProperty('width');
            resizer.style.height = pic.offsetHeight + 'px';
        } else {
            fig.style.margin = GB.STYLES.FIGURE.alignment[cmd];
        }
    }

    /* firefox */
    handleCaptionBlur(sel) {
        let focusNode = this.getParentIfTextNode(sel.focusNode);

        if (!focusNode.closest('figcaption')) {
            this.setDesignMode(true);
            return;
        }

        setTimeout(() => {
            this.setDesignMode(true);
        }, 300);
    }

    createPopoverEvent(evt) {
        this.stopEvent(evt);
        const customEvt = new CustomEvent("click-popover", {
            cancelable: true,
            bubbles: true,
            detail: 'click-popover',
        });
        this.popover.dispatchEvent(customEvt);
    }

    getFigureAlign(fig) {
        const { style } = fig;

        if (style.marginLeft === 'auto' && style.marginRight === 'auto') {
            return 'center';
        }
        if (style.marginLeft === 'auto' && style.marginRight !== 'auto') {
            return 'right';
        }

        return 'left';
    }

    setPopoverAlignButton(fig) {
        const figAlign = this.getFigureAlign(fig);
        this.popover.querySelectorAll('span[class*="btn-align" i]')
            .forEach((el) => {
                const btn = el.closest('.btn-popover');
                btn.classList.toggle('active', figAlign === btn.dataset.cmd);
            });
    }

    createPopover(fig) {
        if (this.popover) return;

        const popover = this.cheditor.imagePopover.cloneNode(true);
        popover.targetNode = fig;

        const img = fig.querySelector('img');
        if (!img) {
            popover.querySelector('.btn-reset').classList.add('d-none');
        }

        const setupPopoverEvents = () => {
            [this.pointerEvents.end, this.pointerEvents.start]
                .forEach(type => this.addEvent(popover, type, evt => this.stopEvent(evt)));
            this.addEvent(popover, this.pointerEvents.end, evt => this.popoverBtnEventHandler(evt));
            this.addEvent(popover, this.pointerEvents.start, (evt) => this.createPopoverEvent(evt));
        };

        this.addEvent(popover, 'toggle', evt => {
            const figCapExists = fig.querySelector('figcaption');
            const figCapBtn = popover.querySelector('.btn-figcaption');

            if (evt.newState === 'open') {
                if (figCapExists) {
                    figCapBtn.parentNode.classList.add('active');
                }

                if (typeof popover.popper !== 'undefined') {
                    popover.popper.update();
                    return;
                }

                popover.popper = this.createPopper(fig, popover, {
                    placement: 'top',
                    modifiers: [{name: 'offset', options: {offset: [0, -20]}}]
                });

                const buttons = popover.querySelectorAll('.btn-popover');
                buttons.forEach(btn => {
                    if (!btn.popper) {
                        const SHOW_DELAY = 300;
                        const PLACEMENT = 'bottom';
                        let showTimeoutId, popper = null;

                        this.addEvent(btn, 'mouseenter', () => {
                            const tooltip = this.createTooltipElement(btn.dataset.tooltip, true);
                            popper = this.createPopper(btn, tooltip, {
                                placement: PLACEMENT,
                                modifiers: [{name: 'offset', options: {offset: [0, 8]}}]
                            });
                            popover.append(tooltip);
                            btn.popper = popper;

                            showTimeoutId = setTimeout(() => {
                                popper.update();
                                tooltip.classList.add('show');
                            }, SHOW_DELAY);

                            if (btn.dataset.cmd === 'figcaption' && btn.classList.contains('active')) {
                                this.updateCaptionButtonTooltip(btn);
                            }
                        });
                        this.addEvent(btn, 'mouseleave', () => {
                            if (popper) {
                                popper.state.elements.popper.remove();
                                popper.destroy();
                                popper = null;
                            }
                            if (showTimeoutId) clearTimeout(showTimeoutId);
                        });
                    }
                });
            } else if (evt.newState === 'close') {
                if (popover.popper) {
                    popover.popper.destroy();
                    popover.popper = null;
                }
            }
        });

        this.popover = this.body.appendChild(popover);
        setupPopoverEvents();
        this.setPopoverAlignButton(fig);
    }

    removePopover() {
        if (this.popover) {
            this.popover.remove();
            this.popover = null;
        }
    }

    createHandleClassChange(mutations, observer) {
        for (const mutation of mutations) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const muTarget = mutation.target;
                if (muTarget.classList.contains('active')) {
                    this.popover?.showPopover();
                } else {
                    this.popover?.hidePopover();
                }
                break;
            }
        }
    }

    createElementController(figure) {
        this.removeElementController();
        this.createModifyImageHandler(figure);
        this.createPopover(figure);
        this.classChangeObserver.observe(figure, { attributes: true });
        figure.classList.add('active');
    }

    cleanUpElement(elem) {
        if (this[elem]) {
            this[elem].remove();
            this[elem] = null;
        }
    }

    removeElementController() {
        const fakeCaret = this.hasBogusCaret();
        if (!fakeCaret) return;

        this.classChangeObserver.disconnect();

        const tgtNode = fakeCaret.fakeNode?.targetNode;
        if (tgtNode) {
            tgtNode.classList.remove('active', 'disabled');
            if (tgtNode.classList.length < 1) {
                tgtNode.removeAttribute('class');
            }
            this.removeTableButton(tgtNode);
        }

        this.removePopover();
        this.cleanUpElement('elementResizer');
        this.cleanUpElement('bogusCaret');
    }

    cutSelectedNode() {
        const NON_REMOVABLE_TAGS = ['TD', 'TH'];
        const selection = this.getSelection();

        selection.deleteFromDocument();

        const rangeElem = this.getRangeElement(selection.getRangeAt(0));
        let currNode = rangeElem, parentNode;

        while (currNode &&
            !currNode.hasChildNodes() &&
            this.isInBody(currNode) &&
            !NON_REMOVABLE_TAGS.includes(currNode.tagName)) {
            parentNode = currNode.parentNode;
            currNode.remove();
            currNode = parentNode;
        }
    }

    tagSelection(parentNode) {
        const selection = this.getSelection();
        selection.selectAllChildren(parentNode);
    }

    getBrowser() { return GB.browser; }
}

// 호환성 유지를 위해 기존이름도 제공
// const cheditor = CHEditor;
// export default CHEditor;

(function () {
    const dragWindow = {
        obj: null,

        init: function (drag, oRoot, minX, maxX, minY, maxY) {
            const setDefaultStyle = () => {
                drag.style.cursor = 'default';
            };

            setDefaultStyle();
            drag.addEventListener(drag.pointerEvents.start, dragWindow.start, { passive: false });
            drag.onmouseover = setDefaultStyle;

            drag.hmode = true;
            drag.vmode = true;
            drag.root = oRoot;
            drag.transId = `${oRoot.id}_trans`;

            const initPos = (isHMode, styleProp) => {
                if (isNaN(parseInt(drag.root.style[styleProp], 10))) {
                    drag.root.style[styleProp] = '0';
                }
            };

            initPos(drag.hmode, drag.hmode ? 'left' : 'right');
            initPos(drag.vmode, drag.vmode ? 'top' : 'bottom');

            drag.minX = minX ?? null;
            drag.maxX = maxX ?? null;
            drag.minY = minY ?? null;
            drag.maxY = maxY ?? null;

            drag.root.onDragStart = () => {};
            drag.root.onDragEnd = () => {};
            drag.root.onDrag = () => {};
        },

        getEventCoordinates: function (evt) {
            const source = this.obj.isTouchEvent ? evt.touches[0] : evt;
            return { x: source.clientX, y: source.clientY };
        },

        start: function (evt) {
            const drag = dragWindow.obj = this;
            const coords = dragWindow.getEventCoordinates(evt);
            const x = parseInt(drag.hmode ? drag.root.style.left : drag.root.style.right, 10);
            const y = parseInt(drag.vmode ? drag.root.style.top : drag.root.style.bottom, 10);

            dragWindow.fixEvent(evt);
            drag.root.onDragStart(x, y);

            drag.lastMouseX = coords.x;
            drag.lastMouseY = coords.y;

            document.addEventListener(drag.pointerEvents.move, dragWindow.drag, { passive: false });
            document.addEventListener(drag.pointerEvents.end, dragWindow.end, { passive: false });

            const lastEl = drag.root.lastElementChild;
            if (lastEl?.id !== drag.transId) {
                const dragBackdrop = document.createElement('div');
                dragBackdrop.className = 'modal-backdrop contents-backdrop';
                dragBackdrop.id = drag.transId;
                Object.assign(dragBackdrop.style, {
                    top: `${lastEl.offsetTop}px`,
                    width: `${lastEl.offsetWidth}px`,
                    height: `${lastEl.offsetHeight}px`,
                    position: 'absolute'
                });
                drag.root.appendChild(dragBackdrop);
            }
            return false;
        },

        drag: function (evt) {
            dragWindow.fixEvent(evt);
            const drag = dragWindow.obj;
            const coords = dragWindow.getEventCoordinates(evt);

            const x = parseInt(drag.hmode ? drag.root.style.left : drag.root.style.right, 10);
            const y = parseInt(drag.vmode ? drag.root.style.top : drag.root.style.bottom, 10);

            const nx = x + (coords.x - drag.lastMouseX) * (drag.hmode ? 1 : -1);
            const ny = y + (coords.y - drag.lastMouseY) * (drag.vmode ? 1 : -1);

            drag.root.style.left = `${nx}px`;
            drag.root.style.top = `${ny}px`;
            drag.lastMouseX = coords.x;
            drag.lastMouseY = coords.y;

            drag.root.onDrag(nx, ny);
            return false;
        },

        end: function () {
            const drag = dragWindow.obj;
            document.removeEventListener(drag.pointerEvents.move, dragWindow.drag, false);
            document.removeEventListener(drag.pointerEvents.end, dragWindow.end, false);

            const finalX = parseInt(drag.root.style[drag.hmode ? 'left' : 'right'], 10);
            const finalY = parseInt(drag.root.style[drag.vmode ? 'top' : 'bottom'], 10);
            drag.root.onDragEnd(finalX, finalY);

            if (drag.root.lastElementChild?.id === drag.transId) {
                drag.root.lastElementChild.remove();
            }
            dragWindow.obj = null;
        },

        fixEvent: function (evt) {
            evt.preventDefault();
            const rect = evt.target.getBoundingClientRect();
            const coords = dragWindow.getEventCoordinates(evt);

            if (evt.layerX === undefined) {
                evt.layerX = dragWindow.obj.isTouchEvent ? coords.x - rect.x : evt.offsetX;
            }
            if (evt.layerY === undefined) {
                evt.layerY = dragWindow.obj.isTouchEvent ? coords.y - rect.y : evt.offsetY;
            }
            return evt;
        }
    };
    GB.dragWindow = dragWindow;
})();

// --------------------------------------------------------------------------
// Color Picker
//
(function () {
    const colorDropper = {
        images: {pad: [181, 101], sld: [16, 101], cross: [15, 15], arrow: [7, 11]},
        fetchElement: function (mixed) {
            return typeof mixed === 'string' ? document.getElementById(mixed) : mixed;
        },

        addEvent: function (el, ev, func) {
            el.addEventListener(ev, func, false);
        },

        fireEvent: function (el, ev) {
            if (!el) {
                return;
            }
            let c_ev = document.createEvent('HTMLEvents');
            c_ev.initEvent(ev, true, true);
            el.dispatchEvent(c_ev);
        },

        getElementPos: function (ev) {
            let e1 = ev, e2 = ev, x = 0, y = 0;
            if (e1.offsetParent) {
                do {
                    x += e1.offsetLeft;
                    y += e1.offsetTop;
                    e1 = e1.offsetParent;
                } while (e1);
            }

            while (e2 && e2.nodeName.toLowerCase() !== 'body') {
                x -= e2.scrollLeft;
                y -= e2.scrollTop;
                e2 = e2.parentNode;
            }
            return [x, y];
        },

        getElementSize: function (e) {
            return [e.offsetWidth, e.offsetHeight];
        },

        getRelMousePos: function (e) {
            let x = 0, y = 0;
            if (!e) {
                e = window.event;
            }
            if (typeof e.offsetX === 'number') {
                x = e.offsetX;
                y = e.offsetY;
            } else if (typeof e.layerX === 'number') {
                x = e.layerX;
                y = e.layerY;
            }
            return {x: x, y: y};
        },

        color: function (target, prop) {
            this.required = true;
            this.adjust = true;
            this.hash = true;
            this.caps = false;
            this.valueElement = target;
            this.styleElement = target;
            this.onImmediateChange = null;
            this.hsv = [0, 0, 1];
            this.rgb = [1, 1, 1];
            this.minH = 0;
            this.maxH = 6;
            this.minS = 0;
            this.maxS = 1;
            this.minV = 0;
            this.maxV = 1;

            // this.pickerOnfocus = true;
            this.pickerMode = 'HSV';
            this.pickerFace = 3;
            this.pickerFaceColor = '#fff';
            this.pickerInset = 1;
            this.pickerInsetColor = '#c2c9d6';
            // this.pickerZIndex = 10003;

            let p,
                self = this,
                modeID = this.pickerMode.toLowerCase() === 'hvs' ? 1 : 0,
                abortBlur = false,
                valueElement = colorDropper.fetchElement(this.valueElement),
                styleElement = colorDropper.fetchElement(this.styleElement),
                holdPad = false,
                holdSld = false,
                touchOffset = {},
                leaveValue = 1 << 0,
                leaveStyle = 1 << 1,
                leavePad = 1 << 2,
                leaveSld = 1 << 3,
                updateFieldEventHandler = function () {
                    self.fromString(valueElement.value, leaveValue);
                    dispatchImmediateChange();
                };

            colorDropper.addEvent(target, 'blur', function () {
                if (!abortBlur) {
                    window.setTimeout(function () {
                        abortBlur || blurTarget();
                        abortBlur = false;
                    }, 0);
                } else {
                    abortBlur = false;
                }
            });

            for (p in prop) {
                if (Object.hasOwn(prop, p)) {
                    this[p] = prop[p];
                }
            }

            this.hidePicker = function () {
                if (isPickerOwner()) {
                    removePicker();
                }
            };

            this.showPicker = function () {
                if (!isPickerOwner()) {
                    drawPicker();
                }
            };

            this.importColor = function () {
                if (!valueElement) {
                    this.exportColor();
                } else {
                    if (!this.adjust) {
                        if (!this.fromString(valueElement.value, leaveValue)) {
                            styleElement.style.backgroundImage = styleElement.jscStyle.backgroundImage;
                            styleElement.style.backgroundColor = styleElement.jscStyle.backgroundColor;
                            styleElement.style.color = styleElement.jscStyle.color;
                            this.exportColor(leaveValue | leaveStyle);
                        }
                    } else if (!this.required && /^\s*$/.test(valueElement.value)) {
                        valueElement.value = '';
                        styleElement.style.backgroundImage = styleElement.jscStyle.backgroundImage;
                        styleElement.style.backgroundColor = styleElement.jscStyle.backgroundColor;
                        styleElement.style.color = styleElement.jscStyle.color;
                        this.exportColor(leaveValue | leaveStyle);
                    } else if (this.fromString(valueElement.value)) {
                        // ignore
                    } else {
                        this.exportColor();
                    }
                }
            };

            this.exportColor = function (flags) {
                if (!(flags & leaveValue) && valueElement) {
                    let value = this.toString();
                    if (this.caps) {
                        value = value.toUpperCase();
                    }
                    if (this.hash) {
                        value = '#' + value;
                    }
                    valueElement.value = value;
                }
                if (!(flags & leaveStyle) && styleElement) {
                    styleElement.style.backgroundImage = 'none';
                    styleElement.style.backgroundColor = '#' + this.toString();
                    styleElement.style.color = 0.213 * this.rgb[0] + 0.715 * this.rgb[1] + 0.072 * this.rgb[2] < 0.5 ? '#ffffff' : '#000000';
                }
                if (!(flags & leavePad) && isPickerOwner()) {
                    redrawPad();
                }
                if (!(flags & leaveSld) && isPickerOwner()) {
                    redrawSld();
                }
            };

            this.fromHSV = function (h, s, v, flags) {
                if (h) {
                    h = Math.max(0.0, this.minH, Math.min(6.0, this.maxH, h));
                }
                if (s) {
                    s = Math.max(0.0, this.minS, Math.min(1.0, this.maxS, s));
                }
                if (v) {
                    v = Math.max(0.0, this.minV, Math.min(1.0, this.maxV, v));
                }

                this.rgb = this.HSV_RGB(
                    h === null ? this.hsv[0] : this.hsv[0] = h,
                    s === null ? this.hsv[1] : this.hsv[1] = s,
                    v === null ? this.hsv[2] : this.hsv[2] = v
                );
                this.exportColor(flags);
            };

            this.fromRGB = function (r, g, b, flags) {
                if (r) {
                    r = Math.max(0.0, Math.min(1.0, r));
                }
                if (g) {
                    g = Math.max(0.0, Math.min(1.0, g));
                }
                if (b) {
                    b = Math.max(0.0, Math.min(1.0, b));
                }

                const hsv = this.RGB_HSV(
                    r === null ? this.rgb[0] : r,
                    g === null ? this.rgb[1] : g,
                    b === null ? this.rgb[2] : b
                );
                if (hsv[0] !== null) {
                    this.hsv[0] = Math.max(0.0, this.minH, Math.min(6.0, this.maxH, hsv[0]));
                }
                if (hsv[2] !== 0) {
                    this.hsv[1] = hsv[1] === null ? null : Math.max(0.0, this.minS, Math.min(1.0, this.maxS, hsv[1]));
                }
                this.hsv[2] = hsv[2] === null ? null : Math.max(0.0, this.minV, Math.min(1.0, this.maxV, hsv[2]));

                const rgb = this.HSV_RGB(this.hsv[0], this.hsv[1], this.hsv[2]);
                this.rgb[0] = rgb[0];
                this.rgb[1] = rgb[1];
                this.rgb[2] = rgb[2];

                this.exportColor(flags);
            };

            this.fromString = function (hex, flags) {
                const m = hex.match(/^\W*([0-9A-F]{3}([0-9A-F]{3})?)\W*$/i);

                if (!m) {
                    valueElement.value = '색 없음';
                    valueElement.style.color = '#000';
                    valueElement.style.backgroundColor = '#fff';
                    return false;
                }

                if (m[1].length === 6) {
                    this.fromRGB(
                        parseInt(m[1].substring(0, 2), 16) / 255,
                        parseInt(m[1].substring(2, 4), 16) / 255,
                        parseInt(m[1].substring(4, 6), 16) / 255,
                        flags
                    );
                } else {
                    this.fromRGB(
                        parseInt(m[1].charAt(0) + m[1].charAt(0), 16) / 255,
                        parseInt(m[1].charAt(1) + m[1].charAt(1), 16) / 255,
                        parseInt(m[1].charAt(2) + m[1].charAt(2), 16) / 255,
                        flags
                    );
                }

                return true;
            };

            this.toString = function () {
                return (
                    (0x100 | Math.round(255 * this.rgb[0])).toString(16).substring(1) +
                    (0x100 | Math.round(255 * this.rgb[1])).toString(16).substring(1) +
                    (0x100 | Math.round(255 * this.rgb[2])).toString(16).substring(1)
                );
            };

            this.RGB_HSV = function (r, g, b) {
                const n = Math.min(Math.min(r, g), b),
                    v = Math.max(Math.max(r, g), b),
                    m = v - n;
                if (m === 0) {
                    return [null, 0, v];
                }
                let h = r === n ? 3 + (b - g) / m : g === n ? 5 + (r - b) / m : 1 + (g - r) / m;
                return [h === 6 ? 0 : h, m / v, v];
            };

            this.HSV_RGB = function (h, s, v) {
                if (h === null) {
                    return [v, v, v];
                }
                const i = Math.floor(h),
                    f = i % 2 ? h - i : 1 - (h - i),
                    m = v * (1 - s),
                    n = v * (1 - s * f);
                switch (i) {
                    case 6:
                    case 0:
                        return [v, n, m];
                    case 1:
                        return [n, v, m];
                    case 2:
                        return [m, v, n];
                    case 3:
                        return [m, n, v];
                    case 4:
                        return [n, m, v];
                    case 5:
                        return [v, m, n];
                }
            };

            function removePicker() {
                delete colorDropper.picker.owner;
                colorDropper.picker.boxB.parentNode.removeChild(colorDropper.picker.boxB);
            }

            function drawPicker() {
                const touchMoveEventHandler = function (e) {
                    let event = {
                        'offsetX': e.touches[0].pageX - touchOffset.X,
                        'offsetY': e.touches[0].pageY - touchOffset.Y
                    };
                    if (holdPad || holdSld) {
                        holdPad && setPad(event);
                        holdSld && setSld(event);
                        dispatchImmediateChange();
                    }
                    e.stopPropagation();
                    e.preventDefault();
                },
                dims = getPickerDims(self),
                padImg = modeID ? 'color_picker_hv.png' : 'color_picker_hs.png';
                let i, seg, segSize;

                if (!colorDropper.picker) {
                    colorDropper.picker = {
                        box: document.createElement('div'),
                        boxB: document.createElement('div'),
                        pad: document.createElement('div'),
                        padB: document.createElement('div'),
                        padM: document.createElement('div'),
                        sld: document.createElement('div'),
                        sldB: document.createElement('div'),
                        sldM: document.createElement('div')
                    };
                    for (i = 0, segSize = 2; i < colorDropper.images.sld[1]; i += segSize) {
                        seg = document.createElement('div');
                        seg.style.height = segSize + 'px';
                        seg.style.fontSize = '1px';
                        seg.style.lineHeight = '0';
                        colorDropper.picker.sld.appendChild(seg);
                    }
                    colorDropper.picker.sldB.appendChild(colorDropper.picker.sld);
                    colorDropper.picker.box.appendChild(colorDropper.picker.sldB);
                    colorDropper.picker.box.appendChild(colorDropper.picker.sldM);
                    colorDropper.picker.padB.appendChild(colorDropper.picker.pad);
                    colorDropper.picker.box.appendChild(colorDropper.picker.padB);
                    colorDropper.picker.box.appendChild(colorDropper.picker.padM);
                    colorDropper.picker.boxB.appendChild(colorDropper.picker.box);
                }

                p = colorDropper.picker;
                p.box.onmouseup = p.box.onmouseout = function () {
                    target.focus();
                };
                p.box.onmousedown = function () {
                    abortBlur = true;
                };
                p.box.onmousemove = function (e) {
                    if (holdPad || holdSld) {
                        holdPad && setPad(e);
                        holdSld && setSld(e);
                        window.getSelection().empty();
                        dispatchImmediateChange();
                    }
                };

                if ('ontouchstart' in window) {
                    p.box.removeEventListener('touchmove', touchMoveEventHandler, false);
                    p.box.addEventListener('touchmove', touchMoveEventHandler, false);
                }
                p.padM.onmouseup = p.padM.onmouseout = function () {
                    if (holdPad) {
                        holdPad = false;
                        colorDropper.fireEvent(valueElement, 'change');
                    }
                };
                p.padM.onmousedown = function (e) {
                    switch (modeID) {
                        case 0:
                            if (self.hsv[2] === 0) {
                                self.fromHSV(null, null, 1.0);
                            }
                            break;
                        case 1:
                            if (self.hsv[1] === 0) {
                                self.fromHSV(null, 1.0, null);
                            }
                            break;
                    }
                    holdSld = false;
                    holdPad = true;
                    setPad(e);
                    dispatchImmediateChange();
                };

                if ('ontouchstart' in window) {
                    p.padM.addEventListener('touchstart', function (e) {
                        touchOffset = {'X': getOffsetParent(e.target).Left, 'Y': getOffsetParent(e.target).Top};
                        this.onmousedown({
                            'offsetX': e.touches[0].pageX - touchOffset.X,
                            'offsetY': e.touches[0].pageY - touchOffset.Y
                        });
                    });
                }
                p.sldM.onmouseup = p.sldM.onmouseout = function () {
                    if (holdSld) {
                        holdSld = false;
                        colorDropper.fireEvent(valueElement, 'change');
                    }
                };
                p.sldM.onmousedown = function (e) {
                    holdPad = false;
                    holdSld = true;
                    setSld(e);
                    dispatchImmediateChange();
                };
                if ('ontouchstart' in window) {
                    p.sldM.addEventListener('touchstart', function (e) {
                        touchOffset = {'X': getOffsetParent(e.target).Left, 'Y': getOffsetParent(e.target).Top};
                        this.onmousedown({
                            'offsetX': e.touches[0].pageX - touchOffset.X,
                            'offsetY': e.touches[0].pageY - touchOffset.Y
                        });
                    });
                }

                p.box.style.width = dims[0] + 'px';
                p.box.style.height = dims[1] + 'px';

                p.boxB.style.position = 'relative';
                p.boxB.style.clear = 'both';
                p.boxB.style.border = 'none';
                p.boxB.style.background = self.pickerFaceColor;

                p.pad.style.width = colorDropper.images.pad[0] + 'px';
                p.pad.style.height = colorDropper.images.pad[1] + 'px';

                p.padB.style.position = 'absolute';
                p.padB.style.left = self.pickerFace + 'px';
                p.padB.style.top = self.pickerFace + 'px';
                p.padB.style.border = self.pickerInset + 'px solid';
                p.padB.style.borderColor = self.pickerInsetColor;

                p.padM.style.position = 'absolute';
                p.padM.style.left = '0';
                p.padM.style.top = '0';
                p.padM.style.width = self.pickerFace + 2 * self.pickerInset + colorDropper.images.pad[0] + colorDropper.images.arrow[0] + 'px';
                p.padM.style.height = p.box.style.height;
                p.padM.style.cursor = 'crosshair';

                p.sld.style.overflow = 'hidden';
                p.sld.style.width = '13px';
                p.sld.style.height = colorDropper.images.sld[1] + 'px';

                p.sldB.style.position = 'absolute';
                p.sldB.style.right = self.pickerFace + 'px';
                p.sldB.style.top = self.pickerFace + 'px';
                p.sldB.style.border = self.pickerInset + 'px solid';
                p.sldB.style.borderColor = self.pickerInsetColor;

                p.sldM.style.position = 'absolute';
                p.sldM.style.right = '0';
                p.sldM.style.top = '0';
                p.sldM.style.width = 14 + colorDropper.images.arrow[0] + self.pickerFace + 2 * self.pickerInset + 'px';
                p.sldM.style.height = p.box.style.height;

                try {
                    p.sldM.style.cursor = 'pointer';
                } catch (e) {
                    p.sldM.style.cursor = 'hand';
                }

                p.padM.style.backgroundImage = 'url("' + self.iconDir + '/color_picker_cross.gif")';
                p.padM.style.backgroundRepeat = 'no-repeat';
                p.sldM.style.backgroundImage = 'url("' + self.iconDir + '/color_picker_arrow.gif")';
                p.sldM.style.backgroundRepeat = 'no-repeat';
                p.pad.style.backgroundImage = 'url("' + self.iconDir + '/' + padImg + '")';
                p.pad.style.backgroundRepeat = 'no-repeat';
                p.pad.style.backgroundPosition = '0 0';
                redrawPad();
                redrawSld();
                colorDropper.picker.owner = self;
                target.parentNode.parentNode.appendChild(p.boxB);
            }

            function getPickerDims(o) {
                return [2 * o.pickerInset + 2 * o.pickerFace + colorDropper.images.pad[0] +
                2 * o.pickerInset + 2 * colorDropper.images.arrow[0] + colorDropper.images.sld[0],
                    2 * o.pickerInset + 2 * o.pickerFace + colorDropper.images.pad[1]];
            }

            function redrawPad() {
                let yComponent, x, y, i = 0, rgb, s, c, f;
                const seg = colorDropper.picker.sld.children;

                switch (modeID) {
                    case 0:
                        yComponent = 1;
                        break;
                    case 1:
                        yComponent = 2;
                        break;
                }
                x = Math.round(self.hsv[0] / 6 * (colorDropper.images.pad[0] - 1));
                y = Math.round((1 - self.hsv[yComponent]) * (colorDropper.images.pad[1] - 1));
                colorDropper.picker.padM.style.backgroundPosition =
                    self.pickerFace + self.pickerInset + x - Math.floor(colorDropper.images.cross[0] / 2) + 'px ' +
                    (self.pickerFace + self.pickerInset + y - Math.floor(colorDropper.images.cross[1] / 2)) + 'px';

                switch (modeID) {
                    case 0:
                        rgb = self.HSV_RGB(self.hsv[0], self.hsv[1], 1);
                        if (window.File && window.FileReader) {
                            colorDropper.picker.sld.style.background = 'linear-gradient(rgb(' +
                                rgb[0] * (1 - i / seg.length) * 100 + '%,' +
                                rgb[1] * (1 - i / seg.length) * 100 + '%,' +
                                rgb[2] * (1 - i / seg.length) * 100 + '%), black)';
                        } else {
                            for (i = 0; i < seg.length; i += 1) {
                                seg[i].style.backgroundColor = 'rgb(' +
                                    rgb[0] * (1 - i / seg.length) * 100 + '%,' +
                                    rgb[1] * (1 - i / seg.length) * 100 + '%,' +
                                    rgb[2] * (1 - i / seg.length) * 100 + '%)';
                            }
                        }
                        break;
                    case 1:
                        c = [self.hsv[2], 0, 0];
                        i = Math.floor(self.hsv[0]);
                        f = i % 2 ? self.hsv[0] - i : 1 - (self.hsv[0] - i);
                        switch (i) {
                            case 6:
                            case 0:
                                rgb = [0, 1, 2];
                                break;
                            case 1:
                                rgb = [1, 0, 2];
                                break;
                            case 2:
                                rgb = [2, 0, 1];
                                break;
                            case 3:
                                rgb = [2, 1, 0];
                                break;
                            case 4:
                                rgb = [1, 2, 0];
                                break;
                            case 5:
                                rgb = [0, 2, 1];
                                break;
                        }

                        for (i = 0; i < seg.length; i += 1) {
                            s = 1 - 1 / (seg.length - 1) * i;
                            c[1] = c[0] * (1 - s * f);
                            c[2] = c[0] * (1 - s);
                            seg[i].style.backgroundColor = 'rgb(' +
                                c[rgb[0]] * 100 + '%,' +
                                c[rgb[1]] * 100 + '%,' +
                                c[rgb[2]] * 100 + '%)';
                        }
                        break;
                }
            }

            function getOffsetParent(el) {
                let parent = el.offsetParent, top = 0, left = 0;
                while (parent) {
                    top += parent.offsetTop;
                    left += parent.offsetLeft;
                    parent = parent.offsetParent;
                }
                return {Left: left, Top: top};
            }

            function redrawSld() {
                let yComponent, y;
                switch (modeID) {
                    case 0:
                        yComponent = 2;
                        break;
                    case 1:
                        yComponent = 1;
                        break;
                }
                y = Math.round((1 - self.hsv[yComponent]) * (colorDropper.images.sld[1] - 1));
                colorDropper.picker.sldM.style.backgroundPosition =
                    '0 ' + (self.pickerFace + self.pickerInset + y - Math.floor(colorDropper.images.arrow[1] / 2)) + 'px';
            }

            function isPickerOwner() {
                return colorDropper.picker && colorDropper.picker.owner === self;
            }

            function blurTarget() {
                if (valueElement === target) {
                    self.importColor();
                }
            }

            function blurValue() {
                if (valueElement !== target) {
                    self.importColor();
                }
            }

            function setPad(e) {
                const pos = colorDropper.getRelMousePos(e);
                let x = pos.x - self.pickerFace - self.pickerInset,
                    y = pos.y - self.pickerFace - self.pickerInset;
                switch (modeID) {
                    case 0:
                        self.fromHSV(x * (6 / (colorDropper.images.pad[0] - 1)), 1 - y / (colorDropper.images.pad[1] - 1), null, leaveSld);
                        break;
                    case 1:
                        self.fromHSV(x * (6 / (colorDropper.images.pad[0] - 1)), null, 1 - y / (colorDropper.images.pad[1] - 1), leaveSld);
                        break;
                }
            }

            function setSld(e) {
                const pos = colorDropper.getRelMousePos(e);
                let y = pos.y - self.pickerFace - self.pickerInset;
                switch (modeID) {
                    case 0:
                        self.fromHSV(null, null, 1 - y / (colorDropper.images.sld[1] - 1), leavePad);
                        break;
                    case 1:
                        self.fromHSV(null, 1 - y / (colorDropper.images.sld[1] - 1), null, leavePad);
                        break;
                }
            }

            function dispatchImmediateChange() {
                if (self.onImmediateChange) {
                    let callback;
                    if (typeof self.onImmediateChange === 'string') {
                        callback = new Function(self.onImmediateChange);
                    } else {
                        callback = self.onImmediateChange;
                    }
                    callback.call(self);
                }
            }

            if (valueElement) {
                colorDropper.addEvent(valueElement, 'keyup', updateFieldEventHandler);
                colorDropper.addEvent(valueElement, 'input', updateFieldEventHandler);
                colorDropper.addEvent(valueElement, 'blur', blurValue);
                valueElement.setAttribute('autocomplete', 'off');
            }

            this.importColor();
        }
    };
    GB.colorDropper = colorDropper.color;
})();

const TMPL = {
    container: `<template id="app-template">
      <link rel="stylesheet" type="text/css" id="ui-css">
      <main id="root" class="app">
        <div id="note-toolbar" class="toolbar" role="toolbar"></div>
        <div id="note-editarea" class="editarea">
          <iframe class="editarea-frame"></iframe>
          <div id="insert-paragraph-node" class="insert-paragraph-line d-none"></div>
        </div>
        <div id="note-statusbar" class="statusbar" role="status">
          <ul class="html-selector"></ul>
          <div class="editarea-resizer"></div>
        </div>
      </main>
      <dialog id="popover-modal" class="modal">
        <div class="modal-title-bar">
          <div class="modal-title">
            <div class="title"></div>
          </div>
          <div class="close">&nbsp;</div>
        </div>
        <div id="popover-modal-contents" class="modal-contents"></div>
      </dialog>
      <dialog id="popover-dialog" class="dialog">
        <div class="dialog-content">
          <form method="dialog">
            <div class="dialog-header">
              <div class="dialog-title"></div>
            </div>
            <div class="dialog-body"></div>
            <div class="dialog-footer">
              <button name="cancel" class="btn btn-light">취소</button>
              <button name="submit" class="btn btn-primary">확인</button>
            </div>
          </form>
        </div>
      </dialog>
      <div id="image-resizer" class="resizer">
        <div class="resizer-handle resizer-handle-top-left"></div>
        <div class="resizer-handle resizer-handle-top-right"></div>
        <div class="resizer-handle resizer-handle-bottom-left"></div>
        <div class="resizer-handle resizer-handle-bottom-right"></div>
      </div>
      <div id="image-popover" class="image-control-popover" popover="manual">
        <div class="image-popover-inner">
          <div class="btn-popover" data-cmd="left" data-tooltip="왼쪽 정렬"><span class="btn-align-left"></span></div>
          <div class="btn-popover" data-cmd="center" data-tooltip="가운데 정렬"><span class="btn-align-center"></span></div>
          <div class="btn-popover" data-cmd="right" data-tooltip="오른쪽 정렬"><span class="btn-align-right"></span></div>
<!--          <div class="btn-split"></div>-->
<!--          <div class="btn-popover" data-cmd="left-float" data-tooltip="왼쪽 정렬: 텍스트 랩핑"><span class="btn-align-left-float"></span></div>-->
<!--          <div class="btn-popover" data-cmd="right-float" data-tooltip="오른쪽 정렬: 텍스트 랩핑"><span class="btn-align-right-float"></span></div>-->
          <div class="btn-split"></div>
<!--          <div class="btn-popover" data-cmd="alt" data-tooltip="대체 텍스트"><span class="btn-alt"></span></div>-->
          <div class="btn-popover" data-cmd="figcaption" data-tooltip="캡션 넣기"><span class="btn-figcaption"></span></div>
          <div class="btn-popover" data-cmd="insert-paragraph-top" data-tooltip="위에 빈줄 삽입"><span class="btn-insert-paragraph-top"></span></div>
          <div class="btn-popover" data-cmd="insert-paragraph-bottom" data-tooltip="아래에 빈줄 삽입"><span class="btn-insert-paragraph-bottom"></span></div>
          <div class="btn-popover" data-cmd="reset" data-tooltip="원래대로"><span class="btn-reset"></span></div>
          <div class="btn-popover" data-cmd="remove" data-tooltip="삭제"><span class="btn-trash"></span></div>
          <div class="popover-arrow" data-popper-arrow></div>
        </div>
      </div>
    </template>`
};
